$(function() {
    window.addEventListener('touchstart', function onFirstTouch() {
        if(!window.localStorage.getItem("hidetouchmsg")){
            document.body.classList.add('user-is-touching');
                   
        }
        $("#topcontent").removeClass('enableHover'); 
        $("#klholder").css('display','none');   
        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
        if(typeof(Tipped)!=='undefined'){
            //console.log('hi');
            Tipped.remove('#chr h4');
            Tipped.remove("#chrkey li a");
            Tipped.remove(".cpanel button");
        }
    }, false);    

   

    if (typeof(mappage) !== "undefined") {
        //var t0 = performance.now();

$.fn.isInViewport = function() {
var elementTop = $(this).offset().top;
var elementBottom = elementTop + $(this).outerHeight();
var viewportTop = $(window).scrollTop();
var viewportBottom = viewportTop + $(window).height();


return elementBottom-75 > viewportTop && elementTop < viewportBottom && viewportTop > elementTop;
};

$(window).scroll(function(){
    function checkChromosome(c){
        if($("#p"+c).hasClass('cp-open') && $("#p"+c).isInViewport() && !expandedchr){

            //console.log(c+' is in the viewport and is open');
            //console.log($("#p"+c).offset().top);
            $("#p"+c).prev().addClass('expandedf');
            expandedchr = true;
        }
        else {
            $("#p"+c).prev().removeClass('expandedf');
        }
    }

    var expandedchr = false;
    for(c = 1; c < 23; c++){   
        checkChromosome(c);
    }
    checkChromosome('X');
   
 /* if(!$("body").hasClass('user-is-touching')){

    if($(window).scrollTop()<50){

    }
    if(!($("#mheader").isInViewport())){    
        $("body").addClass('pinned');
    }
    else {
        $("body").removeClass('pinned');

    }
  }*/

});


        $("#loadme").show();
        if(typeof(Tipped)!=='undefined'){
            Tipped.create('.cpanel button');
        }
        if (typeof(currentmap) === 'undefined') {
            currentmap = '';
        }
        var masseditmode = '<button class="openmem">Mass edit mode</button>';
        var prependstring = '<span class="chrmatchlabel"><label><input type="checkbox" checked="checked" />Show match names</label>'+masseditmode+'</span>';
        //$("#chr .cp").prepend(masseditmode);      
        $("#chr .cp").prepend(prependstring);
       if(!window.localStorage.getItem("hidetips") && typeof(showcase)==='undefined'){
            $('.feature-tips div').shuffle();
            $('.feature-tips').slick({speed:400});                
        }
        else {
            $('.tip-area').hide();
        }
        if (typeof(examplemap) !== "undefined") {


            dp = {map:{id:'dpexample',segs:
            examplechromomapper, 
            matches:examplematches, groups:examplechromogroups
            , index:[]}};
            chromomapper = dp.map.segs;
            chromogroups = dp.map.groups;

         
            //$("#stats").addClass('show');
            adjustChromosomeLengths();        
            calculatePaintedPercentage();
            $("#chr").addClass('gender-male');
            $("body").attr('data-mapgender','gender-male');

        } 
        else {
            if (typeof(chromomapper) === "undefined" || typeof(chromogroups) === "undefined") {
                // if nothing set or stored, initialise variables
                chromomapper = [];
                chromogroups = [];
            }
            getDataForMap();
            //console.log(chromogroups.length);
            if(chromogroups.length >30){
                $("#keyarea").addClass('gs');
                $(".fgc").css('display', 'block');
            }
        }
        setUpMBLines();
        setUpSlider();
        //var t0 = performance.now();
        if(chromomapper.length && typeof(chromomapper[0].id)==='undefined'){
//            var t1 = performance.now();
            assignIDs(); // put IDs in if needed/ todo - save it if needed
  //          console.log("assigning IDs took " + (t1 - t0) + " milliseconds.");
        }
//console.log($('*').length);

        // if there are segments, output the segments and groups
        if (chromomapper.length > 0 || chromogroups.length > 0) {           
            sortSegments();            
            if(chromomapper.length > 200){
               printAllMatchesByChromosome();
            }
            else {
                loadFixedSegments();
                for (var i in chromomapper) {
                    printMatch(i);
                }
                loadLocalSettings();  

            }
            drawKey();
        }
        else {
            $("#find-data-reminder").css('display','block');
        }


        $("#loadme").hide();

        if ($(window).width() < 667) {
            minimiseKey();
        }

        // if the map is untitled, prompt to fill in
        if ($("#mapName").text() == 'Untitled Map') {
            $('body').addClass('form-toggled');
            $("#mapmeta").show();
            $("#mapNameOverlay").focus();
        }

       initialiseSearch();
        //console.log(searchdata);

        $("#keyarea").draggable({
            handle: '.keyhandle',
           /* containment: 'window',*/
            stop: function(event, ui){
                $(this).css('bottom', 'auto');
            }
        });        

   // console.log('being called');
//var t1 = performance.now();
//console.log("Assembling this map took " + (t1 - t0) + " milliseconds.");
//console.log($('*').length);


    $("#keyarea").resizable({ containment: 'parent'});
    $("#edit-key").on('click', function(){
        $("#key-edit-instructions").slideToggle();
        //console.log($("#key-edit-instructions").innerHeight());
    });

  
    $("#report").on('click', '.fix-seg', function(){
       fixSeg($(this).attr('data-seg'));
    });
   
    window.addEventListener('resize', function(event) {
        setUpMBLines(true);
        setUpMBLinesDetail();
    }, true);

    $(".togglematches").on('click', function(){
        if($(this).prop('checked')){
            // checked - show names
            $(".chrcontainer").removeClass('showmatchnames').addClass('showmatchnames');
            adjustMatchNames('.groupdetailcontainer','#groupdetail');
        }
        else {
            $(".chrcontainer").removeClass('showmatchnames');
            
            // not checked - hide names
        }
        var thisid = $(this).attr('id');
        //console.log("input.togglematches:not('#'"+thisid"')");
        // not sure what this is and do I need it?
        var checkBoxes = $("input.togglematches:not('#"+thisid+"')");
        checkBoxes.prop("checked", !checkBoxes.prop("checked"));
    }
    );

    $("#alerts-page").on('click', '#overwrite-map', function(){
        //console.log('overwrite map');
        console.log(1);
        saveFieldLocally('lastsaved', 'force');
        writeDataToMap('all');
        $("#alerts-page button.close").click();
        // 'Overwrite' should do the 'save to server ' again, but pass a 'lastsaved' parameter of 'force' or something else non-numeric.

    });

    $("#alerts-page").on('click', '#revert-map', function(){
          window.localStorage.removeItem(currentmap+'cachedlastsaved');
          location.reload(true);
        //'Revert' should delete the lastsaved parameter and refresh the page (or just re-call the function).
    });

    $(".panel-body").on('click', '.undo-dupetool', function(){
          location.reload(true);
    }); 

    $(".panel-body").on('click', '.save-dupetool', function(){
        writeDataToMap('all');       
    });        



    $("#groupdetail").on('click', '.undo-move', function(){
        //console.log(' i got here');
        // switch back to the other group so the grab will work!
        var matchslug = $(this).attr('data-match');
        var oldgroup = $(this).attr('data-group');
        var currentgroup = $(this).attr('data-currentgroup');
        viewGroupDetail(currentgroup);

        // This was the hilarious bit I had to fight with!
        setTimeout(function(){
            switchmatchgroup(matchslug, currentgroup, oldgroup, true);
             setTimeout(function(){
                viewGroupDetail(oldgroup);
            },200);
            
          //  return false;
        },580);

        //setTimeout(function(){
           

       // },10);


    });

    var fffileInput = document.getElementById("importffcsv"),
    readFile = function () {
        var reader = new FileReader();
        reader.onload = function (e) {
            if (!e) {
                var data = reader.content;
            }
            else {
                var data = e.target.result;
            }
            var ancestral = false;
            if($("#import_ancestral").prop('checked')){
                ancestral = true;
            }
            //console.log(data);
            processFFCSV(data, fffileInput.files[0], ancestral);
        };
        reader.readAsText(fffileInput.files[0]);
        };


    $("#import-ff-file").on('click', function(e){
        e.preventDefault();        
        $("#ftdform .alert").css('display', 'none');        
        if(fffileInput.files.length > 0){
            $("#import-ff-file").text('Importing...');
            $("#import-ff-file").attr('disabled', 'disabled');
            $("#import-ff-file").addClass('loading');            
            readFile();
        }
        else {
            $("#ff-file-warning").show();
        }
    });    

    $(".clr-field").on('click', function(e){
        e.preventDefault();
        $(this).prev().val('');
    });
    
    $("#datareport").on('click', '#selectall', function(){
        $("td.chkcol input:visible").prop('checked', this.checked);
        if(this.checked){

        }
    });

    $(".mark-del").on('click', function(){        
        $("#datareport").addClass('cdeleting');
        $(".del-segs-area").addClass('started');
        var modalw = $(".filterblock").width();
        modalw = modalw -40;
        //$(".del-segs-area").css('width',modalw);
    });

    $("#report").on('click','.chkcol input', function(){
        var checkedItems = $(".chkcol input:checked");
        if(checkedItems.length>0){
            $(".del-segs-area").addClass('active').removeClass('started');
        }
        else {
            $(".del-segs-area").removeClass('active').addClass('started');        
        }
        //console.log(checkedItems.length);
    });
    $(".cdel-segs, .cdel-segs2").on('click', function(){ 
        cancelDeletion();
    });

    $(".cdel-tsegs").on('click', function(){ 
        $("#delete-tabulator-rows-confirm").css('display','none');
    });


    $(".key-help").on('click', function(){
        if(inMassEditMode()){
            cancelMassEditMode();
        }
        
        openHelp('key');
    });
    $(".del-segs").on('click', function(){ 
        //console.log('delete');
        var checkedItems = $("td.chkcol input:checked");
        $(".del-segs-area").addClass('confirm');

        $("#segs-confirm-delete").css('display', 'block');

        $("#sdno").text(checkedItems.length);
        if(checkedItems.length !=1){
            $("#sdnos").text('s');
        }
        else {
            $("#sdnos").text('');
        }
    });

    $("#confirm-info-read").on('click', function(){
        $(this).css('display', 'none');
    });

    $(".del-segs-confirm").on('click', function(){ 
        var segstodelete = [];
        $("input[name='sdel']:checked").each(function() {
            var mys = getIndexFromId(parseInt(this.value));

            segstodelete.push(mys);
            $(this).parent().parent().addClass('removesegment');
            //console.log($("strong[data-id=match"+mys+"]"));
            //console.log(mys);
            //console.log($("strong[data-id=match"+mys+"]").parent());
            $("strong[data-id=match"+mys+"]").parent().addClass('removesegment');
        });        
        // go through chromomapper in reverse and delete them
        //console.log(segstodelete);
     //console.log(segstodelete);
     //var t0 = performance.now();
     segstodelete.sort(function(a, b){return b-a});
     //console.log(segstodelete);
     //return false;
     for (var i in segstodelete){


        quickDeleteSegment(segstodelete[i]);

     }
   
       
        $(".del-segs-area").removeClass('active').addClass('started');    
        $(".del-segs-area").removeClass('confirm');
        //$("#datareport").removeClass('cdeleting');
        //console.log($(".removesegment"));
        setTimeout(function(){
           //console.log($(".removesegment").length);
           //$(".removesegment").addClass('pleasehelp');
           $(".removesegment").remove();
        },500);
        $("#segs-confirm-delete").css('display', 'none');
        //var t1 = performance.now();
        //console.log("Deleting these items took " + (t1 - t0) + " milliseconds.")   
       
        printMatches('all');
        writeDataToMap('matches'); 
        initialiseSearch();

       

        //console.log('deleted');
    });



    $("#chr").on("click", ".chrmatchlabel input", function(e) {
        // TODO - sort this out!
        //console.log();
        var checkBoxes = $(".chrmatchlabel input");
        if($(this).prop("checked")){
            // they are checking the box. 
            $("#chr").removeClass('hidematchnames');
            checkBoxes.prop("checked",true);
            // show match names
            // check all the boxes

        }
        else {
            // they are unchecking the box
            $("#chr").removeClass('hidematchnames').addClass('hidematchnames');
            checkBoxes.prop("checked",false);

        }
        //$("#chr").toggleClass('hidematchnames');
        //checkBoxes.prop("checked", !checkBoxes.prop("checked"));


        
    });
  

   

  $("#filterdata").on("keyup", function(e){
        var currentval = $("#filterdata").val();
         setTimeout(function() {    
            var currentval = $("#filterdata").val();           
            filterDataTable(currentval);
            }, 500);         
    });
  


    $("#filter-groups").on("keyup", function(e){
        filterGroupsByString();        
    });


    $("#groupdetail").on('click', '.load-mn', function(e){
       viewGroupDetail($(this).attr('data-group'),'',true);
    });

 $("#filtermatchlist").on("keyup", function(e){
        var currentval = $("#filtermatchlist").val();
         setTimeout(function() {    
            var currentval = $("#filtermatchlist").val();           
            filterMatchList(currentval, false, false);
            }, 500);         
    });
    $("#mThreshold").on("keyup", function(e){
     var currentval = $("#mThreshold").val();
         setTimeout(function() {    
            var currentval = $("#mThreshold").val();           
            filterMatchList(false, false, currentval);
            }, 500);      
    });

    $("#mSegments").on("keyup", function(e){
        var currentval = $("#mSegments").val();
         setTimeout(function() {    
            var currentval = $("#mSegments").val();           
            filterMatchList(false, currentval, false);
            }, 500);      
    });
    $("#filterdatagroup").on("keyup", function(e){
        if($("#matchdetailheader").css('display')=='block'){
            $(".mdoclose").trigger('click');
        }
        var currentval = $("#filterdatagroup").val();
         setTimeout(function() {    
            var currentval = $("#filterdatagroup").val();           
            filterGroup(currentval);
            }, 500);         
    });    



    $(".cancel-filter").on("click", function(e){
        $("#filterdata").val('');
        filterDataTable('');
    });



 $(".cancel-filter-group").on("click", function(e){
        $("#filterdatagroup").val('');
        filterGroup('');
    });    

 $(".cancel-filter-matchlist").on("click", function(e){
        $("#filtermatchlist").val('');
        filterMatchList('', false, false);
    }); 
    

   
    // INLINE EDITABLE ITEMS
    var data = {};
    data[site.csrf.keys.name] = site.csrf.name;
    data[site.csrf.keys.value] = site.csrf.value;
    $('#mapDesc').editable(function(value, settings) {
        data['mapDesc'] = value;
        if(value ==''){
         //   data['mapDesc'] = '~blank~';
        }        
        data['accessKey'] = accessKey;
        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + currentmap,
            data: data,
            success: function(result) {
                saveTimeStampLocally(true, result); // put true in
            },
            error: function(exception) {
                //console.log('exception'+JSON.stringify(exception));
            }
        });
        return (value);
    }, {
        type: 'textarea',
        onblur: 'submit',
        select: 'true',
        submit: 'Save'
    });
    $('#mapName').editable(function(value, settings) {
        //data[$(this).attr('id')] = value;
        //var myvalue = $('#mapName').text();
        //$('#mapName').text(myvalue);
        data['mapName'] = value.substring(0,191);

        data['accessKey'] = accessKey;
        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + currentmap,
            data: data,
            success: function(result) {
                // if successful, save the timestamp:
                //console.log('tsnote is '+tsnote)
                saveTimeStampLocally(true, result); // put true in

            },
            error: function(exception) {
                //console.log('exception'+JSON.stringify(exception));
            }
        });

        // now save to local storage
        // actually don't!

        //saveFieldLocally($(this).attr('id'), value);
        return (value);
    }, {
        onblur: 'submit',
        select: 'true',
        submit: 'Save'
    });


    $("#open-search").on('click', function(e) {
        e.preventDefault();
        closePopups();
        if($("#open-settings").hasClass('active')){
            toggleCpanelItem('settings', true);
        }
        else if($("#open-traits").hasClass('active')){
            toggleCpanelItem('traits', true);
        }        
        toggleCpanelItem('search');
        $("#searchentry").focus();      
    });

    $("#open-settings").on('click', function(e) {
       e.preventDefault();
        if($("#open-search").hasClass('active')){
            toggleCpanelItem('search', true);
        }
        else if($("#open-traits").hasClass('active')){
            toggleCpanelItem('traits', true);
        }         
        toggleCpanelItem('settings');
    });

    $("#wasopen-traits").on('click', function(){
        $("#traits-intro").css('display', 'block');
        $("#open-traits").css('display','none');

    });

    $("#open-traits").on('click', function(e) {
        e.preventDefault();
        closePopups();
        if($("#open-settings").hasClass('active')){
            toggleCpanelItem('settings', true);
        }
        else if($("#open-search").hasClass('active')){
            toggleCpanelItem('search', true);
        }        
        toggleCpanelItem('traits');
        //$("#searchentry").focus();      
    });
    $(".cp").on('click', '.cancelhilitematch', function(){
        closePopups();
        clearSearch();
    });
    $(".clears").on('click', function(){
        $("#searchentry").val('').focus();
        clearSearch();
    });
    //$('.editable').addEventListener('blur', handler, { once: true });
    $('#mapGender').editable(function(value, settings) {
        //data[$(this).attr('id')] = value;   
        data['mapGender'] = value;
        data['accessKey'] = accessKey;
        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + currentmap,
            data: data,
            success: function(result) {
                saveTimeStampLocally(true, result); // put true in
            },
            error: function(exception) {}
        });
        // now adjust the class 
        $("#chr").removeClass();
        $("#chr").addClass('gender-' + value.toLowerCase());
        $("body").attr('data-mapgender','gender-' + value.toLowerCase());
        
        // TODO - get selected in there.

        // now save to local storage
        //saveFieldLocally($(this).attr('id'), value);
        return (value);
    }, {
        data: " {'Unspecified':'Unspecified', 'Male':'Male','Female':'Female'}",
        type: 'select',
        onblur: 'submit',
        submit: 'Save'
    });

    $("#mapName").focus(function() {
        if ($("#mapName").text() == 'Untitled Map') {
            var $this = $(this);
            $this.select();

            // Work around Chrome's little problem
            $this.mouseup(function() {
                // Prevent further mouseup intervention
                $this.unbind("mouseup");
                return false;
            });
        }
    });




   

    if(typeof(mappage) !== 'undefined'){
        function addEvent(evnt, elem, func) {
           if (elem.addEventListener)  // W3C DOM
              elem.addEventListener(evnt,func,false);
           else if (elem.attachEvent) { // IE DOM
              elem.attachEvent("on"+evnt, func);
           }
           else { // No much to do
              elem[evnt] = func;
           }
        }
     //  fileInput.addEventListener('change', readFile);
     //addEvent('change', fileInput, readFile);
    }
    $(".reset-key").click(function(){
        $("#keyarea").removeAttr('style');
    });



   
/*
    var fileInput = document.getElementById("csv"),

        readFile = function () {
            var reader = new FileReader();
            reader.onload = function () {
                processCSV(reader.result);
            };
            // start reading the file. When it is done, calls the onload event defined above.
            reader.readAsBinaryString(fileInput.files[0]);
        };

    fileInput.addEventListener('change', readFile);
*/


  
    // CLICK EVENTS



  

    /* save-match-start */
    $(".save-match-start").click(function(e) {
        // save the title and gender and close the window.
       if($.trim($("#mapNameOverlay").val())==''){
            $("#mapNameOverlay").val('Untitled Map');
       }
        data['mapName'] = $("#mapNameOverlay").val();     
        data['mapGender'] = $("#mapGenderOverlay").val();
        data['accessKey'] = accessKey;

        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + currentmap,
            data: data,
            success: function(result) {
                saveTimeStampLocally(true, result); // put true in
            },
            error: function(exception) {
                //console.log('exception'+JSON.stringify(exception));
            }
        });


        $("#mapName").text($.sanitize($("#mapNameOverlay").val()));
        $("#mapGender").text($.sanitize($("#mapGenderOverlay").val()));

        // now save to local storage and screen
        //saveFieldLocally("mapName", $("#mapName").text());
        //saveFieldLocally("mapGender", $("#mapGender").text());

        if(data['mapGender']=='Male'){
            $("#chr").addClass('gender-male');
            $("body").attr('data-mapgender','gender-male');

        }
        // now close the window
        $("#mapmeta").hide();
        $('body').removeClass('form-toggled');

    });


    $("#dupe-groups-only").on('click', function(e){
        var newhref = $('#duplicate a.btn').attr('href').replace('/groups','');

        if($(this).prop('checked')){
            var newhref = $('#duplicate a.btn').attr('href')+'/groups';
        }

        $('#duplicate a.btn').attr('href',newhref);
    });


    // click on 'share'
    $(".open-share").on('click', function(e) {
        e.preventDefault();
        openShare();
    });

    $("#retrievemsg").on('click', '.no-retr', function(e) {
        e.preventDefault();
        $("#retrievemsg").css('display', 'none');
    });

    $("#retrievemsg").on('click', '.yes-retr', function(e) {
        e.preventDefault();
        retrieveMap();
    });    


    $(".open-duplicate").on('click', function(e) {
        e.preventDefault();
        closeOverlays();
        openDuplicate();
    });

    $(".open-tg").on('click', function(e) {
        e.preventDefault();
        closeOverlays();
        openTransformGroups(e.target.dataset.side);
    });

    $("#tgbtn").on('click', function(e){
        e.preventDefault();
        closeOverlays();
        setTimeout(function(){
            updateAllGroups($("#tgbtn").attr('data-side'));
            writeDataToMap();
            drawKey();
        },100)
    });

    $(".open-dupetool").on('click', function(e){
        e.preventDefault();
        openDupeTool();
    });

    $("#run-dupetool").on('click', function(e){
        e.preventDefault();
            $("#run-dupetool").text('Checking for duplicates...');
            $("#run-dupetool").addClass('loading'); 
        setTimeout(function(){
           runDupeTool();
         
        },90);
  
    });



    $(".mergegroup-choose").on('click', function(e) {
        $("#mergegroupname").text($("#detailgroupname").text());
        //$("#mergegroupid").html(options);

        var currentgroup = $("#editgroupbutton").attr('data-group');
        var options = getSortedGroupOptions('all', currentgroup, null, true);
        $(".mergegroup-choose").hide();
        $("#mergegroupid").empty();
        $("#mergegroupid").append(options);

        $(".merge-groups").show();
    });

    $(".mergegroup").on('click', function(e){
        $(".mergegroup").text('Merging...');
        $(".mergegroup").innerHeight();

        e.preventDefault();
       setTimeout(function(){
            if($("#mergegroupid").val()==''){
                //console.log('need to choose');
                $(".mergegroup").text('Merge');
                $(".mergegroup").innerHeight();                
            }
            else {
                var newgroup = $("#mergegroupid").find(':selected').val();
                mergeGroups($("#editgroupbutton").attr('data-group'),newgroup);            
            }
       },200);
       
    });

    $("#groupdetail").on('click', '.del-empty-group', function(e) {
        deleteGroup($(this).attr('data-group'), true);       

        // save this deletion
        writeDataToMap();
        drawKey();
        closeAndMark('groupdetail', 'deleted');
    });

    // click on 'add desc'
    $(".add-desc").on('click', function(e) {
        $("#mapDesc").show();
    });

    // click on 'minimise key'
    $("#minkey").on('click', function(e) {
        e.preventDefault();
        minimiseKey();
    });

    $("#switchmap").change(function() {
        if(this.value=='new'){
            window.open('/maps/new', "_self");
        }
        else if(this.value=='all'){
            window.open('/#maps', "_self");
        }           
        else{
            window.open('/map/' + this.value, "_self");
        }
    });

    $(".download-matches").on('click', function(event){
        var filename =  'DNA Painter Matches - '+ $("#mapName").text()+'.csv';

        var args = [$('#matchlisttable'), filename+'.csv'];

        exportTableToCSV.apply(this, args);


        /*
        var mydata = [];
        $("#matchlistpeople tr:visible").each(function(index){
            mydata.push($(this).text());
        });

        var dpMatches =  encodeURIComponent(mydata.join('\n'));
        if (window.navigator.msSaveBlob) {
            var blob = new Blob([decodeURIComponent(dpMatches)], {
                type: 'data:text/plain;charset=utf8'
            });


            window.navigator.msSaveBlob(blob, filename);

        }
        else {
             $(this)
            .attr({
                'download': filename,
                'href': 'data:text/plain;charset=utf-8,' + dpMatches,
                'target': '_blank'
            });
        }*/

       
    });
    // This must be a hyperlink
    $(".download-csv").on('click', function(event) {
        // CSV
        var filename =  'DNA Painter Export - '+ $("#mapName").text();
        var args = [$('#report'), filename+'.csv'];

        exportTableToCSV.apply(this, args);

        // If CSV, don't do event.preventDefault() or return false
        // We actually need this to be a typical hyperlink
    });

    $(".download-dpbackup").on('click', function(event) {

        // simply get the chromomapper and chromogroups variables and put them in a file to download.
        var mapName = $("#mapName").text();
        var mapGender = $("#mapGender").text();
        var mapDesc = $("#mapDesc").text();
        var dpData =  encodeURIComponent(mapName) + "\n" + encodeURIComponent(mapGender) + "\n" + encodeURIComponent(JSON.stringify(chromomapper)) + "\n" + encodeURIComponent(JSON.stringify(chromogroups)) + "\n" + encodeURIComponent(mapDesc);
        var filename = 'dnapainter_backup_'+url_slug(mapName)+'.txt';
        if (window.navigator.msSaveBlob) {
        var blob = new Blob([decodeURIComponent(dpData)], {
            type: 'data:text/plain;charset=utf8'
        });

        // Crashes in IE 10, IE 11 and Microsoft Edge
        // See MS Edge Issue #10396033
        // Hence, the deliberate 'false'
        // This is here just for completeness
        // Remove the 'false' at your own risk
        window.navigator.msSaveBlob(blob, filename);

            //navigator.msSaveBlob(dpData, filename);
        }
        else {
            $(this)
            .attr({
                'download': filename,
                'href': 'data:text/plain;charset=utf-8,'+dpData,
                'target': '_blank'
            });
        }
       

    });    
    $(".clear-storage").on('click', function(e){
        // clear local storage
        localStorage.clear();
        $("#cleared-flash").delay(500).fadeIn().delay(2500).fadeOut();

    });

    $(".restore-csv").on('click', function(e) {
        $("#restore").show();
    });


    $("#settingspanel, #searchpanel, .floater").on('click', "#view-report, .view-report", function(e) {
        //console.log(clickedElement.nodeName);
        e.preventDefault();
        closeOverlays();
        $("#loadme").show();
        setTimeout(function(){
            printAllSegmentData();
        },200);
    });

    $("#settingspanel, #searchpanel, .floater").on('click', "#view-report, .view-report-new", function(e) {
        //console.log(clickedElement.nodeName);
        e.preventDefault();
        closeOverlays();
        $("#loadme").show();
        setTimeout(function(){
            printInlineSegmentEditor();
        },200);
    });    

   $("#settingspanel, .floater").on('click', ".view-matchlist", function(e) {
        closeOverlays();
        viewAllMatchesReport();
        e.preventDefault();
    });

    
    $(".dpcancel").click(function(e) {
        e.preventDefault();        
        $(this).parent().hide();
    });

    // * glossary
    $('dd ul.collapse a').click(function(e) {
        window.open(this.href);
        e.preventDefault();
    });

 $('#matchdetail').on('click', '.add-segments', function(e) {
        // TODO if the match is in one group, include that group. Otherwise don't
        e.preventDefault();
        compareMatch($("#currentmatchdetail").attr('data-match'), $(this).attr('data-group'));
    });

   
    $(".tree").click(function() {
        return false;
    });
    // * click on coloured square to show and hide the group items
    $("#chrkey, #newmatchkey").on("click", "span", function(e) {
        e.preventDefault();
        toggleGroupVisibility($(this));
    });


    $("#compareform").on("click", ".savenew", function(e) {
        e.preventDefault();
        var emn = $.sanitize($("#emn").val());
        //var egr = $.sanitize($("#egr").val());

        var process = processMatchData($("#comparedata").val(), emn)
        if (process) {
            saveMatchForm();
        } else {
            var threshold = $.sanitize($("#threshold").val());
            $("#overthreshold").text(threshold);
            $("#overlay-confirm-none").show();
        }
    });
    // * click on 'save' button for new match and bring up the form
    $("#newmatchkey, #overlay-confirm").on("click", ".savenew", function(e) {
        e.preventDefault();
        //collapseAllChroms();
        // TODO - possibly nicer not to collapse them all at this point but to wait until match is saved.
        saveMatchForm();
    });

    // * click on a chromosome number
    /*
    $("#chr > h4").click(function() {
        var chromofocus = $(this).text();
        closeOverlays();
        viewChromosomeDetail(chromofocus);
    });*/

    $("#chr > h4").click(function() {
       // $("#chr > h4").removeClass('expanded');

       // new proposal:
       // if this hasClass expanded, collapseChromosome($(this))
       // else expandChromosome(this)        
        closePopups();
        if($(this).hasClass('expanded')){
            collapseChromosome($(this));
            //hideMeMBox();

            //console.log('show show/hide')
        }
        else{
            expandChromosome($(this));
            if(inMassEditMode()){
                // get selected segments
                
                initialiseMassEditMode(true);
                // re-select selected segments



                //showMeMBox();
                //$(".cp-open > div").selectable( "enable" );
                //console.log($(".cp-open > div").selectable( "instance" ));
            }
            //showMeMBox();
            //clearSearch(); possibly restore this - let's see...
        }
        // if no h4s are expanded, hide the show/hide
      
        //closeOverlays();
        //viewChromosomeDetail(chromofocus);
    });
    $(".cp, .floater, #keylower").on('click', '.openmem', function(){
        showMeMBox();
        $("[name='mem_status']").bootstrapSwitch({
            onText: 'On',
            offText: 'Off',
            onSwitchChange: function(event, state) {
                if (state === true) {
                    initialiseMassEditMode();
                    $("#membox").removeClass('memactive').addClass('memactive');
                    $("#memtext").css('display','block');
                    //console.log('on')

                } else {      
                    cancelMassEditMode(true);
                    $("#membox").removeClass('memactive');
                    $("#memcounter, #memtext").css('display','none');
                }               
            }
        });

    });
    $(".groupdetailcontainer, .matchdetailcontainer").on("click", ".chrdetailchromosome > h4", function(e) {
        var chromofocus = $(this).text();
        closeOverlays();
        viewChromosomeDetail(chromofocus);
    });
  

    // * click on a group name or other link to open a group
    $("#chrkey, .chr-detail-key").on("click", "a", function(e) {
        e.preventDefault();
        if(inMassEditMode()){
            cancelMassEditMode();
        }
       
       // $("body").addClass('body-loading');
        $("#load-group").css('display', 'block');
        //var fun = $("#load-group").offset();
        //document.getElementsByTagName('body')[0].focus();
       var detailgroup = $(this).attr('data-group');

        //<div class="lflash" id="loahjhdme" style="/* display: none; */">Loading...</div>
        //$(".container-wide").prepend(loader);
       loadGroupOverlay(e, detailgroup);
    });

    $(".panel-body .dpclose").on("click", function(e){
        $(this).parent().hide();
        if(inMassEditMode()){
            //console.log('in mass edit mode');
            cancelMassEditMode();
        }
        if($(this).parent().attr('id')=='traits-intro'){
            $("#open-traits").css('display','inline-block');
            saveFieldLocally('closetraits',1);
        }       
    });


    $("#traitspanel .dpclose").on("click", function(e){
        toggleCpanelItem('traits');
    });

    $("#searchpanel .dpclose").on("click", function(e){
        toggleCpanelItem('search');
        clearSearch();
    });

    $("#settingspanel .dpclose").on("click", function(e){
        toggleCpanelItem('settings');
    });    

    $(".panel-body .merge-cancel").on("click", function(e){
        $(this).parent().hide();
        $(".mergegroup-choose").show();
    });    
    $(".floater, .dpform, #import-confirm-some").on("click", '.open-group', function(e){
        
        e.preventDefault(); 
        closeOverlays();        

        viewGroupDetail($(this).attr('data-group'), $(this).attr('data-match'));
    });
    $(".cp, .chrcontainer").on("click", "a.entire-group", function(e) {
            e.preventDefault();
            closeOverlays();            
            var detailgroup = $(this).attr('data-group');
            var matchh = $(this).attr('data-match');
            viewGroupDetail(detailgroup, matchh);
    });

    // * click on conditional items within new group form
    $("#oldgroup").click(function() {
        $(".newgroupfields").hide();
        $(".oldgroupfields").show();
        $("#gnewgroupname").hide();
        $("#existinggroup").show();
    });
    $("#newgroup").click(function() {
        $(".oldgroupfields").hide();
        $(".newgroupfields").show();
        $("#existinggroup").hide();
        $("#gnewgroupname").show();
    });
    $("#knownancestor").click(function() {
        setActiveLabel($(this));
        $(".groupfields").hide();
        $("#anewgroupname").show();

        $(".ancestorfields").show();
        //$("#bothoption").hide();
        // if new group is checked, show newgroup fields. Otherwise hide them.
        if ($("#newancestor").prop('checked')) {
            $("#existingancestor").hide();
            $("#anewgroupname").show();
            $(".newgroupfields").show();
        } else {
            $("#anewgroupname").hide();
            $("#existingancestor").show();
            $(".newgroupfields").hide();
        }


    });
    $("#unknownancestor").click(function() {
        setActiveLabel($(this));
        $(".ancestorfields").hide();
        var evv = $("#existingancestor").val();
        if(evv!=''){
            $("#oldgroup").trigger('click');
            $("#existinggroup option[value="+evv+"]").attr('selected', true);
        }
        else if($("#anewgroupname").val()!=''){
            $("#newgroup").trigger('click');
            $("#gnewgroupname").val($("#anewgroupname").val());
        }
        $(".groupfields").show();
        $("#gnewgroupname").show();
        setupCertainty(3, "newmatchCertainty");

        // $("#bothoption").show();
        // if new group is checked, show newgroup fields. Otherwise hide them.
        if ($("#newgroup").prop('checked')) {
            $(".oldgroupfields").hide();
            $(".newgroupfields").show();
            $("#existinggroup").hide();
            $("#gnewgroupname").show();
        } else {
            $(".newgroupfields").hide();
            $(".oldgroupfields").show();
            $("#gnewgroupname").hide();
            $("#existinggroup").show();
        }
    });

    $("#oldancestor").click(function() {
        $("#anewgroupname").hide();
        $("#existingancestor").show();
        $(".newgroupfields").hide();

    });
    $("#newancestor").click(function() {
        $("#existingancestor").hide();
        $("#anewgroupname").show();
        $(".newgroupfields").show();
    });




 


    $(".open-import").on('click', function(e) {
        e.preventDefault();
        openImport();
        if($("#importcsv").length>0){
            resetFormElement($("#importcsv"));
        }
    }); 

    $(".tip-area .dpclose").on("click", function(e) {
        $(".tip-area").hide();
        if(supportsLocalStorage()){
            window.localStorage.setItem('hidetips', 1);
        }
    });    
    $(".save-map-to-account").on("click", function(e) {
        // ajax update
        // use id and key

        data['mapID'] = $(this).attr('data-id');
        if (typeof(accessKey) !== "undefined") {
            data['accessKey'] = accessKey;
        } else {
            data['accessKey'] = $(this).attr('data-key');
        }
        data['claim'] = 1;
        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + data['mapID'],
            data: data,
            dataType: "json",
            success: function(result) {},
            error: function(exception) {}
        });
        // update button
        //$(this).parent().find('p').text("Saved");
        //$(this).hide();
        $(this).parent().hide();
        // now add to list. 
        $("#claimedlink").attr('href', '/map/' + $(this).attr('data-id'));
        $("#claimed").show();
    });

    // * click help icon
    $(".start-tour").on("click", function(e) {
        e.preventDefault();
        toggleCpanelItem('settings');
        tour.start(true);
        tour.goTo(0);

    });

   

    // * click the group confidence checkbox
    $("#groupConfidence").click(function() {
        $("#groupCertaintySlider").toggleClass('active');
    });

 // * click the group confidence checkbox
    $("#mmatchConfidence").click(function() {
        $("#matchCertaintySlider").toggleClass('active');
    });    
    $("#mmatchNotes").click(function() {
        $("#matchNotesholder").toggle();
    });    


    // * click an edit link within the key (edit group)
    // to be adjusted - you will now do this via the group detail once I have it working.
    $("#groupdetail").on("click", ".editgroup", function(e) {
        e.preventDefault();
        if(inMassEditMode()){
            cancelMassEditMode();
        }        
        var thisgroup = $(this).attr('data-group');
        editGroup(thisgroup);
      
    });
    $("#matchdetail").on("click", ".editmatch", function(e) {
        e.preventDefault();
        if(inMassEditMode()){
            cancelMassEditMode();
        }        
        var thismatch = $(this).attr('data-match');
        editMatch(thismatch, 'opennotes');
      
    });




    // * click on an existing match's edit button
    $(".cp, .groupdetailcontainer, .matchdetailcontainer").on("click", "strong.match .edit", function(e) {
        e.preventDefault();
        var editsegment = $(this).attr('data-match');
        editSegment(editsegment);

    });


    $(".cp, .groupdetailcontainer, .matchdetailcontainer").on("mouseenter mouseleave", "strong.match, strong.trait", function(e) {
        handleCutoffs($(this));
    });    

 // * hover on an existing match to view details in a popup
    $(".cp").on("mouseenter", "strong.match", function(e) {
        if(!$(this).parent().hasClass('clone')){
            var context = '';
            if($("#chromodetail").hasClass('active')){
                context = '#chr-detail';
            }            
            //setTimeout(function(){
                var thisid = ($(this).attr('data-id').replace('match',''));
                showSegSummary(thisid, context);            
            //},50);
        }
    });
    $(".groupdetailcontainer, .matchdetailcontainer").on("mouseenter", "strong.match", function(e) {
 //       console.log('hover');
        if(!$(this).parent().hasClass('clone')){
            showSegSummary($(this).attr('data-id').replace('match',''), '.chrdetailchromosome');
        }
    });    

    $(".cp, #chr-detail, .groupdetailcontainer, .matchdetailcontainer").on("mouseleave", "strong.match", function(e) {
            removeSegSummary($(this).attr('data-id').replace('match',''));
    });  
      $(".edit-matchdetail").on("click", function(e) {
            //closeOverlays();
            console.log('dude');
            // new plan
            // close the match detail overlay and open a new one with the form in it.
            if(inMassEditMode()){
                cancelMassEditMode();
            }  
            
            $("#matchdetail").hide();
            if($(this).attr('data-matchslug')){
                var thismatch = $(this).attr('data-matchslug');
            }
            else {
                var thismatch = $("#currentmatchdetail").attr('data-match');
            }
            editMatch(thismatch);
            //var thismname = $("#currentmatchname > strong").text();
           
            // hide groupdetail, show groupdetailform
            //$("#matchdetailformholder").hide();
           
           // $("#matchdetailform").show();

        });
            $(".cp, #chr-detail, .groupdetailcontainer, .matchdetailcontainer").on("click", "strong.match .edit-matchdetail", function(e) {
            // new plan
            // close the match detail overlay and open a new one with the form in it.
            closeOverlays();
            console.log('sweet');

            if($(this).attr('data-matchslug')){
                var thismatch = $(this).attr('data-matchslug');
            }
            else {
                var thismatch = $("#currentmatchdetail").attr('data-match');
            }
            if(thismatch){
            //console.log(thismatch);
                viewMatchDetail(thismatch);
                $("#matchdetail").hide().removeClass('active');

                editMatch(thismatch);

            }

            //var thismname = $("#currentmatchname > strong").text();
           
            // hide groupdetail, show groupdetailform
            //$("#matchdetailformholder").hide();
           
           // $("#matchdetailform").show();

        });      



   /* $(".cp, .groupdetailcontainer, .matchdetailcontainer").on("click", "span.swr", function(e) {
        openSegPopup($(this).parent(), e);
    });*/

    // * click on a fixed segment view details in a popup
    $(".cp").on("click", "strong.fixed", function(e) {
        closePopups();
        if (!$(e.target).is('.dpclose')) {
            $(this).addClass('popped');
            var matchnumber = $(this).attr('data-id').replace('fmatch', '');
            var thismatch = fixedsegments[matchnumber];
            var groupnotes = fixedgroups[thismatch.group].notes;
            $(this).append("<div class='popup'><span class='thischr'>" + thismatch.chromosome + "</span>" + numberWithCommas(thismatch.start) + " - " + numberWithCommas(thismatch.end) + numberDisplay(thismatch.cM, thismatch.SNPs) + "<p>" + groupnotes + "</p><a href='#' class='dpclose'>x</a></div>");
        }
    });


    $(".cp").on("click", "strong.trait", function(e) {
        if((e.target).nodeName !='LI'){

            closePopups();
            $("h6.olheading").css('display','none');        
            if (!$(e.target).is('.dpclose')) {
                $(this).addClass('popped');
                var traitnumber = $(this).attr('data-id').replace('tr', '');
                var thistrait = traits[traitnumber];
                var groupnotes = thistrait.notes;
                var traitdata = $.map([traits[traitnumber]], function(n,i){
                    return [[ n.chromosome, n.start, n.end, n.cM, '' ]];
                });
                //console.log(traitdata);
                var ol = getOverlappingSegments(traitdata[0], 'both', 1000);
                var distinctgrps = [];
                for (var i in ol){
                    ol[i].group = parseInt(ol[i].group);
                    // Possible todo: check group has ancestor=1
                    if($.inArray(ol[i].group,distinctgrps)==-1){
                        distinctgrps.push(ol[i].group);
                    }
                }
                //var distinctgrps = ol.filter(function(group, i, ar) {
                //return ar.indexOf(group) === i;
                //});

                var olstring ='';
                for(var i in distinctgrps){  
                    var thisind = distinctgrps[i];
                    olstring += '<li data-id="'+thisind+'">'+chromogroups[thisind].name+'</li>';
                }
                if(olstring!=''){            
                    //$(".olheading").css('display','block');
                    olstring = "<h6 class='olheading'>Overlapping Groups</h6><ul>"+olstring+"</ul>";
                }
                var tlinkstring = '';
                if(thistrait.marker !='' && typeof(thistrait.markerlink)!=='undefined' && thistrait.markerlink !=''){
                    tlinkstring = "<h6 class='olheading'>Marker</h6><ul><li><a target='_blank' href='"+thistrait.markerlink +"'>"+thistrait.marker+"</a></li></ul>";
                }
                var frstring = '';
                if(typeof(thistrait.furtherreading)!=='undefined' && thistrait.furtherreading !=''){
                    frstring = "<ul><li><a target='_blank' href='"+thistrait.furtherreading +"'>Further reading</a></li></ul>";
                }
                $(this).append("<div class='popup'><h5 class='trname'>"+ thistrait.genename + ": " +thistrait.name + "</h5><span class='thischr'>" + thistrait.chromosome + "</span>" + numberWithCommas(thistrait.start) + " - " + numberWithCommas(thistrait.end) + numberDisplay(thistrait.cM, thistrait.SNPs) + "<p>" + groupnotes + "</p>"+olstring+tlinkstring+frstring+"<a href='#' class='dpclose'>x</a></div>");
            }
        }
        else if((e.target).nodeName =='LI'){
            viewGroupDetail($(e.target).attr('data-id'));
            //console.log($(e.target).attr('data-id'));
        }
    });
 

    $(".cp, .groupdetailcontainer, #report, .matchdetailcontainer").on("click", ".hilitematch", function(e) {
        e.preventDefault();
        var thismatch = $(this).attr('data-match');
            closeOverlays();
            highlightMatch(thismatch);

        setTimeout(function(){
                closePopups();

            },100);
    });

    // * click on a match name in a popup 
    $(".cp, .groupdetailcontainer, #report, .matchdetailcontainer").on("click", ".matchname", function(e) {
        // open the group with the match highlighted 
        // data-group, data-matchslug
        e.preventDefault();
        resetModals();
        closeOverlays();
        var returnto = false;
        if($(this).prop('tagName')=='TD'){
            returnto = 'asd';
        }
        //closePopups();     
        //var currentmatch = $(this).text().replace('VIEW MATCH','');
        var currentmatch = $(this).attr('data-matchslug');

        viewMatchDetail(currentmatch,returnto);
    });
    $("#groupdetail, #matchdetail, #match-confirm, #matchlist").on("click", ".view-match", function(e) {
        // open the group with the match highlighted 
        // data-group, data-matchslug
        e.preventDefault();
        //console.log('dddd');
        closeOverlays();        
        var currentmatch = $(this).attr('data-match');
        var returnto = false;
        if($(this).attr('data-return')){
            returnto = $(this).attr('data-return');
        }
        viewMatchDetail(currentmatch, returnto);
          $('#modal').animate({
                scrollTop: (20)
            }, 500);

    });

 
    // * click on a notes field in the report
  ;


    $(".dpform").on("click", ".editmatchfromsegment", function(e) {
        $("#matchform").hide();
        var thematch = $(this).find('span').text();
        viewMatchDetail(thematch);
        editMatch(thematch);
    });  

    $(".dpform").on("click", ".viewmatchfromsegment", function(e) {
        $("#matchform").hide();
        var thematch = $(this).find('span').text();
        viewMatchDetail(thematch);
    });     

    $(".dpform").on("click", "#editseggroup", function(e) {
        $("#matchform").hide(); 
        editGroup($(this).attr('data-group'));

    });  

    // * refresh stats
    $(".refresh-stats").on("click", function(){
      calculatePaintedPercentage();  
    });
    // * click on a new match
    $(".cp").on("click", "strong.gnewmatch", function(e) {
        closePopups();
        if (!$(e.target).is('.dpclose')) {
            $(this).addClass('popped');
            var matchnumber = $(this).attr('data-id').replace('newmatch', '');            
            //var thismatch = newmatches[matchnumber];
//            var newmatchelement = newmatches[matchnumber].split("\t");
            var newmatchelement = newmatcharray[matchnumber];

            $(this).append("<div class='popup'><span class='thischr'>" + newmatchelement[0] + "</span>" + numberWithCommas(newmatchelement[1]) + " - " + numberWithCommas(newmatchelement[2]) + numberDisplay(newmatchelement[3], newmatchelement[4]) + "<a href='#' class='dpclose'>x</a></div>");

        }
    });
/*
    $("#modal-inner").on("click", function(e){
        if(typeof(e.target.id)!=='undefined'){
            var myforms = $(".dpform");
            var formactive = false;
            myforms.each(function(){
                //console.log($(this));
                if($(this).css('display')=='block'){
                    formactive = true;
                }
            });
            if(e.target.id=='modal-inner' && !formactive){
                $(".floater, .dpform").hide().removeClass('active');
                $('body').removeClass('form-toggled');                                
            }
        }
    });
*/
    // * click close button
    $(".cp, .dpform, .floater").on("click", ".dpclose", function(e) {
        e.preventDefault();
        if(inMassEditMode()){
            cancelMassEditMode();
        }   
        // if this doesn't parent '.popup'
        if (!$(this).parent().hasClass('popup')) {
          //  console.log('here');
            // figure out if there's a place to go back to
            if($("#newmatchform").css('display')=='block'){
                clearNewMatch();
            }
            resetModals();
          
            $('body').removeClass('form-toggled');
            $("#chromodetail div.cp").attr('id', 'p0');
            $(".floater").hide();
            if($("#returnToChrom").val()==1 && $("#matchform").css('display')=='block'){


                viewChromosomeDetail($("#chromosome").val());
            }  
            else if(
                $("#returnToGroup").val()==1 && $("#matchform").css('display')=='block'){
                viewGroupDetail($("#chromogroupfield").val());
            } 
            else if($("#groupform").css('display')=='block'){
                viewGroupDetail($("#groupArrayPosition").val());                
            }
            else if($("#returnToMatch").val()==1 && $("#matchform").css('display')=='block'){
                viewMatchDetail($("#match").val());                

            }

        }
        closePopups();
        resetPoppedItem($(this).parent());
        if($(this).parent().attr('id')=='datareport'){
            cancelDeletion();
        }
        if($(this).parent().attr('id')=='newreport'){
            printMatches('all');
            writeDataToMap('all');
            initialiseSearch();
        }             
        $(this).parent().hide();
    });

    // * click on clear button
    $(".clear-data").on("click", function(e) {
        e.preventDefault();
        // bring up 'are you sure' confirmation
        $(this).hide();
        $("#confirm-clear-area").show();
    });

    // * click on cancel clear button
    $(".cancel-clear").on("click", function(e) {
        e.preventDefault();
        // bring up 'are you sure' confirmation
        $("#confirm-clear-area").hide();
        $(".clear-data").show();
    });

    // * click on confirm clear button
    $(".confirm-clear").on("click", function(e) {
        e.preventDefault();
        clearSession();
        // bring up 'are you sure' confirmation

        $("#confirm-clear-area").hide();
    });

    // * click on a match segment's delete button
    $(".del-match").on("click", function(e) {
        e.preventDefault();
        $(".del-match-confirm").text('Yes, Delete permanently');
        // bring up 'are you sure' confirmation
        $("#confirm-delete-match").show();
    });

    $(".copy-segment").on("click", function(e) {
        e.preventDefault();
        $("#confirm-copy-match").show();

    });
    $(".copy-segment-confirm").on("click", function(e) {
        e.preventDefault();
        var newseg = copySegment($("#arrayPosition").val());
        // then open the form again for this new segment.
        setTimeout(function() {
            editSegment(newseg);
        }, 500);    
    });

    // * click on a match's delete button
    $(".del-matchdetail").on("click", function(e) {
        e.preventDefault();
        // bring up 'are you sure' confirmation
        $("#confirm-delete-matchdetail").show();
    });    


    $(".dpprint").on("click", function(e) {
        e.preventDefault();
        print();
    });

    // * click on a group's delete button
    $(".del-group").on("click", function(e) {
        $(".del-group-confirm").text('Yes, Delete permanently');
        
        e.preventDefault();
        // bring up 'are you sure' confirmation
        $("#confirm-delete-group").show();
    });

    // * click on a ethnicity groups delete button
    $(".delete-ethgroups").on("click", function(e) {
        e.preventDefault();
        // bring up 'are you sure' confirmation
        $("#confirm-delete-ethgroups").show();
    });

    // * click on a segment's confirm delete button
    $(".del-ethgroups-confirm").on("click", function(e) {
        e.preventDefault();
        // go through each group.
        // if it has spec and spec is eth, delete it            
            var i = chromogroups.length;            
            while (i--) {
                if(typeof(chromogroups[i].spec) !=='undefined' && chromogroups[i].spec=='eth'){
                    //console.log('deleting '+chromogroups[i].name);
                    deleteGroup(i);
                }
            }
        
        // leaving like this for now as there could be lots of groups
        printMatches('all');
        drawKey();
        closeAndMark('deleted');
        writeDataToMap();

    });


    // * click on a segment's confirm delete button
    $(".del-match-confirm").on("click", function(e) {
        $(this).text('Deleting...');
        e.preventDefault();
        setTimeout(function(){
            deleteSegment($("#arrayPosition").val());
            initialiseSearch();
            adjustMatchNames("#chr");            
        },50);

        // remove this item from chromomapper       

    });

  // * click on a match's confirm delete button
    $(".del-matchdetail-confirm").on("click", function(e) {
        e.preventDefault();

        // get all the segments

        // TODO - this should now delete ALL segments with this match, regardless of the group.

        var thismatch = $("#currentmatchdetail").attr('data-match');
        console.log('deleting '+thismatch);
        var todelete = (getMatchSegments(thismatch, "all", "#matchdetail"));
        //console.log(todelete)
        // remove these items from chromomapper
        var prevtotal = chromomapper.length;
        $(todelete).each(function(index){
            var thissegment = todelete[index];
            chromomapper[thissegment].delete = 1;
            // OK I can't delete them one by one because this obviously changes the index!
            // That was why it was working for one but not for loads!
            // HURRAH!
            // proposed solution:
             // loop through them and add a property delete
             // loop again and delete these.
          
            //console.log(chromomapper[thissegment]);
        });
           
            var i = chromomapper.length;
            while (i--) {
        //if(typeof(editgroup.ancestor)!== false){
        //if(editgroup.hasOwnProperty(ancestor)){
                //console.log(chromomapper[i].delete);
                if(typeof(chromomapper[i].delete) !== 'undefined'){
              //  if(chromomapper[i].hasOwnProperty('delete')){
                    chromomapper.splice(i, 1); // delete and reset array
                    removeSegment(i);
                }               
            }
        // remove the match itself:
        // thismatch
        var matchindex = findIndexOfItemWithAttr(dp.map.matches, 'id',thismatch);
        dp.map.matches.splice(matchindex,1);

        // save this deletion
        writeDataToMap('matches'); // comment this back in!
        var startfromvalue = Math.min.apply(null, todelete);
        // all segments with an index equal to or higher than this will need to be removed and redrawn
        // at this point we'll need to redraw everything.
        // TODO - get highest index value and pass it to printMatches
        //printMatches('all');
        //console.log(startfromvalue);
        // New: if you pass a start from value to printmatches, it uses that.
        if(startfromvalue <= chromomapper.length){
            printMatches('all','', startfromvalue, prevtotal);
        }
        closeAndMark('matchform', 'deleted');
        calculatePaintedPercentage();
        // need to do search index
        initialiseSearch();
        setTimeout(function(){
            adjustMatchNames("#chr");
        },50);

    // should just close the overlay with deleted flag
       // setTimeout(function(){
       //      viewGroupDetail(thisgroup);
       // },350);
       

        //console.log(chromomapper);
    });



    // * click on a group's confirm delete button
    $(".del-group-confirm").on("click", function(e) {
        e.preventDefault();
        $(this).text('Deleting...');
        setTimeout(function(){
            var deletinggroup = parseInt($("#groupArrayPosition").val()); // working
            // deleteGroup now returns the lowest index segment in the group
            var endAt = chromomapper.length;
            var startAt = deleteGroup(deletinggroup, true);
            // save this deletion
            writeDataToMap();

            //removeMatches(deletinggroup);
            // print all matches starting from that one (this function removes them too)
            // OK but this doesn't work because the segments in the group have already been removed from chromomapper.
            printMatches('all', '', startAt, endAt);
            drawKey();
            closeAndMark('groupform', 'deleted');
            initialiseSearch();
            calculatePaintedPercentage();
        },100);
       
    });

    $("#cmsliderLowerBound").on('change', function(){
        if(!isNaN($("#cmsliderLowerBound").val())){
            if($("#cmsliderLowerBound").val()<0){
                $("#cmsliderLowerBound").val(0);
            }
            if($("#cmsliderLowerBound").val()>279){
                $("#cmsliderLowerBound").val(279);
            }            
            $("#cmDisplayThreshold").attr('min', $("#cmsliderLowerBound").val());
            if(parseInt($("#cmDisplayThreshold").attr('max'))<=parseInt($("#cmsliderLowerBound").val())){
                $("#cmDisplayThreshold").attr('max', parseInt($("#cmsliderLowerBound").val())+1);
                $("#cmsliderUpperBound").val(parseInt($("#cmsliderLowerBound").val())+1);               
            }            
            saveBoundsLocally();           
        }
    });
    
    $("#cmsliderUpperBound").on('change', function(){
        if(!isNaN($("#cmsliderUpperBound").val())){
            if($("#cmsliderUpperBound").val()<1){
                $("#cmsliderUpperBound").val(1);
            }
            if($("#cmsliderUpperBound").val()>280){
                $("#cmsliderUpperBound").val(280);
            } 
            $("#cmDisplayThreshold").attr('max', $("#cmsliderUpperBound").val());
            if(parseInt($("#cmDisplayThreshold").attr('min'))>=parseInt($("#cmsliderUpperBound").val())){
                $("#cmDisplayThreshold").attr('min', parseInt($("#cmsliderUpperBound").val())-1);
                $("#cmsliderLowerBound").val(parseInt($("#cmsliderUpperBound").val())-1);
            }  
            saveBoundsLocally();          
        }
    });


    // * save a match
    // SOME Time change the name of this to segment - confusing!
    $(".save-match").on("click", function(e) {
        e.preventDefault();
        $(".dpform .alert").hide();

        // add validation
        var savingmatch = $("#arrayPosition").val();
        var segmentgroup = $("#chromogroupfield").find(':selected').val();
        //console.log(segmentgroup);
        var currentgroup = $("#currentGroup").val();
        var segmentchromosome= $("#chromosome").val();
        var currentchromosome= $("#currentChromosome").val();


        if (validateMatch()) {
            var mysnps;
            var mycms;
           
            if ($.isNumeric($("#SNPs").val())) {
                mysnps = $("#SNPs").val();
            }
            if ($.isNumeric($("#cM").val())) {
                mycms = $("#cM").val();
            }
            // process the group field
            //newexistingmatchgroupname
            var redrawKey = false;
            if(!$.isNumeric(parseInt(segmentgroup))){
                // create new group
                // add current group
                var currentgroup = $("#currentGroup").val();
                var segmentgroupside=$("#newexistingmatchgroupside").val();
                /*var segmentgroupside='both';
                if(typeof(chromogroups[currentgroup])!=='undefined'){
                    if(chromogroups[currentgroup].side !=''){
                        segmentgroupside = chromogroups[currentgroup].side;
                    }
                } */               
                var thisgroupcolor = $("#newexistingmatchgroupcolor").val();
                segmentgroup = addNewGroup(chromogroups, $("#newexistingmatchgroupname").val(), segmentgroupside, thisgroupcolor, '',0);
                // SUSPECT THIS OCCASIONALLY FAILS.
                redrawKey = true;
            }

            var mychrom = $.sanitize($("#chromosome").val());
            var mymatch = $.trim($.sanitize($("#match").val()));
            if(mymatch==''){
                mymatch = 'Not specified';
            }
            mymatch = escape_quotes(mymatch);
            chromomapper[savingmatch] = {
                "chromosome": mychrom,
                "start": parseInt($.sanitize($("#start").val())),
                "end": parseInt($.sanitize($("#end").val())),
                "group": parseInt(segmentgroup),
                "id": chromomapper[savingmatch].id,
                "cM": mycms,
                "SNPs": mysnps,
                "certainty": $.sanitize($("#certainty").val()),
                "notes": $.sanitize($("#notes").val()),
                "match": mymatch
            }
            //console.log(chromomapper[savingmatch]);
            writeDataToMap();
            // THIS IS WHERE THE BUG WAS - I WASN'T WRITING GROUPS HERE SO THEY COULD BE LOST
            // save to server via AJAX request at same time?
            // TODO logic to redraw group (and old group if changed?)
            
            /*

            propose - redraw if < 1000. Otherwise don't

            removeSegment(savingmatch);
            // adjusted 24/5 to print it specifically on the main set - otherwise it got drawn twice.
            printMatch(savingmatch, '#chr','', false);
            */
            if(chromomapper.length < 15000){               
                removeSegment(savingmatch);
                paintSegmentInPosition(savingmatch);
             
                //printAllMatchesByChromosome(mychrom); // print them all in order to preserve order.  May have to reverse if perf. issues.
                //adjustMatchNames( $("#chr #p"+mychrom+" strong"));
            }
            else {
                removeSegment(savingmatch);
                printMatch(savingmatch, '#chr','', false);                
            } 



            if(redrawKey){
                drawKey();
            }

            // if the name has changed, update the searchindex
            if($("#oldmn").val() !=mymatch){
                initialiseSearch();
            }        

            closeAndMark('matchform', 'saved');
            if($("#returnToMatch").val()==1){
                viewMatchDetail(mymatch);
            }
            else if($("#returnToGroup").val()==1){
                viewGroupDetail(segmentgroup);
            }
            else if($("#returnToChrom").val()==1){
                viewChromosomeDetail(mychrom);
            }            
        } else {
            // print an error message
            if(!$.isNumeric(parseInt(segmentgroup)) && $("#newexistingmatchgroupname").val()==''
                ){
                //console.log(!$.isNumeric(parseInt(segmentgroup)));
                $("#namematchError").show();

            }
            else {
                $("#matchError").show();
            }
        }
    });

  

    $("#matchdetailform").on("click", ".save-matchdetail", function(e) {
        e.preventDefault();
        // udpate the matches array for this person.
        var match = $("#currentmatchdetail").attr('data-match');
        console.log('saving '+match);
        // update all segments with a match equal to the old value to the new value
        var oldvalue = $("#matchdetailoldname").val();
        oldvalue = oldvalue.replace('\\','\\\\');
        var newvalue = $.sanitize($("#matchdetailname").val());
        if(newvalue==''){
            newvalue='Not specified';
        }
        var valid = true;
        var isnewgroup = false;
        var newgroup = $("#existinggroups").find(':selected').val();

        var redrawKey = false;
        var matchsegments = getMatchSegments(match, "all", "#matchdetail");
        if($("input[name=changegroup]:checked").val() && newgroup=='createnewgroup'){
            // check they have entered a name for the new group
            var thisnewgroupname = $.trim($("#newmatchgroupname").val());
            var thisgroupcolor = $("#newmatchgroupcolor").val();
            var thisgroupside = $("#newmatchgroupside").val();
            if(thisnewgroupname==''){
                valid = false;
            }
            else {
                // add side
                newgroup = addNewGroup(chromogroups, thisnewgroupname, thisgroupside, thisgroupcolor, '', 0);
                redrawKey = true;
            }
        }
        else if($("input[name=changegroup]:checked").val() && $.isNumeric(parseInt(newgroup))) {
            newgroup = parseInt(newgroup);
        }
        //console.log(matchsegments);
            // for each of these match segments, update the name and group as appropriate
       if(!valid){
            //console.log('invalid');
            $("#matchdetail-invalid").show();
       }
       else{
            // turn on new group if turned off
            if($("input[name=changegroup]:checked").val() && $.isNumeric(newgroup)){                
                var groupbut = $("li#group"+newgroup+ " span").first();
                if($(groupbut).hasClass('dphidden')){
                   // setTimeout(function(){
                        $(groupbut).click();
                    //},50);
                    //console.log('found');
                }
                //redrawGroup(newgroup);
            }        
           for (var i in matchsegments) {
                var arrayPosition = matchsegments[i];
                newvalue = escape_quotes(newvalue);
                //chromomapper[arrayPosition].match = newvalue;  no need
                   //console.log(newgroup);
                   if($.isNumeric(newgroup)){
                        chromomapper[arrayPosition].group = newgroup;                    
                   }                  
                   if ($("#mmatchConfidence").is(":checked")) {
                        chromomapper[arrayPosition].certainty =  $("#matchCertainty").val();
                   }
                 
                   //removeSegment(arrayPosition);
                   //printMatch(arrayPosition);
                    removeSegment(arrayPosition);
                    paintSegmentInPosition(arrayPosition);

            }

            //printAllMatchesByChromosome();
           
           
            if(redrawKey){
                drawKey();
            }
            var thismatch = getMatchById(match);
            if($("#matchdetailoldname").val() !=$("#matchdetailname").val()){
                initialiseSearch();
                thismatch.name = $("#matchdetailname").val();
            }

            if ($("#mmatchNotes").is(":checked")) {
                thismatch.notes = $.sanitize($("#matchNotes").val());
            }

            writeDataToMap('all');            
            closeAndMark(false, 'saved');

            /* got rid of 10-1-21*/
            if($("#showmatchaftersave").prop("checked")){

                setTimeout(function(){
                viewMatchDetail(match);

            }, 200);
            }

        }
    });
   


    // * click on an item in the key in a group
    $("#groupdetail").on("click", ".indmatch a", function(e) {
        e.preventDefault();
        var mm = $(this).attr('data-match');
        setTimeout(function(){
            toggleMatchHeader(mm);
        },100);
        // if scrolled down, this value will be negative. make it positive and add it to the other
       
    });


    $(".mdclose").on("click", function(e) {
        // hide groupdetail, show groupdetailform
        $("#matchdetailform").hide();
       // $("#matchdetailformholder").show();
    });
    $(".mdoclose").on("click", function(e) {
        // hide groupdetail, show groupdetailform
        $("#matchdetailheader").hide();
        $(".indmatch a").removeClass('active');
        $(".cp strong").removeClass('highlight');

    });    
    $(".ngclose").on("click", function(e) {
        $(".newgroupformholder").hide();
        var currentmatch = $("#ngmatch").val();
        var myitem = $("a[data-match='"+currentmatch+"']").parent();
        $( myitem).attr('style','').show();
        // move the match back by removing the inline style attribute
    });

    $("#gshownames").click(function(){
        saveFieldLocally('gshownames', $(this).prop("checked"));        
    });
    $("#gshowcm").click(function(){        
        if($(this).prop("checked")){
            $("#maincontent").addClass('showmatchcm');
        }
        else {
            $("#maincontent, .groupdetailcontainer").removeClass('showmatchcm');
        }
        
        saveFieldLocally('gshowcm', $(this).prop("checked"));
        //printMatches('all');
    });
    
    $("#gshowmblines").click(function(){      
        if($(this).prop("checked")){           
            $("#maincontent").addClass('gshowmblines');
        }
        else {
            $("#maincontent").removeClass('gshowmblines');
        }
        
        saveFieldLocally('gshowmblines', $(this).prop("checked"));
        //printMatches('all');
    });

    $("#showmatchaftersave").click(function(){        
        saveFieldLocally('showmatchaftersave', $(this).prop("checked"));
    });

    $("#showcentromeres").click(function(){
        if($(this).prop("checked")){
            loadCentromeres();
        }
        else {
            removeCentromeres();
        }
        saveFieldLocally('showcentromeres', $(this).prop("checked"));
    });

    $("#touch-device-message").on('click', '.dpclose', function(){
        window.localStorage.setItem('hidetouchmsg', 1);
    });

    $("#chrkey").on('click', '.hunknown button', function(e){
         $("#hideunknown").trigger('click');
         $(".hunknown").remove();
         return false;
    });
    $("#chrkey").on('click', '.hethnicity button', function(e){
         $("#hideethnicity").trigger('click');
         $(".hethnicity").remove();
         return false;
    });


    $("#showkl").click(function(){
        if($(this).prop("checked")){
            showKeylines();
        }
        else {
            hideKeylines();
        }
        saveFieldLocally('showkl', $(this).prop("checked"));
    });  

   $("#showcmslider").click(function(){
        if($(this).prop("checked")){
            showSlider();
            saveFieldLocally('cmsliderboundL', $("#cmsliderLowerBound").val());
            saveFieldLocally('cmsliderboundH', $("#cmsliderUpperBound").val());
        }
        else {
            hideSlider();
        }
        saveFieldLocally('showcmslider', $(this).prop("checked"));
    });     


    

    $("#enablecf").click(function(){
        if($(this).prop("checked")){
            enableControlF();
        }
        else {
            disableControlF();
        }
        saveFieldLocally('enablecf', $(this).prop("checked"));
    });  

  $("#showtm").click(function(){
        if($(this).prop("checked")){
            showTraits();
        }
        else {
            hideTraits();
        }
        saveFieldLocally('showtm', $(this).prop("checked"));
    });  



    $("#hideunknown").click(function(){
        if($(this).prop("checked")){
            hideGroups('unknown');
            calculatePaintedPercentage();

        }
        else {
            showGroups('unknown');
            $(".hunknown").remove();
            calculatePaintedPercentage();
        }
        saveFieldLocally('hideunknown', $(this).prop("checked"));
    });  

    $("#hideethnicity").click(function(){
        if($(this).prop("checked")){
            hideGroups('ethnicity');
        }
        else {
            showGroups('ethnicity');
            $(".hethnicity").remove();

        }
        saveFieldLocally('hideethnicity', $(this).prop("checked"));
    });  

    $("#changegroup").click(function() {
        $("#existinggroups").toggle();
    });

    $("#chrtog").on('click', function(e){
        //console.log('sup');
        collapseCpanelItems();
        if($(this).hasClass('exp')){
            $(this).removeClass('exp');
            $("#contracting-flash").css('display', 'inline-block');
            setTimeout(function(){

            //$("#fchrmatchlabel").removeClass('floating').hide(); 
            $("#chr .cp").removeClass('cp-open');
            $("#chr h4").removeClass('expanded');            
            $("#chrtog span").removeClass('fa-minus').addClass('fa-plus');
            $("#contracting-flash").css('display', 'none');
            showHideMemButtons();          

            },10);  
        }
        else {

            $("#expanding-flash").css('display', 'inline-block');
            $(this).addClass('exp');
            $("#chrtog span").removeClass('fa-plus').addClass('fa-minus');
            setTimeout(function(){

            //$(".chrmatchlabel").show();
            $("#chr > .cp").addClass('cp-open'); 
            $("#chr > h4").addClass('expanded');  
            if(inMassEditMode()){
                initialiseMassEditMode(true);
            }
            setTimeout(function(){
                adjustMatchNames( "#chr");
            },200);

           
            $("#expanding-flash").css('display', 'none');
            showHideMemButtons();          

            },10);

        }
        if($("#showkl").prop('checked')){
                setTimeout(function(){
                   showKeylines();
                },100);
            }
     

    });
    $("#chrlabel1").on('click', function(e){
        if(!$(this).prop('checked')){
            $("#chr").addClass('hidematchnames');
        }
        else{
            $("#chr").removeClass('hidematchnames');
        }
    });



   $(".save-ng").on("click", function(e){
        // create the group
        var ngcolor, ngname;
            if ($("#ngnewgroupcolor").val() == '') {
                ngcolor = '#000000';
            }
            else {
                ngcolor = $("#ngnewgroupcolor").val();
            }
            if ($("#ngnewgroupname").val() == '') {
                ngname = 'Untitled';
            }
            else {
                ngname = $.sanitize($("#ngnewgroupname").val());
            }
            newgroupindex = addNewGroup(chromogroups, ngname,$("#ngnewgroupside").val(),ngcolor,'',0);
            var match = $("#ngmatch").val();
            var currentgroup = $("#ngcurrentgroup").val();
        // save the match
        switchmatchgroup(match, currentgroup, newgroupindex);
        // close the form
        $(".newgroupformholder").hide();
        // redraw the key
        drawKey();
        // remove this as was creating a dupe... the matches get drawn in 'switchmatchgroup'
        //var groupItems = getGroupItems(newgroupindex);
        //printMatches(groupItems, "#chr");
        // draw the matches

   });

    // * save a new match
    $(".savenewgroup").on("click", function(e) {
        e.preventDefault();
        //var t0 = performance.now();

        var ancestor = $("input[name=ancestor]:checked").val();
        var isnewgroup = false;
        var newgroupname = '';
        if (ancestor == 1 && $("input[name=neworold]:checked").val() == 'new') {
            isnewgroup = true;
            newgroupname = $("#anewgroupname").val();
        } else if (ancestor == 0 && $("input[name=gneworold]:checked").val() == 'new') {
            isnewgroup = true;
            newgroupname = $("#gnewgroupname").val();
        }
        newgroupname =  $.trim($.sanitize(newgroupname));
        var matchname = '';

        if ($("#matchname").val() != '') {
            matchname = $("#matchname").val();
            matchname = matchname.replace(/\</g,"");
            matchname = matchname.replace(/\>/g,""); 
            matchname = $.trim($.sanitize(matchname));
            matchname = escape_quotes(matchname);
        }
        if(matchname==''){
            matchname = 'Not specified';
        }
        if($("#emn").val()==''){
            var thismatch = getIdForMatch(matchname, true); // force generating a new ID even if there is a name match
        }
        else {
            var thismatch = $("#emn").val();
        }
        var segmentnotes = '';
            if ($("#segmentnotes").val() != '') {
                segmentnotes = $("#segmentnotes").val();           
            }
        //  new group is now denoted by existinggroup and existingancestor having a value of ''
        // new group name is anewgroupname or gnewgroupname
        var newgroupindex;
        var validated = false;
        var itemidentifier;
        if(isnewgroup && newgroupname==''){
            if (ancestor == 1) {
                itemidentifier = 'entered a name for the ancestor, or selected an existing ancestor';

            } else {
                itemidentifier = 'entered a name for the group, or selected an existing group';
            }
        }
        else if (isnewgroup) {
            // add new group to chromogroups (kind of an array push?)
            // { "id": "1", "notes": "notes here", "side": "pat", "order": "1","name": "Ernst (Jonathan shared)", "color": "#aaa"},
            // set colour to black if not set

            // nothing to validate
            validated = true;
            if ($("#newgroupcolor").val() == '') {
                $("#newgroupcolor").val('#000000');
            }
            if (newgroupname == '') {
                newgroupname = 'Untitled';

            }
            newgroupindex = addNewGroup(chromogroups, newgroupname,$("#newgroupside").val(),$("#newgroupcolor").val(),$("#newgroupnotes").val(),ancestor);
          
            //writeDataToMap('groups');
        } else {

            if (ancestor == 1) {
                groupfield = 'existingancestor';
                itemidentifier = 'selected an ancestor, or entered a name to create a new one';

            } else {
                groupfield = 'existinggroup';
                itemidentifier = 'selected a group, or entered a name to create a new one';

            }
            if ($.isNumeric($("#" + groupfield).val())) {
                validated = true;
                newgroupindex = parseInt($("#" + groupfield).val());
            }


            //TODO check a group has been selected
            // group is the submitted selected group
            //newgroupindex = $("#newgroupfield")[0].selectedIndex.val();
        }

        if (validated) {
            $("#find-data-reminder").css('display', 'none');
            // clear the form
            //$("#compareform")[0].reset();
            $("#comparedata").val('');
            $("#newmatchform")[0].reset();
            $("#newmatchkey").empty().hide();
            //console.log(newmatcharray);

            //  match name needs to be stored against all the chromomapper matches
            //  set certainty to 4 if it's an ancestor match and existingancestor is ''
            // otherwise set certainty to 3 as before
          
            if($.isNumeric($("#newmatchCertainty").val()) && $("#newmatchCertainty").val() <=4){
                var certaintyval = $("#newmatchCertainty").val();                    
            }
            else {
                // putting a default in for Michelle's problem
                var certaintyval = 3;
            }
           // var chromstodraw = [];
            var newsegs = [];
            for (var m in newmatcharray) {
                var nm = newmatcharray[m]; 
                var currchrom = $.sanitize($.trim(nm[0]));               
                var ns = chromomapper.push({
                    "chromosome": currchrom,
                    "start": String(numberWithoutCommas(nm[1])),
                    "end": String(numberWithoutCommas(nm[2])),
                    "group": parseInt(newgroupindex),
                    "id": getIdentifier(),
                    "cM": String(numberWithoutCommas(nm[3],1)),
                    "SNPs": String(numberWithoutCommas(nm[4])),
                    "notes": $.sanitize(segmentnotes),
                    "match": thismatch,
                    "certainty": certaintyval
                })-1;
                newsegs.push(ns);
                //if($.inArray(currchrom, chromstodraw)==-1){
                //    chromstodraw.push(currchrom);
                //}
              
            }
            //chromomapper[$("#arrayPosition").val()] = {
            //  "chromosome": $("#chromosome").val(),"start": $("#start").val(),"end": $("#end").val(),"group": $("#chromogroupfield").find(':selected').val(), "cM": $("#cM").val(), "SNPs": $("#SNPs").val(), "certainty": $("#certainty").val(), "notes": $("#notes").val() 
            //}
            //sortSegments();
            writeDataToMap('all');
            $("#overlay-confirm").hide();
            $("#chrcontainer").removeClass('overlaying');
            // possibly just redraw chromosomes?
            // scene of a bug!  I have to redraw all matches here if I am to put the segments in order.
            //setTimeout(function(){
                for (var i in newsegs){
                    paintSegmentInPosition(newsegs[i]);
                }
            //},10);
         


            //for(var i in chromstodraw){
                /*
                Tests showed that clearing the chroms was a lot quicker for some reason.
                if(chromomapper.length < 10){
                    printAllMatchesByChromosome(chromstodraw[i]);
                    adjustMatchNames( $("#chr #p"+ chromstodraw[i] + " strong"));             
                }
                else{*/
                   /* console.log('clearing '+chromstodraw[i]);
                    clearChromosome(chromstodraw[i]);
                    printChromosomeMatches(chromstodraw[i]);      */

                    //printAllMatchesByChromosome(chromstodraw[i]);
                    //adjustMatchNames( $("#chr #p"+ chromstodraw[i] + " strong"));                                       
                //}                              
            //}
           

            
            /*for(var i in chromstodraw){
                clearChromosome(chromstodraw[i]);
                printChromosomeMatches(chromstodraw[i]);  
            }*/
            /*
                compile a list of chromosomes above
                printChromosomeMatches
                make or reuse a function to clear and redraw chromosomes
            */
            //redrawGroup(newgroupindex);
            newmatcharray = [];
            $(".gnewmatch").remove();
            // also redraw the key
            adjustChromosomeLengths(); 
            initialiseSearch();


            drawKey();
            closeAndMark('newmatchform', 'saved');
            showNewMatchLink(thismatch);
            //var t1 = performance.now();
            //console.log("Painting this match took " + (t1 - t0) + " milliseconds.");

        } else {

            $("#validategroupitem").text(itemidentifier);
            $("#groupError").show();
        }
    });

        
    // mass move tool
    $(".mem-deselect").on('click', function(){
        memDeselect();
    });

    $(".memmovetogroup").on('click', function(){
        var newgroup = $("#memgroupid").val();
        var valid = true;
        var isnewgroup = false;
        var newgroup = $("#memgroupid").find(':selected').val();
        var redrawKey = false;
        if(newgroup=='createnewgroup'){
            // check they have entered a name for the new group
            var thisnewgroupname = $.trim($("#newmemgroupname").val());
            var thisgroupcolor = $("#newmemgroupcolor").val();
            var thisgroupside = $("#newmemgroupside").val();
            if(thisnewgroupname==''){
                valid = false;
            }
            else {
                // add side
                newgroup = addNewGroup(chromogroups, thisnewgroupname, thisgroupside, thisgroupcolor, '', 0);
                redrawKey = true;
            }
        }
        if(!$.isNumeric(newgroup)){
            $("#memerror").css('display','block');
        }
        else {
            for(var i in itemstomove){
                // remove the display
                var thisitem = itemstomove[i].id;
                removeSegment(thisitem);                
                // update the group
                chromomapper[thisitem].group = newgroup;
                //setTimeout(function(){
                    paintSegmentInPosition(thisitem);        
                //},5);
            }

            // (or should I just be doing this on every select?)            
            // loop through these and change the group
            // redraw         
            //setTimeout(function(){
                // possibly don't do this, but instead use existing 'paint segment in position' on every segment

                // redrawGroup(newgroup);
            //},100);

            setTimeout(function(){
                var aelement ="#chr";            
                //if(getSelectableRoot() !='.cp-open'){
                if($("#matchdetail").hasClass('active')){
                    aelement = "#matchdetail .chrcontainer";                
                }
                else if($("#groupdetail").hasClass('active')){
                    aelement = "#groupdetail .chrcontainer";                
                }       
                         

                // putting context as well to match when the chr is expanded
                adjustMatchNames(aelement, aelement);
            },100);


            if(redrawKey){
                drawKey();
            }
            // todo: save
            writeDataToMap();
            // todo: print undo button. 
            // undo will revert to the backed up chromomapper and redraw and save
            // hopefully it will keep the selections somehow...
            // turn edit mode off and deselect segments
            //$('.ui-selectee').removeClass('ui-selected');
            // reset membox
            var numbermoved = itemstomove.length;
            itemstoundo = JSON.parse(JSON.stringify(itemstomove));
            memDeselect();

            if($("#matchdetail").hasClass('active')){
                // have to do this or it gets confused opening it again
                 cancelMassEditMode();
                 var showcommon = false;
                if($("#show_common").prop('checked')){
                  showcommon = true;
                }
                viewMatchDetail($("#currentmatchdetail").attr('data-match'));
                if(showcommon){
                    $("#show_common").click();
                    // possible to do - preserve itemstoundo and turn on mass edit mode
                }
                initialiseMassEditMode();
                $("#membox").css('display','block');


            }
            $("#memsuccess").find('strong').first().text(numbermoved);
            $("#memsuccess").find('span').first().text(chromogroups[newgroup].name);

            $("#memsuccess").css('display','block');

        }
        // if there's a selectedindex, use it. Otherwise ask them to choose a group
    });

    // * clear a new match
    $("#newmatchkey, #overlay-confirm").on("click", ".clearnew", function(e) {
        e.preventDefault();
        collapseAllChroms();
        clearNewMatch();
    });

    $(".mem-undo").on('click', function(){
        //console.log(itemstoundo);
        for(var i in itemstoundo){            
            var thisid = itemstoundo[i].id;
            //console.log(thisid);
            removeSegment(thisid);
            chromomapper[thisid].group = itemstoundo[i].group;
            //printMatch(thisid);
            paintSegmentInPosition(thisid);
        }
        // if in an overlay, reload that
        if($("#matchdetail").hasClass('active')){                       
            viewMatchDetail($("#currentmatchdetail").text());
            setTimeout(function(){
                initialiseMassEditMode();
                $("#membox").css('display','block');
            },510);

        }
        else if($("#groupdetail").hasClass('active')){
            viewGroupDetail($("#detailgroupname").attr('data-group'));
            setTimeout(function(){
                initialiseMassEditMode();
                $("#membox").css('display','block');
            },510);
        }  

        // turn mode on

        // restore chromomapper to what it was
        // redraw
        // remove any new groups from the key
        // print message
        $("#memundone").css('display','block');
        $("#memsuccess").css('display','none');
        writeDataToMap();
    });

    // click on the key filter
    $("#keyarea").on("click", "#chrfilter li a", function(e) {
        e.preventDefault();
        //$("#filter-groups").val('');
        filterGroups($(this).attr('data-chrfilter'));
        if($("#filter-groups").val()!=''){
          //setTimeout(function(){filterGroupsByString();},100);
            filterGroupsByString();
        }
    });
    $("button.fgc").on("click", function(e){
       $("#filter-groups").val('');
        filterGroupsByString();        
    });

    // * save a group
    $(".savegroup").on("click", function(e) {
        e.preventDefault();
        var groupbeingedited = $("#groupArrayPosition").val();
        var ancestorval = 0;
        var gdivider = '';
        //console.log($("#ancestor").val());
        if ($("#ancestor").is(":checked")) {
            ancestorval = 1;
        }
      
        
        //console.log(ancestorval);
        if($("#groupcolor").val()==''){
           $("#groupcolor").val()='000000' 
        }
        var myside = $("#groupside").find(':selected').val();
        if(myside==''){
            myside = 'both';
        }
        chromogroups[$("#groupArrayPosition").val()] = {
            "notes": $.sanitize($("#groupnotes").val()),
            "side": $.sanitize(myside),
            "order": $.sanitize($("#grouporder").val()),
            "name": $.sanitize($("#groupname").val()),
            "color": $.sanitize($("#groupcolor").val()),
            "ancestor": ancestorval
        }
        if($("#gdivider").is(":checked")){
            chromogroups[$("#groupArrayPosition").val()].gdivider = 1;
        }
        if($("#ethnicityg").is(":checked")){
            chromogroups[$("#groupArrayPosition").val()].spec = 'eth';
        }        
        // if the confidence level has been set (groupConfidence is checked), update the certainty value for all matches in this group
        if ($("#groupConfidence").is(":checked")) {
            //console.log(chromomapper);
            //console.log(groupbeingedited);
            $(chromomapper).each(function(i) {
                if (chromomapper[i].group == groupbeingedited) {
                    chromomapper[i].certainty = $("#groupCertainty").val();
                }

            });


        }
        writeDataToMap('all');
        var myg = $("#groupArrayPosition").val();
        redrawGroup(myg);
        drawKey();
        loadLocalSettings();
        closeAndMark('groupform', 'saved');
        // now open the group!
        viewGroupDetail(myg);
    });

    // * click next or previous links
    $(".next-chrom").on("click", function(e) {
        navigateToChromosome('next');
    });
    $(".prev-chrom").on("click", function(e) {
        navigateToChromosome('prev');
    });
    $(".next-group").on("click", function(e) {
        navigateToGroup('next');
    });
    $(".prev-group").on("click", function(e) {
        navigateToGroup('prev');
    });
   

    $(".view-dupes").on("click", function(e){        
        e.preventDefault();
        viewDuplicates();
    });
   

    // * overlap - select group when you click
    $("#newmatchform").on('click', '#overlap-info li', function(){
        var thisgroup = $(this).attr('data-group');
        selectGroup(thisgroup);      
        //console.log($(this).attr('data-group'));

        // check if knownancestor is checked.  if so trigger a click on oldancestor and select the item with a value of 'data-group
        // otherwise,  trigger a click on oldgroup and select the item with a value of 'data-group'
    });

    $(document).on('keydown', function(e) {
        if (!$('body').hasClass('tour-tour-element') && $("#matchform").css('display') != 'block' && $("#matchdetailform").css('display') != 'block' && !$("#filterdatagroup").is(":focus")) {
            if ($("#chromodetail").hasClass('active')) {
                if (e.keyCode == 37 || e.keyCode == 38) {
                    navigateToChromosome('prev');
                } else if (e.keyCode == 39 || e.keyCode == 40) {
                    // right or down.  If active is 22,go to X. If it's X, go to 1. Otherwise go to active +1
                    navigateToChromosome('next');

                }

            } else if ($("#groupdetail").hasClass('active')) {
                if (e.keyCode == 37 || e.keyCode == 38) {
                    navigateToGroup('prev');
                } else if (e.keyCode == 39 || e.keyCode == 40) {
                    navigateToGroup('next');
                }
            }
        }
    });

    // * close form when user hits escape
    $(document).keyup(function(e) {
        if (e.which == 27) {
            if(inMassEditMode()){
                cancelMassEditMode();
            }

            if($("#newreport").css('display')=='block'){              
                writeDataToMap('all'); // todo - could actually make this revert. I don't know.
                printMatches('all');
            }   
            //console.log($("#chr-detail strong.popped").length);
            resetModals();
            if($("#chr").hasClass('searching')){
                clearSearch();
            }
            if ($('body').hasClass('form-toggled') && $(".chrcontainer strong.popped").length == 0) {
                $('form').hide();
                $('body').removeClass('form-toggled');
                $('.confirm-delete').hide();
                $("#chromodetail").removeClass('active');
                closeOverlays();
            }
            if ($(".chrcontainer strong.popped").length == 0) {
                //$("#chromodetail").hide();
                //$(".floater").hide();
                //console.log('sup');
                if($("#returnToChrom").val()==1 && $("#matchform").css('display')=='block'){
                    viewChromosomeDetail($("#chromosome").val());
                }  
                else if($("#returnToGroup").val()==1  && $("#matchform").css('display')=='block'){
                    viewGroupDetail($("#chromogroupfield").val());
                } 


            }
            $(".confirm-delete").hide();
            closePopups();
            //$(".cp strong").removeClass('popped');
            $("#chromodetail div.cp").attr('id', 'p0');
            resetPoppedItem();
            $(".popup").remove();
            if (typeof(tour) !== "undefined") {
                tour.end();
            }
        }
    });

    // * show new match aka compare form
    $(".compare").on("click", function() {
      clearSearch();
      $("#match-confirm").css('display', 'none');
        if($("#open-search").hasClass('active')){
            toggleCpanelItem('search', true);
        }      
      //collapseAllChroms();
      compareMatch('','');
      $("#comparedata").focus();
    });
    
    /*$(".open-buckettool").on("click", function() {
        if(!hasftDNAImportGroup()){            
            $("#ftdupload").css('display','block');
            $("#ftdgoahead").css('display','none');

        }
        else {
            $("#ftdgoahead").css('display','block');
            $("#ftdform .alert").css('display', 'none');
            $("#import-ff-file").text('Import FTDNA match info');
            $("#import-ff-file").prop('disabled', false);
            $("#import-ff-file").removeClass('loading');     

        }
        bucketForm();        

    });*/

    $(".open-ftdtool").on("click", function() {
        if(!hasftDNAImportGroup()){            
            $("#ftdupload").css('display','block');
            $("#ftdgoahead").css('display','none');

        }
        else {
            $("#ftdgoahead").css('display','block');
            $("#ftdform .alert").css('display', 'none');
            $("#import-ff-file").text('Import FTDNA match info');
            $("#import-ff-file").prop('disabled', false);
            $("#import-ff-file").removeClass('loading');     

        }
        ftdForm();
       
    });

    $(".open-ethnicity").on("click", function() {
      ethnicityForm();
    });



    $(".saveethnicity").on("click", function(e) {
      e.preventDefault();
      saveEthnicity();
    });




    $("#printProfile").click(function() {
        /* console.log('well');
         html2canvas($("#chrcontainer")).then(function(canvas) {
           document.body.appendChild(canvas);
         });*/
        // hide elements
        var filename = 'DNA Painter Map for '+$("#mapName").text()+'.png';
        $("#generating-flash").show();
        $("#maincontent").addClass('repositioned');
        if($("#mapDesc").text()=='Click to add a description'){
            $("#mapDesc").hide();  
        }
        html2canvas($("#maincontent")[0], {
            dpi: 300, logging: false }).then(function(canvas) {

                theCanvas = canvas;

                canvas.toBlob(function(blob) {
                    saveAs(blob, filename);
                });
                $("#maincontent").removeClass('repositioned');
                $("#generating-flash").hide();

            }).catch(function (err) { console.log(err); });

        });



    // * process the compare form 
    $("#compareform .overlay-segments").on("click", function(e) {
        e.preventDefault();
        $("#overlay-overlaps").empty();
        $("#matchname").val('');
        var emn = $.sanitize($("#emn").val());
//        var egr = $.sanitize($("#egr").val());

        var process = processMatchData($.sanitize($("#comparedata").val()), emn);
        if (process) {
            $('body').removeClass('form-toggled');
            $("#newmatchkey").append("<li class='newmatchlink' data-group='newmatch'><span></span><a href='#' class='savenew'>New match</a></li><li><a href='#' class='btn-secondary clearnew'>Clear</a></li>");
            $("#newmatchkey").show();
            $("#numberofsegmentsalert").text(process.length);
            if (process.length == 1) {
                $("#onesegment").text(' is');
                $("#onesegmentcount").text('this segment');
                $("#onesegmentit").text('it');
            } else {
                $("#onesegment").text('s are');
                $("#onesegmentcount").text('these segments');
                $("#onesegmentit").text('them all');
            }
            $("#overlay-overlaps-dupe-warning").hide();            
            checkNewMatch(newmatcharray,'overlay-overlaps');
            // close the chromosomes
            $("#chr .cp").removeClass('cp-open');
            $("#chr h4").removeClass('expanded'); 


            // expand chromosomes
            var chrstoexpand = Array();
            for(var m in newmatcharray){
                //console.log(newmatcharray[m][0]);
                //var c = $("#chr > #p"+newmatcharray[m][0]).prev();
                chrstoexpand.push(newmatcharray[m][0]);
                //expandChromosome(c);
            }
            chrstoexpand = $.unique(chrstoexpand);
            //console.log(chrstoexpand);
            for(var i in chrstoexpand){
                var c = $("#chr > #p"+chrstoexpand[i]).prev();
               expandChromosome(c); 
            }
            $("#overlay-confirm").show();
            $("#chrcontainer").addClass('overlaying');

        } else {
            var threshold = $.sanitize($("#threshold").val());
            $("#overthreshold").text(threshold);            
            $("#overlay-confirm-none").show();
        }
    });

  


    /* select changes in new group form*/
    $("#existingancestor, #existinggroup").change(function() {
        if ($(this).val() != '') {
            $(".newgroupfields").hide();
        } else {
            $(".newgroupfields").show();
        }
    });

    $("#update-info").on('click', function() {
        if(inMassEditMode()){
            cancelMassEditMode();
        }
        $('body').addClass('form-toggled');
        $("#whatsnew").css('display', 'block')
    });


    $("#chrkey").sortable({
        revert: 'invalid',
        handle: '.grippy',
        placeholder: 'ui-sortable-placeholder',
        forceHelperSize: true
    });
    $("#chrkey").on("sortstop", function(event, ui) {
        //console.log('sort has stopped and it should say saving');
        sortGroups()
    });

    $("#existinggroups, #chromogroupfield, #memgroupid").change(function(){
        var selectedgroup = $(this).find(':selected').val();
        if(selectedgroup=='createnewgroup'){
            // show new group name field
            $(".newgroupholder").show();
             $(".newgroupholder input").first().focus();
            $("#newmemgroupname").val('');
            $("#newmemgroupside").val('both');
            if(!$("body").hasClass('user-is-touching')){
                $("#newmemgroupname").focus();
            }
            
            if(this.id=='chromogroupfield'){
              initialiseColorPicker('newexistingmatchgroupcolor', 'random');              

            }
            else if(this.id=='memgroupid') {
              initialiseColorPicker('newmemgroupcolor', 'random');              
            }
            else {
              initialiseColorPicker('newmatchgroupcolor', 'random');              
            }

        }
        else {
            $(".newgroupholder").hide();
        }
    });
    activateCpClicks();
    activateChromClicks();

 }  // end of if in map page
});  // end of the doc ready



// FUNCTIONS


    // todo https://stackoverflow.com/questions/14674456/how-to-combine-keypress-on-click-function-in-javascript
    // also adjust if statements to include element clicked on (e.g. prev-link)

    $.sanitize = function(input) {
        if(typeof(input)==='undefined' || input ==''){
            return '';
        }
        var output = $('<div />').text(output).html();
        output = input.replace(/<script[^>]*?>.*?<\/script>/gi, '').
                     replace(/<[\/\!]*?[^<>]*?>/gi, '').
                     replace(/<style[^>]*?>.*?<\/style>/gi, '').
                     replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '');
        //output = output.replace(/"/g, '&quot;');
        return output;

    };

    function activateChromClicks(){
        // * click on a chromosome number
    /* was too aggressive*/
        $("#chr > .cp > div").click(function(e) {

            clickedElement = e.target;
            //console.log(clickedElement.nodeName);

            if (clickedElement.nodeName == 'DIV' && !$(clickedElement).hasClass('popup')) {
                //console.log(clickedElement);
                var chromofocus = $(this).parent().attr('id').replace("p", "");
                viewChromosomeDetail(chromofocus);
            }
        });    

    }
    function activateCpClicks(){
         // * click on an existing match to view details in a popup

  
        
        $(".cp, .groupdetailcontainer, .matchdetailcontainer").on("click", "strong.match", function(e) {

           /* if(
                ($("#chr").hasClass('searching') && !($(this).hasClass('hilite')))
                ){
                return false;
            }*/
          
            if(!$(e.target).is('.thischr')){
                openSegPopup($(this), e);
            }
           
        });
    }

    function quickDeleteSegment(deletingseg){
        chromomapper.splice(deletingseg, 1); // delete and reset array
    }

    function toggleCollapser(elem){
        $(elem).next().collapse('toggle');
        $(elem).find('span').toggleClass('glyphicon-minus', 'glyphicon-plus');

    }
    function openSegPopup(poppedItem, e){
        closePopups();
        if (!$(e.target).is('.dpclose')) {
           setTimeout(function(){

            $(poppedItem).parent().clone().addClass('clone').insertBefore($(poppedItem).parent());
            $(poppedItem).parent().addClass('popped');

            poppedItem.addClass('popped');
            var matchnumber = poppedItem.attr('data-id').replace('match', '');
            var thismatch = chromomapper[matchnumber];
            var matchstring = '';
            var thismatchname = 'Not specified';

            if (typeof(thismatch.match) !== 'undefined' && thismatch.match != '') {
                thismatchname = getMatchById(thismatch.match, 'name');
            }            
            var showmdbutton = true;
            if($("#matchdetail").css('display')=='block'){

                var cmch = ($("#currentmatchdetail").text());

                if(cmch==$(poppedItem).attr('data-match')){
                    showmdbutton = false;
                }
            }

            var highlightbutton = '<button class="btn hilitematch" data-match="'+thismatch.match+'">Highlight this match</button>';
            if($("strong.hilite").length){
                var currentlyhigh = $("strong.hilite:first").attr('data-match');
                if(currentlyhigh ==thismatch.match){
                    var highlightbutton = '<button class="btn cancelhilitematch">Unhighlight this match</button>';
                }
            }            
            if (thismatchname != '' && showmdbutton) {
                matchstring = '<a class="btn matchname" data-group="'+thismatch.group+'" data-matchslug=\''+thismatch.match+'\'>VIEW MATCH<br /><span>' + thismatchname + '</span></a><button class="btn edit-matchdetail" data-matchslug=\''+thismatch.match+'\'>Edit match</button>';
            }
            else {
                matchstring = '';
            }
            var notestring = '';
            if (typeof(thismatch.notes) !== 'undefined' && thismatch.notes != '') {
                notestring = $.sanitize(thismatch.notes);
            }
            if (notestring != '') {
                var len = notestring.length;

                if(len > 200){
                    notestring = shorten(notestring, 200);
                    //notestring = notestring.substring(0,199)+'&#8230;';
                }
                notestring = addLinks(notestring);
                notestring = '<span class="notestring">' + notestring + '</span>';
            }
       //     console.log($.sanitize(thismatch.match));
            var pastestring = getSegmentData(matchnumber);
            var thisgroupname = chromogroups[thismatch.group].name;

            poppedItem.append("<div class='popup'><em class='gn'>"+thisgroupname+"</em><a href='#' class='entire-group' data-group='" + thismatch.group + "' data-match='"+thismatch.match+"'>View entire group</a><span class='thischr' title='click here to copy the data for this segment' data-clipboard-text='"+pastestring+"'>" + thismatch.chromosome + "</span> " + numberWithCommas(thismatch.start) + " - " + numberWithCommas(thismatch.end) + numberDisplay(thismatch.cM, thismatch.SNPs) + notestring + highlightbutton + matchstring + 
                 "<button class='btn edit' data-match='" + matchnumber + "'>Edit Segment</button><a href='#' class='dpclose'>x</a><div class='flash' id='copied-segment'>Copied!</div><div class='flash' id='copied-flash-ctrl'>Click CTRL-C to copy!</div></div>");

            var clipboard = new Clipboard('.thischr');
            clipboard.on('success', function(e) {
                //$("#copied-segment").css('display', 'inline-block');
                $("#copied-segment").delay(200).fadeIn().delay(500).fadeOut();
            });
            clipboard.on('error', function(e) {
                $("#copiedseg-flash-ctrl").delay(200).fadeIn().delay(500).fadeOut();
            });
          },10);

        }
    }

    function deleteSegment(deletingseg){
        var chrtotidy = chromomapper[deletingseg].chromosome;
        var grptoopen = chromomapper[deletingseg].group;
        chromomapper.splice(deletingseg, 1); // delete and reset array

        // save this deletion
        writeDataToMap('matches');

        // at this point we'll need to redraw everything.
        // if it happens to be the final seg in the map, remove it and we're good to go    
        var endAt = chromomapper.length;
        if(deletingseg>chromomapper.length){
            removeSegment(deletingseg);
        }
        else {
            // otherwise, redraw all from that one onwards.
            //printMatches('all','',deletingseg, endAt);
            // actually can't do this efficiently right now!
            // perhaps it might be worth doing this conditionally if 'deletingseg' is say < 100 than endat ?
            // include 'chr' so it doesn't paint them on chr detail and group detail, match detail etc. 
            printMatches('all', '#chr');

        }
        closeAndMark('matchform', 'deleted');

        if($("#returnToGroup").val()==1){
            setTimeout(function(){
                viewGroupDetail(grptoopen);
            },200);
        }
        else if($("#returnToChrom").val()==1){
            setTimeout(function(){
                viewChromosomeDetail(chrtotidy);
            },200);                
        }     
       
    }


    function showSegSummary(id, context){
        var thiselement = $("strong[data-id=match"+id+"]");
        //console.log(id);
        //console.log(thiselement);
        if(typeof(context)!=='undefined'){
            thiselement = $(context+" strong[data-id=match"+id+"]");
        }
        if(
            (thiselement.parent().parent().parent().hasClass('cp-open') && !$("#chr").hasClass('hidematchnames'))
            || ($("#matchdetail").hasClass('active') && $(".matchdetailcontainer").hasClass('showmatchnames'))
            || ($("#groupdetail").hasClass('active') && $(".groupdetailcontainer").hasClass('showmatchnames'))

            || ($("#chr").hasClass('searching') && !$("strong[data-id=match"+id+"]").hasClass('hilite'))
             ){
            return false;
        }

        $("span.swr").remove();
        var thismatch = chromomapper[id];
        var thisgroup = chromogroups[thismatch.group];
        var mymatchname = 'Not specified';
         if (typeof(thismatch.match) !== 'undefined' && thismatch.match != '') {
                mymatchname = getMatchById(thismatch.match, 'name');
            }        
        var lcm = '';
        if($.isNumeric(thismatch.cM)){
            lcm = "<span class='lcm'>"+thismatch.cM+"cM";
            if(typeof(thismatch.SNPs)!=='undefined' && $.isNumeric(thismatch.SNPs)){
                lcm += " <span>("+numberWithCommas(thismatch.SNPs)+" SNPs)</span>";
            }  
            lcm += "</span>";
        }
              
        // append it to strong[data-id=]

        var summary = "<span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+mymatchname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(thismatch.start)+"-"+numberWithCommas(thismatch.end)+"</span></span></span>";
        thiselement.append(summary);
        //console.log(id);
 /**/
//        <span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(match.start)+"-"+numberWithCommas(match.end)+"</span></span></span>

    }

    function removeSegSummary(id){
        var summary = $("strong[data-id=match"+id+"]").find('span.swr');
        $(summary).remove();
    }
  
    function clearNewMatch(){
        $(".gnewmatch, .matchtrack").remove();
        $("#comparedata").val('');
        $("#matchname").val('');        
        $("#emn").val('');   
        $("#egr").val('');       
        $("#newmatchkey").empty().hide();
        $("#overlay-confirm").hide();
        $("#chrcontainer").removeClass('overlaying');

    }
    function openHelp(elem){
        // open a modal called '#help-'+elem
        $("body").addClass('form-toggled');
        $("#help-"+elem).css('display', 'block');
    }

    function openMailerForm(e){
        // open a modal called '#help-'+elem
        e.preventDefault();
        $("body").addClass('form-toggled');        
        $("#mailerform").css('display', 'block');           
       
    }

    function navigateToChromosome(action) {
        var destination;
        var activeItem = $("#chr-detail h4").text();
        if (action == 'prev') {
            if (activeItem == 1) {
                destination = 'X';
            } else if (activeItem == 'X') {
                destination = 22;
            } else {
                destination = parseInt(activeItem) - 1;
            }
        } else if (action == 'next') {
            if (activeItem == 22) {
                destination = 'X';
            } else if (activeItem == 'X') {
                destination = 1;
            } else {
                destination = parseInt(activeItem) + 1;
            }
        }
        if (typeof(destination) !== "undefined") {
            viewChromosomeDetail(destination);
        }
    }
    function saveBoundsLocally(){
        saveFieldLocally('cmsliderboundL', $("#cmsliderLowerBound").val());
        saveFieldLocally('cmsliderboundH', $("#cmsliderUpperBound").val());
    }

    function handleCutoffs(elem){
        // if an element is on the right hand edge of the screen, apply a class
        // so if the left edge of the item is less than [the item width or an arbitrary say 300px] away from the edge of the container
        /// if it's the window, I can just say if windowwidth - 300 > itemleftposition
        /// or if it's in a modal window, I have to say if itemleftposition > (windowwidth - modalwidth /2) + itemleftposition 

        var rightEdge = $(window).width();
        if($("body").hasClass('form-toggled')){
            var fwidth = $('.floater.active').outerWidth();

            rightEdge = rightEdge - (parseInt(rightEdge) - fwidth)/2;
        }
        if(300+elem.offset().left > rightEdge){
            elem.addClass('cutoff');
            if(elem.offset().left >150){
                elem.addClass('cutoff-right');
            }
        }
        // TODO - can a popup be more than 300px?
        //console.log(rightEdge);
        //console.log(elem.offset().left);
       
    }

    function hideUnknown(){
        if($("#hideunknown").prop('checked')){
            return true;        
        }
        return false; 
    }
    function hideEthnicity(){
        if($("#hideethnicity").prop('checked')){
            return true;        
        }
        return false; 
    }

    function getDestination(action, activeItemOrder, sortedgroups, lastgroup){
        if (action == 'prev') {
            if (activeItemOrder == 0) {
                return sortedgroups[lastgroup].arrayPosition;
            } else {
                return sortedgroups[parseInt(activeItemOrder) - 1].arrayPosition; // 2 to account for order starting at 1 not zero
            }

        } else if (action == 'next') {
            // right or down.  If active is the last in the array, go to 0
            if (activeItemOrder == lastgroup) {
                return sortedgroups[0].arrayPosition;
            } else {
                return sortedgroups[parseInt(activeItemOrder) + 1].arrayPosition; // took +1 off to account.....
            }
        }


    }

    function paintSegmentInPosition(seg){
        //console.log(seg);
        var appendposition = getSegmentPosition(seg);
        if(appendposition){
            var mystring = printMatch(seg, '#chr','', false, true);
            // for some reason it sometimes finds 2. makes no sense to me!

            var mytarget = $('#chr strong[data-id=match'+appendposition+']').first();
           if(mytarget.length>0){
                     $(mystring).insertBefore(mytarget.parent());   
           }
           else {
            printMatch(seg, '#chr', '', false);
           }

          //  console.log('inserting before');
        }
        else {
            // otherwise just append it
            printMatch(seg, '#chr', '', false);
            //            console.log('appending');

        }
        setTimeout(function(){
            adjustMatchNames("strong[data-id=match"+seg+"]");
        },500)

    }
              

    function getSegmentPosition(seg){
        /*
order them by start position
get all the ones that are lower than the current start position
organise these by start position
get the id of the last one
        */
        var segsforposition = JSON.parse(JSON.stringify(chromomapper));
        for (var i in segsforposition) {
            segsforposition[i].arrayPosition = i;
        }           
        var mychr = chromomapper[seg].chromosome;
        var myside = chromogroups[chromomapper[seg].group].side;
        var mystart = parseInt(chromomapper[seg].start);        
        // console.log(myside);
        // Get all segments that have the same side and chromosome
        var neighbourhood = segsforposition.filter(function(segsforposition) {
            return (
                segsforposition.arrayPosition != seg && 
                chromogroups[segsforposition.group].side == myside && 
                segsforposition.chromosome == mychr && 
                parseInt(segsforposition.start) >= mystart
                )
        });
        //console.log(neighbourhood);
        if(neighbourhood.length>0){
            neighbourhood.sort(function(a, b) {
            // Ascending: first  less than the previous
            return a.start - b.start;
            // TODO - could put something alphabtical in here....
        });
        var myplace = neighbourhood[0].arrayPosition;
        return myplace;

        }
        return false;
        //console.log(neighbourhood);
      
        //console.log(neighbourhood);


    }

   

    function hideMeMBox(){
        $("#membox").css('display','none');
    }
   
    function memDeselect(){
        $( ".ui-selectee" ).removeClass( "ui-selected" );
        $("#memcounter").find('strong').first().text('0');   
        $("#memcounter").find('span').first().css('display','inline');   
        $(".mem-deselect, .mem-groups, #memcounter .alert").css('display','none'); 
        itemstomove = [];
    }
    function cancelMassEditMode(keepopen){
        // * selectable not active
        //console.log('got here');
        $( selectableroot+ " > div" ).selectable( "destroy");
        itemstomove = [];
        $("#membox").removeClass('memactive');
        // all forms etc hidden
        if(typeof(keepopen)==='undefined'){
            $("#memcounter, #membox").css('display','none');            
        }
        // stuff is clickable to popups again
        activateChromClicks();
        if($("#showkl").prop("checked")){
            setTimeout(function(){
                showKeylines();
            },100);        
        }
        showHideMemButtons();
        //activateCpClicks();
    }      

    function showMeMBox(){
         initialiseMassEditMode();

        $("#membox").css('display','block');
    }

    function populateGroups(selector, exclude){        
        if(typeof(exclude)==='undefined'){
            exclude = '';
        }
        var options = getSortedGroupOptions('all', exclude);
        $("#"+selector).empty();
        $("#"+selector).append(options);
    }
    function initialiseMassEditMode(reinitialise){
        closePopups();
        selectableroot = setSelectableRoot();
        if(!$("[name='mem_status']").prop('checked')){
            $("[name='mem_status']").click();
        }
        //$("[name='mem_status']").bootstrapSwitch('state', true);
        //console.log($("[name='mem_status']").bootstrapSwitch('state'));
        $("#membox").addClass('memactive');
        if(typeof(reinitialise)==='undefined'){
            itemstomove = [];
        }
        if($("#chr").hasClass('searching')){
            clearSearch();
        }
        // this now appears to work. But might it be necessary to destroy and recreate? Not sure.
        hideKeylines();
        // turn off clicks for segs
         suspendCpClicks();
         $("#membox").draggable({
           /* containment: 'window',*/
            stop: function(event, ui){
                //$(this).css('bottom', 'auto');
            }
        }); 
        $("#membox").addClass('memactive');
//        var selectableroot = getSelectableRoot(); 
        $(selectableroot+" > div").selectable({
            stop: function( event, ui ) {
                itemstomove = [];                
                $(selectableroot+" div.ui-selected").each(function(){
                    var thisone = {}
                    if($(this).find('strong.match').length){
                        thisone.id = ($(this).find('strong.match').first().attr('data-id')).replace('match','');               
                        thisone.group = chromomapper[thisone.id].group;
                        itemstomove.push(thisone);
                    }
                });
                //console.log(itemstomove);
                var memcount = itemstomove.length;

                if(memcount==0){
                    $(".mem-groups, .mem-deselect").css('display','none'); 
                } 
                else {
                    $("#memcounter > strong").text(memcount);
                    if(memcount==1){
                        $("#memcounter").find('span').first().css('display','none');
                    }
                    else {
                        $("#memcounter").find('span').first().css('display','inline');
                    }

                    //if($("#memgroupid option").length==0 || (chromogroups.length +2) != $("#memgroupid option").length ){
                        var exclude = '';
                        if($("#groupdetail").hasClass('active')){
                            exclude = $("#detailgroupname").attr('data-group');
                        }
                        populateGroups('memgroupid', exclude);
                    //}
                    $(".mem-groups").css('display','block');
                    if($("#memgroupid").val()=='createnewgroup'){
                        $("#memgroupid").val('');
                    }
                    $(".mem-deselect").css('display','inline');
                    $("#memcounter .alert, .newgroupholder").css('display','none');
                }
                $("#memcounter > strong").text(memcount);
                },
            autoRefresh: true                
            });
        $("#memcounter").css('display','block');
        $("#memcounter > strong").text(itemstomove.length);
        $("#memcounter .alert").css("display","none");
        if(itemstomove.length==0){
            $(".mem-groups").css("display","none");
        }
        showHideMemButtons();

    }
    function suspendCpClicks(){  
    //, strong.match      
        $("#chr > .cp > div").unbind('click');
    }


    function navigateToGroup(action, skip) {
        var destination;
        $("#filterdatagroup").val('');

        // copy and sort chromogroups on order
        var groupsforsort = JSON.parse(JSON.stringify(chromogroups));
        for (var i in groupsforsort) {
            groupsforsort[i].arrayPosition = i;
        }       


        var activeItem = $("#editgroupbutton").attr('data-group');
        var activeItemOrder = chromogroups[activeItem].order;
       
        sortedgroups = groupsforsort.sort(function(a, b) {
            return parseInt(a.order, 10) - parseInt(b.order, 10);
        });
        var lastgroup = sortedgroups.length - 1; // took -1 off to account for order starting at 1


        destination = getDestination(action, activeItemOrder, sortedgroups, lastgroup)
        /*
        if(typeof(skip) !=='undefined'){
            if(action=='prev'){
                activeItemOrder = activeItemOrder-1;
            }
            else {
                activeItemOrder = activeItemOrder+1;
            }
           destination = getDestination(action, activeItemOrder, sortedgroups, lastgroup)
           console.log(destination);
        }
       */


        // if a destination is defined
        if (typeof(destination) !== "undefined") {


            // check if I've landed in a group that's supposed to be hidden
            // if so, go to the one before (action 'prev') or the one after (action 'next')
/*
            var hideunknown = hideUnknown();   
            var hideethnicity = hideEthnicity();  
            var isUnknown = chromogroups[destination].ancestor!=1 && (typeof(chromogroups[destination].spec)==='undefined' || chromogroups[destination].spec !='eth');
            var isEth = chromogroups[destination].spec=='eth';
            var groupisvisible = true;
            if(hideunknown && isUnknown){
               groupisvisible = false;
            }
            if(hideethnicity && isEth){
               groupisvisible = false;
            }     
           
            if(!groupisvisible){
                if(action =='prev'){
                    console.log('try to go to prev');
                    navigateToGroup('prev', true);
                }
                else{
                    console.log('try to go to next');
                    navigateToGroup('next', true);

                }
            }
*/




            viewGroupDetail(destination);
        }
    }


function resetFFFileInput(){
    $("#ff-file-warning").css('display', 'none');
    $("#import-ff-file").text('Import');
    $("#import-ff-file").prop('disabled', false);
    $("#import-ff-file").removeClass('loading');     
}

function setSelectableRoot(){      
        if($("#matchdetail").hasClass('active')){
            selectableroot = "#matchdetail .cp";
        }  
        else if($("#groupdetail").hasClass('active')){
            selectableroot = "#groupdetail .cp";
        } 
        else {
            selectableroot = ".cp-open";
        } 
                
    return selectableroot;
}
function processFFCSV(data, fileobject, ancestral){
    //console.log(ancestral);
    $("#ff-import-confirm").css('display', 'none');
    try {
        //var importdata = $.csv.toArrays(data, {onParseEntry: cleanftDNA});
         var importdata = $.csv.toArrays(data);

    }
    catch(err) {
        // reject non CSV files
        $("#ff-filecontent-warning-invalid").show();
        //console.log(err);
        resetFFFileInput();      
        return false;
    }

    var testfield1 = importdata[0][0];
    var testfield2 = importdata[0][5];
    var testfieldbucket = importdata[0][15];
    var eol = getEOL();
    if(testfield1 =='Full Name' && testfield2=='Relationship Range'){
        // we have the right file

        /*
        create a mat group and a pat group when needed
        get the group number of the ftdna group
        get the segments in this group

        loop through import data. 
        - get the match string from the file (Will need to replace double spaces with single and sanitise) 
        - and then change the group number of any segments that match to the value with the match in the chromomapper file

        for each one, field 9 is the Linked Relationship

        */

        var matgroup = '';
        var patgroup = '';
        var matgroupc = '#f69a89';
        var patgroupc = '#ce8578';

 //var groupsforkey = sortmyarray(chromogroups, 'order');
    var groupsforkey = JSON.parse(JSON.stringify(chromogroups));
    for (var i in groupsforkey) {
        groupsforkey[i].arrayPosition = i;
    }


        var ftdnagroups = groupsforkey.filter(function(groupsforkey){ 
            return (groupsforkey.name).substring(0,5) == 'ftDNA' 
        });


        var existing = [];
        for (var g in ftdnagroups){
            existing.push(parseInt(ftdnagroups[g].arrayPosition));
        }

        if(existing.length==0){
            $("#ff-nogroups-warning").show();           
            resetFFFileInput();      
            return false;
        }

        var ftdnasegs = [];
        for (var s in existing){
            ftdnasegs = $.merge(ftdnasegs, getGroupItems(existing[s]));
            //ftdnasegs.push(
            //   getGroupItems(existing[s])
            //);
        }
       /* var masterlist = [];
        for (var f in ftdnasegs){
            masterlist.push(ftdnasegs[f]);
        }*/

        //console.log(ftdnasegs);
        //console.log(masterlist);
        // go through each row


        // July 2021: figure out whether old or new version
        var bucketcol = 15;
        if(typeof(testfieldbucket)==='undefined'){
            bucketcol = 13;
        }

        var updatedsomething = false;
        for (var i in importdata){
            // format so it will match existing
            var thismatch = $.trim($.sanitize(importdata[i][0].replace('  ',' ')));
            // ignore if no bucket
            //console.log(importdata[i][15]);
            if(typeof(importdata[i][bucketcol])==='undefined'){
                continue;
            }
            var grouptouse = '';
            // set up the group this seg is going in; ignore if none
            if(importdata[i][bucketcol] =='Maternal'){
                if(matgroup==''){
                   matgroup = getOrCreateGroup(chromogroups, 'Maternal ftDNA matches', 'mat', matgroupc, 'ftdna');
                } 
                grouptouse = matgroup;
            } 
            else if (importdata[i][bucketcol] =='Paternal'){
                if(patgroup==''){
                   patgroup = getOrCreateGroup(chromogroups, 'Paternal ftDNA matches', 'pat', patgroupc, 'ftdna');
                }  
                grouptouse = patgroup;

            }
            else if(!ancestral) {
                continue;
            }
            //console.log(grouptouse);
            //console.log(thismatch);
            // figure out which segments need to be moved
            var segstoupdate = ftdnasegs.filter(function(ftdnasegs){
              //  console.log(ftdnasegs.match);
              //  console.log(thismatch);
                return ftdnasegs.match == thismatch;
            });
            //console.log(segstoupdate);
            var notes = '';
            if(ancestral){
                notes = $.sanitize(importdata[i][11]);
                nms = notes.split(' / ');
            }

            for (var s in segstoupdate){
                if(grouptouse!=''){
                    segstoupdate[s].group = grouptouse;
                }
                segstoupdate[s].notes += eol + notes;
             //   segstoupdate[s].nms = nms;                
                var updatedseg = chromomapper.indexOf(segstoupdate[s]);
                updatedsomething = true;
                
                removeSegment(updatedseg);
                // TODO - make this use my new function to paint it in place.
                printMatch(updatedseg, '#chr','', false);                  

            }        

            //$.trim($.sanitize
            //console.log(thismatch);
            //console.log(importdata[i][15]);
        }
        closeAndMark('import','imported');
        $("#open-settings").trigger('click');
        $("#ff-import-confirm").css('display', 'block');
        if(updatedsomething){
         drawKey();
            // TODO - put the number of segs update into a box reporting on it.
            writeDataToMap();  
            $("#ff-import-confirm-some").css('display', 'block');          
        }
        else {
            $("#ff-import-confirm-none").css('display', 'block');          
            
            /*console.log('no new ones');
            $("#ff-noupdate-warning").show();           
            resetFFFileInput();*/
            return false;

            //ff-seg-warning
        }


    }
    else {
        $("#ff-filecontent-warning").show();           
            if(testfield2=='Centimorgans'){
                $("#ff-seg-warning").show();        
            }
        resetFFFileInput();
        return false;
    }
   // console.log(importdata);
  

}


function openImport() {
    $('body').addClass('form-toggled');
    //$('#duplicate a.btn').attr('href','/api/maps/copy/'+accessKey+'/p/'+currentmap);
    $("#import .alert").hide();
    $("#dupetool-confirm").hide();
    if($("body").hasClass('user-is-touching')){
        $("#iwarning").css('display', 'block'); 
    }

    if(chromomapper.length>3999){
        $("#swcount").text(numberWithCommas(chromomapper.length));
        $("#sizewarning").css('display', 'block');         
    }
    $("#import").show();
}

function collapseCpanelItems(){
    $("#chrcontainer .cpanel > button").removeClass('active');
    $("#chrcontainer .cpanel > div").css('display','none');
    if($("#showcmslider").prop('checked')){
        $("#chrcontainer .cpanel > div.cmslidecontainer").css('display','inline-block');
    }    
}
function toggleCpanelItem(item, hide){
    if(item=='search' && $("#open-"+item).hasClass('active')){
        //console.log('clear searfch now');
        clearSearch();
    }  
    $("#open-"+item).toggleClass('active');
    
// clear search if closing search
    if(hide){
        $("#"+item+"panel").toggle();
    }
    else {
        $("#"+item+"panel").fadeToggle(200, "linear");
    }
}

function hasftDNAImportGroup(){
    for (var i in chromogroups) {
        if((chromogroups[i].name).substring(0,5) == 'ftDNA'){
            return true;
        }
    }
    return false;
}

function loadGroupOverlay(e, detailgroup){

        if($("#matchdetail").hasClass('active')){
            var matchslug = $("#detailmatchname").text();
        }
        if (!$(e.target).hasClass('edit') && !$(e.target).hasClass('dpclose')) {
            closeOverlays();
            if(typeof(matchslug)!=='undefined'){
                viewGroupDetail(detailgroup, matchslug);
            }
            else {
               viewGroupDetail(detailgroup);            
            }
        }
}

function closePopups(){
   // console.log('called');
   // console.log($(".popup"));
    //console.log('remove popped!');
    //console.log($(".cp strong.popped"));
    //setTimeout(function(){
        var clones = $(".cp").find('.clone');
       // console.log('removing '+clones.length+' clones');
       // console.log(clones);
        $(clones).remove();
    //},1);
    
    $(".popup").remove();
    $(".cp strong.popped, .cp div.popped").removeClass('popped');
}

function showNewMatchLink(match){
    $("#match-confirm a").attr('data-match', match);
    $("#match-confirm").css('display','block');
}
function resetCollapser(context){
    if(typeof(context)==='undefined'){
        context = 'body';
    }
    else {
        context = '#'+context;
    }
    $(context +" .collapse").collapse('hide');
    $(context + " .collapser").find('span').removeClass('glyphicon-minus').addClass('glypicon-plus');
}
function minimiseKey() {
    if (!$("#chrkey").hasClass('hidden')) {
        $("#keyarea ul, #chrfilter").addClass('hidden');
        $("#minkey").find('span').removeClass('glyphicon-minus').addClass('glyphicon-plus');
        $("#minkey").addClass('minimised');
    } else {
        $("#keyarea ul, #chrfilter").removeClass('hidden');
        $("#minkey").find('span').removeClass('glyphicon-plus').addClass('glyphicon-minus');
        $("#minkey").removeClass('minimised');
    }
}

function inMassEditMode(){
  
   // return $("input[name=mem_status]").prop('checked');
    return $("#membox").hasClass('memactive');
    //return $("#membox").css('display')=='block' && $("input[name=mem_status]").prop('checked');
}

function getCertaintyForMatch(match, matchitems){
    var avg = 0;


  $(matchitems).each(function(){
        var thisitem = $(this).attr('data-id');
        thisitem = thisitem.replace("match",""); 
        avg += parseInt(chromomapper[thisitem].certainty);
    });

   // console.log(avg);
   // console.log(matchsegments.length);
    //console.log(avg/matchitems.length);
    return Math.ceil(avg/matchitems.length)
}

function filterGroupsByString(){
    var currentval = $("#filter-groups").val();

    if(currentval ==''){
        filterKey(currentval);
    }
    else {
        setTimeout(function(){
            filterKey(currentval);
         }, 500);        
    }
          
}
function editSegment(segment){
        
        // experimental
        $(".chrdetailchromosome").remove();
        $(".viewmatchfromsegment, .editmatchfromsegment").css('display', 'block');
        if($("#groupdetail").hasClass('active')){
            $("#returnToGroup").val(1);        
        }
        else {
            $("#returnToGroup").val(0);        
        }
        if($("#matchdetail").hasClass('active')){
            $("#returnToMatch").val(1);        
        }
        else {
            $("#returnToMatch").val(0);        
        }

        if($("#chromodetail").hasClass('active')){
            $("#returnToChrom").val(1);        
        }
        else {
            $("#returnToChrom").val(0);        
        }        
        var thismatch = chromomapper[segment];
        $(".dpform .alert").hide();
        $("#newexistingmatchgroupname").val('');
        $(".newgroupholder").hide();
        $(".floater").hide();
        $("#chromosome").val(thismatch.chromosome);
        $("#start").val(thismatch.start);
        $("#end").val(thismatch.end);
        if (typeof(thismatch.match) !== 'undefined' && thismatch.match != '') {
            var mmname = (thismatch.match).replace('&quot;','"');
            $("#oldmn").val(thismatch.match);
            $("#match").val(mmname);
        } else {
            $("#match, #oldmn").val('Not specified');
            $(".viewmatchfromsegment, .editmatchfromsegment").css('display', 'none');
        }
        $("#cM").val(thismatch.cM);
        $("#SNPs").val(thismatch.SNPs);
        $("#notes").val(thismatch.notes);
        setupCertainty(parseInt(thismatch.certainty), "certainty");
        $("#thegroupnotes p").empty();

        if (chromogroups[thismatch.group].notes != '') {
            $("#thegroupnotes").show();
            var printnotes = nl2br(chromogroups[thismatch.group].notes);

            $("#thegroupnotes p").html(printnotes);
            if (chromogroups[thismatch.group].ancestor == 1) {
                $("#ancestor-or-group").text('ancestor');
            } else {
                $("#ancestor-or-group").text('group');
            }
        }
        $("#arrayPosition").val(segment);
        $("#currentGroup").val(thismatch.group);
        $("#currentChromosome").val(thismatch.chromosome);

        // populate select with options
        /*var options = '';


        $(chromogroups).each(function(index) {
            options += '<option value="' + index + '"';
            if (index == thismatch.group) {
                options += ' selected="selected"';
            }
            options += '>' + this.name + '</option>';

        });*/
        var options = getSortedGroupOptions('all', null, thismatch.group);

        $("#editseggroup").attr('data-group',thismatch.group);
        $("#currentsegside").text(sideFromString(chromogroups[thismatch.group].side));
        $("#currentseggroup").text(chromogroups[thismatch.group].name);


        if(typeof(thismatch.match)==='undefined'){
            thismatch.match = 'Not specified';
            mmname = 'Not specified';
        }

        //$(".editmatchfromsegment").attr('data-group',thismatch.group);
        //$(".editmatchfromsegment").attr('data-match',thismatch.match);
        $(".thematchname").text(mmname);

        $("#chromogroupfield").empty();
        $("#chromogroupfield").append(options);
        $('body').addClass('form-toggled');        
        $("#matchform").show();
}

function selectGroup(thisgroup){
      if($("#knownancestor").prop('checked')){
            $("#oldancestor").trigger('click');
            $("#existingancestor").val(thisgroup).trigger('change');          
        }
        else {
            $("#oldgroup").trigger('click');
            $("#existinggroup").val(thisgroup).trigger('change');
        }
}

function ftdForm(){
    closeOverlays();
    // put close popups in here
    $("#ftdform").show();
    $('body').addClass('form-toggled');    
}

function bucketForm(){
    closeOverlays();
    // put close popups in here
    $("#bucketform").show();
    $('body').addClass('form-toggled');    
}

function ethnicityForm(){
  closeOverlays();
  closePopups();
  $("#ethnicityform").show();
  $('body').addClass('form-toggled');
}

function saveEthnicity(){
    var ethdata = $("#ethnicitydata").val();
// test for CSV.  If we have CSV, let's replace the commas with tabs! (specifically looking for the 'copy')
    var csvFormat =  /([^,\n]+),([^,\n]+),([^,\n]+),([^,\n]+),([^,\n]+)/;
    if( csvFormat.test(ethdata)) {
        ethdata = ethdata.replace(/,/g, "\t");
        ethdata = ethdata.replace(/"([^\"]+)([\t])([^\"]+)"/g, "$1,$3");

    }
    // remove any blank lines
    //ethdata = ethdata.replace(/^\n/g, "");
    ethsegments = ethdata.trim().replace(/\t\n/g,"\n").split("\n"); // split into lines
    var tFormat = /(.+)chr(.+)/;
    if(!tFormat.test(ethsegments[0]) && !tFormat.test(ethsegments[1])){
        $("#ethnicity-none").show();
        return false;
    }

   // console.log(ethsegments);
   // console.log(ethsegments[1])
    
    var paternalCopy = ($("input[name=paternal-copy]:checked").val());
    //saveethnicity
    // split into rows



      // ethsegments = ethsegments.trim().split("\n"); // split into lines
        var currenttime = new Date($.now()); 
        var nowtime = currenttime.toLocaleTimeString();
        var now = currenttime.toLocaleDateString();
        now = now + ' '+nowtime;           
       var currentgrps = chromogroups.length;
       var currentsegs = chromomapper.length;
        for (m in ethsegments) {
            //console.log(ethsegments[m]);
            var matchelement = $.trim(ethsegments[m]).split("\t");
             //console.log(matchelement)
            
            matchelement = $.map(matchelement, $.trim);
            //console.log(matchelement)
            if(matchelement.length !=5){
                continue;
            }
            // 0 = group, 1 = copy, 3 = chr, 4 = start, 5 = end
            // get rid of header row (can do with chr check)
            var thisgroupside = '';
            var thiscopy = matchelement[1];

            //console.log(paternalCopy);
            if(paternalCopy==0){
                thisgroupside = 'both';
            }
            else if(paternalCopy==thiscopy){
                thisgroupside = 'pat';
            }
            else {
                thisgroupside = 'mat'; 
            }

            var thisgroup = '23andme '+matchelement[0];
            if(thisgroupside =='mat'){
                thisgroup += ' Maternal';
            }
            else if(thisgroupside =='pat'){
                thisgroup += ' Paternal';
            }
            //console.log(matchelement);
            var thischr = matchelement[2].replace('chr','');
            var thisstart = matchelement[3];
            var thisend = matchelement[4];
            // if the copies are assigned, create a mat or pat column; otherwise create a 'both' column.
          
            var thisnote = 'Copy '+thiscopy+' Chr '+thischr;
     // if col1 is not equal to currentgroup, create the group
     // add the segment (will need to parse 'chr' out of it)
      // also name the match 'copy1chr1'
     // set currentgroup to the group of this one
            if($.isNumeric(thischr) || thischr=='X' || thischr=='x'){
                // validate
                var newgroupindex = getOrCreateGroup(chromogroups, thisgroup, thisgroupside, null, '23andme', now, '','','eth');

                chromomapper.push({
                    "chromosome": thischr,
                    "start": String(numberWithoutCommas(thisstart)),
                    "end": String(numberWithoutCommas(thisend)),
                    "group": parseInt(newgroupindex),
                    "id": getIdentifier(),
                    "match": escape_quotes(thisgroup),
                    "notes": thisnote,
                    "certainty": 2
                });
            }
        }


        if(currentgrps>0 && currentgrps !=chromogroups.length){            
            var linegroup = chromogroups.filter(function(chromogroups){ return chromogroups.order == (currentgrps-1) });
            linegroup[0].gdivider = 1;
                //  return 

        }              
        printMatches('all');
        drawKey();
        // save 

        // print message
        var totalsegs = parseInt(chromogroups.length) - currentgrps;
        var totalgrps = parseInt(chromomapper.length) - currentsegs;
        $("#egroupcount").text(totalsegs);
        $("#esegcount").text(totalgrps);
         if(totalsegs==1){
            $("#eoneisegment").text('');
        }
         if(totalgrps==1){
            $("#oneegroup").text('');
        }


        $("#ethimport-confirm").show();
        writeDataToMap('all');
        closeAndMark('ethnicityform','imported');

}

function viewDuplicates(){
    $('body').addClass('form-toggled');
    //$('#duplicate a.btn').attr('href','/api/maps/copy/'+accessKey+'/p/'+currentmap);

    $("#dupes-removed").show();

}


function getMatchSide(matchname){
    var miboth = $(".matchdetailcontainer strong.sboth[data-match='"+matchname+"']");
    if(miboth.length){
        return 'both';
    }

    var mipat = $(".matchdetailcontainer strong.spat[data-match='"+matchname+"']");
    var mimat = $(".matchdetailcontainer strong.smat[data-match='"+matchname+"']");
    if(mipat.length && !mimat.length){
        return 'pat';
    }
    else if(mimat.length && !mipat.length){
        return 'mat';
    }
    return 'both';

}

function editMatch(match, option){
    $(".floater").removeClass('active').css('display','none');
    var matchitems = $(".matchdetailcontainer strong[data-match='"+match+"']")
    var myoption = false;
     if(typeof(option)!=='undefined'){
        myoption = option;
     }
     var thismatch = getMatchById(match);
     console.log(thismatch);
     var thismatchname = thismatch.name;
     var cformatch = getCertaintyForMatch(match, matchitems);

        setupCertainty(cformatch, "matchCertainty");
        $("#changegroup").prop('checked', false);
            $("#mmatchConfidence").prop('checked', false);
            $("#mmatchNotes").prop('checked', false);
            $("#matchNotesholder").hide();
            $("#matchdetailform").hide();
            $("#existinggroups").hide();
            $("#newgroupholder").hide();
            $("#newmatchgroupname").val('');
            $("#matchdetail-invalid").hide();
            $(".indmatch a").removeClass('active');
            $(".currentmatchname2").text(thismatchname);
            var thismatchside = getMatchSide(match);
            if(thismatchside=='both'){
                $("#cmmappedto").text('both your maternal and paternal ')
            }
            else if(thismatchside=='pat'){
                $("#cmmappedto").text('your paternal ')
            }            
            else if(thismatchside=='mat'){
                $("#cmmappedto").text('your maternal ')
            }   
            //var mymatchdata = getDataForMatch(matchname);
            //console.log(mymatchdata);
            //var currentcm = mymatchdata.sharedcm;


            var segmentstotal = $(matchitems).length;
            if(segmentstotal==1){
                segmentstotal = segmentstotal + ' segment';
            }
            else {
                segmentstotal = segmentstotal + ' segments';
            }

            $("#currentmatchname").html('<strong>'+thismatchname+'</strong><br />'+segmentstotal);

            if(typeof(thismatch.notes)!=='undefined' || thismatch.notes ==''){
                var matchnotestoedit = thismatch.notes;
              } else {  
                var mynotes
                     $(matchitems).each(function(){
                        var thisitem = $(this).attr('data-id');
                        thisitem = thisitem.replace("match","");

                        //console.log(chromomapper[thisitem]);
                        if(typeof(chromomapper[thisitem].notes) !=='undefined' && chromomapper[thisitem].notes!=''){
                            mynotes = chromomapper[thisitem].notes;
                        }                  
                    });
                var matchnotestoedit = mynotes;
            }

            $("#matchNotes").val(matchnotestoedit);



            //$("#currentsharedcm").attr('href','/tools/sharedcm/'+currentcm);
            //$("#currentsharedcm").text(currentcm+"cM shared");
            /*if(currentcm == 0){
                $("#currentsharedcm").css('display', 'none'); 
            }
            else {
                $("#currentsharedcm").css('display', 'block');
            }*/
            $("#segmentcount2, #segmentcount3").text(segmentstotal);
            if(segmentstotal > 1){
            $("#segmentcount2").text(segmentstotal);
                $("#segmentcount3").text('all '+segmentstotal);
            }
            else {
                $("#segmentcount3").text(segmentstotal);
            }

            $("#matchdetailname").val(thismatchname);
            $("#matchdetailoldname").val(thismatchname);

            // get all other groups and populate existinggroups
            var options = getSortedGroupOptions('all');

            //if(options.length){
                $("#existinggroups").empty().append(options);


        $("#matchCertaintySlider").prop('checked',false);
        $(".newgroupholder").hide();        
        $("#matchdetailform").show();
        if(myoption && myoption=='opennotes'){
            $("#mmatchNotes").click();
        }


}

function compare(a,b) {
  if (a.match < b.match)
    return -1;
  if (a.match > b.match)
    return 1;
  return 0;
}

function compareMatch(match, group){
  closeOverlays();
  closePopups();
            if(inMassEditMode()){
                cancelMassEditMode();
            }

  resetCollapser('newmatchform');
  $("#compareform > .inner > h2").text('Paint a Match');
  if(match !=''){
    thismatchname = getMatchById(match, 'name');
    $("#compareform > .inner > h2").text('Add segments for '+thismatchname);
  }
  // should their be other exceptions?
    if (typeof(examplemap) === "undefined" && typeof(newmatcharray)==='undefined') {
        $("#comparedata").val('');
    }
  $("#compareform").show();
  $("#emn").val(match);
  $("#egr").val(group);
  $("#overlay-confirm").hide();
  $("#chrcontainer").removeClass('overlaying');
  $("#overlay-confirm-none").hide();
  $('body').addClass('form-toggled');
}

function clearChromosome(chrom){
    $("#p"+chrom +"> div").empty();
}

function printChromosomeMatches(chrom, group, container){
    // make two strings - one for mat and one for pat
   // console.log('doing '+chrom);
    var cmat = [];
    var cpat = [];
    var cboth = [];
    cboth.length = 0;
    cpat.length = 0;
    cmat.length = 0;
    //console.log($(container).innerHTML);

    //console.log(cboth);
    // filter chromomapper to get just this chrom
    if(typeof(group)!=='undefined'){        
        var chromItems = getGroupItems(group, chrom);
        var context = '.groupdetailcontainer';
    }
    else{
        var chromItems = getGroupItems(null, chrom);
        var context = '#chr';
    }
    //console.log(context);
    if(typeof(container)!=='undefined'){
        context = container;
    }
    //console.log(chromItems);
     for (var i in chromItems) {
        var match = chromItems[i];
        //console.log(match);
        //  protect against the group not existing.
        if(typeof(chromogroups[match.group])==='undefined'){
            continue;
        }
        if (chromogroups[match.group].side == 'both') {
            //console.log('here');
            cboth[i] = printMatch(chromItems[i], context, '', '', true); 
        }
        else if (chromogroups[match.group].side == 'mat') {
            cmat[i] = printMatch(chromItems[i], context, '', '', true);
        }    
        else if (chromogroups[match.group].side == 'pat') {
            cpat[i] = printMatch(chromItems[i], context, '', '', true);
        } 
        //detailGroups.push(parseInt(match.group));
        //printMatch(match, context);
    }
    //console.log(cboth);
    // appends each to the relevant place
    //$(context + "#p" + match.chromosome + " div." + thisgroup.side).append    


    //console.log(cboth);
    if(typeof(container)!=='undefined'){
        if(cboth.length >0){
            $(container).find("#p" + chrom + " div.both").append(cboth.join(''));
        }
        if(cmat.length >0){
            $(container).find("#p" + chrom + " div.mat").append(cmat.join(''));        
        }
        if(cpat.length >0){
            $(container).find("#p" + chrom + " div.pat").append(cpat.join(''));
        }      
    }    
    else {
        if(cboth.length >0){
            $(context+" #p" + chrom + " div.both").append(cboth.join(''));
        }
        if(cmat.length >0){
            $(context+" #p" + chrom + " div.mat").append(cmat.join(''));        
        }
        if(cpat.length >0){
            $(context+" #p" + chrom + " div.pat").append(cpat.join(''));
        }
    }
    // if cmat etc have length > 0, append them

}

function mergeGroups(group, destination) {
    // take all segments in group
    //console.log(group);
    var items = getGroupItems(group);
    //var olditems = JSON.parse(JSON.stringify(items));
    // remove them from the display
    //console.log(items);
    //console.log(olditems);
    var oldgroup = group;
    //removeMatches(oldgroup);
    
    // change their group to destination
    $(items).each(function(i) {
        items[i].group = destination;
    });
    var oldgroupname = chromogroups[group].name;
    var oldgroupnotes = chromogroups[group].notes;
    // delete 'group'

    destination = deleteGroup(group, true, destination);
    // add a note to destination
    if(typeof(chromogroups[destination].notes) !=='undefined'){
        chromogroups[destination].notes +='\n'+oldgroupname+'  was merged into this group';
    }
    else {
        chromogroups[destination].notes =oldgroupname+ ' was merged into this group';
    }
    chromogroups[destination].notes +='\n\n'+oldgroupnotes;
    // save this deletion
    var newgroupitems = getGroupItems(destination);
    writeDataToMap();
    
    drawKey();
   // setTimeout(function(){
    //TODO - this could be improved. I need to redraw a set of items
    printMatches('all');
     //     },100);    

    loadLocalSettings();
    closeOverlays();
    setTimeout(function() {
        viewGroupDetail(destination);
        adjustMatchNames( '.groupdetailcontainer', '#groupdetail');
        adjustMatchNames( "#chr");

    },500);
    $(".mergegroup").text('Merge');
    $(".mergegroup").prop('disabled', false); 
    $(".merge-groups").hide();
    $("#merge-flash").html('Group "'+oldgroupname+'" merged into group "'+chromogroups[destination].name+'"').delay(500).fadeIn().delay(7000).fadeOut();

}
function sideFromString(string){
    if(string=='pat'){
        return 'paternal';
    }
    else if(string=='mat'){
        return 'maternal';
    }
    else {
        return 'not known or shared';
    }
}


/*
function openSettings(){
  // THIS IS THE PROFILE COMPARISON STUFF 

  closeOverlays();
  $(".cp strong").removeClass('popped');
  $(".popup").remove();
  $("#settings").show();
   $("#pbc").sortable({
        revert: 'invalid',
        handle: 'em.grippy',
        helper : 'clone',
        placeholder: 'ui-sortable-placeholder',
        forceHelperSize: true
    });
  $('body').addClass('form-toggled');
}*/


function deleteGroup(deletinggroup, contents, groupofinterest){
 // get the order of the group being deleted
 // new - lets you add a group of interest so you can return the new number for it.
        var removedOrder = chromogroups[deletinggroup].order;
        var g = chromogroups.length;
        while (g--) {
            var currentOrder = parseInt(chromogroups[g].order);
            if (currentOrder > removedOrder) {
                chromogroups[g].order = parseInt(currentOrder) - 1;
            }
        }
        // remove this group from chromogroups

        chromogroups.splice(deletinggroup, 1); // working
        // remove this group from the key

        // remove all items in this group from chromomapper; reduce the group number by 1 for any that have a group higher
        // this is the most likely culprit
        // this was a daft piece of code because by default if you are deleting the group, you're deleting its contents
        // so what was happening to Michelle is that the group was being deleted, so all the other groups were changing order, but the items weren't being renumbered
        // TODO - remove 'contents'!  Meanwhile, have changed to 'true' in import.
            var i = chromomapper.length;
            var lowestindex = '';
            while (i--) {
                var currentgroup = parseInt(chromomapper[i].group);
                if (currentgroup == deletinggroup) {
                    // console.log('deleting '+i);
                    // console.log(chromomapper[i]);
                    chromomapper.splice(i, 1); // delete and reset array
                    // have to remove match now
                    removeSegment(i);
                    lowestindex = i;
                } else if (currentgroup > deletinggroup) {
                    chromomapper[i].group = parseInt(currentgroup - 1);
                    if(typeof(groupofinterest)!=='undefined'){
                        if(currentgroup==groupofinterest){

                            var returngroupofinterest = parseInt(currentgroup - 1);
                        }
                    }
                } 
            }
            if(typeof(returngroupofinterest)!=='undefined'){
                // return updated version if exists
                return returngroupofinterest;
            }
            else if(typeof(groupofinterest)!=='undefined'){
                // or return original if passed and not updated
                return groupofinterest;

            }
            return lowestindex;
            // unless otherwise specified, return the lowest segment

}

function openShare() {
    $('body').addClass('form-toggled');
    var displaystatus = 'private';
    if (share_status == 'readonly') {
        displaystatus = 'shared';
        $("[name='share_status']").prop('checked', true);
    }
    $("#mapsharestatus").text(displaystatus);
    $("#sharelink").hide();
    var clipboard = new Clipboard('.clip');
    clipboard.on('success', function(e) {
        $("#copied-flash").delay(500).fadeIn().delay(2500).fadeOut();
    });
    clipboard.on('error', function(e) {
        $("#copied-flash-ctrl").delay(500).fadeIn().delay(2500).fadeOut();
    });


    $("#shareURL").val('https://dnapainter.com/map/view/' + accessKey);
    if (share_status == 'readonly') {
        $("#sharelink").show();
    }
    $("[name='share_status']").bootstrapSwitch({
        onText: 'Shared',
        offText: 'Private',
        onSwitchChange: function(event, state) {
            if (state === true) {
                $("#sharelink").show();
                share_status = 'readonly';
                displaystatus = 'shared';

            } else {
                $("#sharelink").hide();
                share_status = 'private';
                displaystatus = 'private';

            }
            $("#mapsharestatus").text(displaystatus);
            updateShareStatus(state);
        }
    });
    $("#share").show();
}

function shorten(str, maxLen, separator) {
  //if (str.length <= maxLen) return str;
  if(typeof(separator)==='undefined'){
    separator = ' ';
  }
  if (!str || str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen));
}

function collapseAllChroms(){
    var allchroms = $("#chr > h4");

    $(allchroms).each(function(){
        if($(this).hasClass('expanded')){
            collapseChromosome($(this));                  
        }
    });    
}


function getFloaterWidth(){
    var floaterWidth = .8;
      if($("body").width()<=840){
        floaterWidth = .9;
      }
      if($("body").width()<=767){
        floaterWidth = 1;
      }
    return floaterWidth;   
}

function getMbScaleDiv(numberNeeded){
    var divstring = '<span class="mbscale">';
            count = 1;
            while (numberNeeded >=0){
                divstring +='<span>'+count*10+'mb</span>';
                numberNeeded--;
                count++;
            }
            divstring +='</span>';
    return divstring;
}
function setUpSlider(){
    var slider = document.getElementById("cmDisplayThreshold");
    var output = document.getElementById("cmDisplayAmount");
    //slider.setAttribute('data-cm-val',slider.value);
    slider.oninput = function() {
      output.innerHTML = this.value+'cM';
      hideSegmentsBelow(this.value);
    }
}

function filterSegmentsIfNecessary(){
    if($("#showcmslider").prop('checked')){
        hideSegmentsBelow($("#cmDisplayThreshold").val());
    }
}
function hideSegmentsBelow(value){
    value = parseInt(value);
    if(isNaN(value)){
        return;
    }
    $("strong[data-cm]").filter(function(){
        return parseFloat($(this).attr("data-cm")) < value;
    }).parent().css('display','none');
    $("strong[data-cm]").filter(function(){
        return parseFloat($(this).attr("data-cm")) >= value;
    }).parent().css('display','block');
    $(".cmreminder").html('Segments &lt; <strong>'+value+'cM</strong> are currently hidden');
    $("#matchdetail .cmreminder").html($("#matchdetail .cmreminder").html() +' <br /><em>This does not apply to overlapping segments displayed via the switch below</em>');
    //setTimeout(function(){
        reHideHiddenGroups();
    //},100);
}

function setUpMBLinesDetail(){
   $("#chr-detail .mbscale").remove();
   var myUnit = $("#chr-detail .cp").width()/($("#chr-detail .chrdetailchromosome").attr('data-length')/10000000);
   var numberNeeded = Math.floor(($("#chr-detail .chrdetailchromosome").attr('data-length')/10000000)-1);
   var floaterWidth = getFloaterWidth();
   var divstring = getMbScaleDiv(numberNeeded);           
   $("#chr-detail .cp").append(divstring);
   $("#chrdetail_style").remove();
    var mbStyle = "<style id=\"chrdetail_style\">                   \n                    .gshowmblines #chr-detail .mbscale span:first-child {\n                        margin-left: ".concat(myUnit / 2, "px\n                    }\n                    .gshowmblines #chr-detail .mbscale span {\n                        display:inline-block;\n                        width: ").concat(myUnit, "px;\n                        text-align:center\n                    }                  \n                     .gshowmblines #chr-detail .cp > div {                        \n                        background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'><defs><pattern id='pattern_2RWUpR' patternUnits='userSpaceOnUse' width='").concat(myUnit, "' height='1' patternTransform='rotate(0)'><line x1='").concat(myUnit, "' y='0' x2='").concat(myUnit, "' y2='").concat(myUnit, "' stroke='%23989898' stroke-width='1'/></pattern></defs><rect width='100%' height='100%' fill='url(%23pattern_2RWUpR)' opacity='1'/></svg>\") !important;\n                     }\n                                     \n                </style>\n                    ");

    document.head.insertAdjacentHTML('beforeend', mbStyle);
    
}

function setUpMBLines(resizeOnly){
    if(typeof(resizeOnly)==='undefined'){
        resizeOnly = false;
    }
      var myUnit = $("#chr #p1").width()/$("#chr #p1").attr('data-length')*10000000;
      var floaterWidth = getFloaterWidth()
      
      if(resizeOnly){
         $("#mainmb_style").remove();
      }
      else {
         var numberNeeded = Math.floor(($("#chr #p1").attr('data-length')/10000000)-1);
         var divstring = getMbScaleDiv(numberNeeded);           
         $(".cp").append(divstring);
      }

    var myUnit2 = ((floaterWidth * $("body").width()) - 98)/$("#p1").attr('data-length')*10000000;                 
    var mbStyle = "<style id=\"mainmb_style\">.gshowmblines .mbscale span:first-child {\n                        margin-left: ".concat(myUnit / 2, "px\n                    }\n                    .gshowmblines .mbscale span {\n                        display:inline-block;\n                        width: ").concat(myUnit, "px;\n                        text-align:center\n                    }\n                  \n                     .gshowmblines .cp-open > div {                        \n                        background:#f6f6f6 url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'><defs><pattern id='pattern_2RWUpP' patternUnits='userSpaceOnUse' width='").concat(myUnit, "' height='1' patternTransform='rotate(0)'><line x1='").concat(myUnit, "' y='0' x2='").concat(myUnit, "' y2='").concat(myUnit, "' stroke='%23989898' stroke-width='1'/></pattern></defs><rect width='100%' height='100%' fill='url(%23pattern_2RWUpP)' opacity='1'/></svg>\") !important;                        \n                     }\n                     .gshowmblines .cp-open .mat {\n                        background-color: #f9ecee !important\n                     }\n                    .gshowmblines .cp-open .pat {\n                        background-color: #eef1f5 !important\n                     }\n                    .gshowmblines .chrdetailchromosome > .cp > div, .gshowmblines #chr-detail .cp > div {                        \n                        background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'><defs><pattern id='pattern_2RWUpQ' patternUnits='userSpaceOnUse' width='").concat(myUnit2, "' height='1' patternTransform='rotate(0)'><line x1='").concat(myUnit2, "' y='0' x2='").concat(myUnit2, "' y2='").concat(myUnit, "' stroke='%23989898' stroke-width='1'/></pattern></defs><rect width='100%' height='100%' fill='url(%23pattern_2RWUpQ)' opacity='1'/></svg>\") !important;\n                     }\n                    .gshowmblines .chrdetailchromosome  .mbscale span:first-child {\n                        margin-left: ").concat(myUnit2 / 2, "px\n                    }                     \n                    .gshowmblines .chrdetailchromosome .mbscale span {\n                        display:inline-block;\n                        width: ").concat(myUnit2, "px;\n                        text-align:center\n                    }                     \n\n                </style>\n                    ");
    document.head.insertAdjacentHTML('beforeend', mbStyle);
}


function collapseChromosome(chrom){ 

    var goto = false;
    if($(chrom).hasClass('expandedf')){
        goto = 'p'+chrom.text();
    }
    $(chrom).removeClass('expanded expandedf');
     

    var thischrom = $(chrom).next();
    //console.log($(chrom));       
    //console.log($(thischrom));      
    $(thischrom).removeClass('cp-open');
    showHideMemButtons();
    if(goto){
        var scrollto = $('#'+goto).offset().top-20;
        $('html, body').animate({
                scrollTop: scrollto               
            }, 400);
        //console.log(goto);
    }
    //var openchroms = $("#chr h4.expanded");
    //if($(openchroms).length ==0){
    //    $("#fchrmatchlabel").removeClass('floating').hide();         
   // }
        //console.log($(thischrom));      
        // unwrap stuff removed from here
    // var currentchrom = (thischrom[0].id).replace('p','');
     // do i need this?
   // $("#p"+currentchrom+' span').attr('style','');
}

function expandChromosome(chrom){
//console.log('called');        
    var thischrom = $(chrom).next();
    var currentchrom = (thischrom[0].id).replace('p','');   

    $("#p"+currentchrom+" span.swr").remove();
    $(chrom).addClass('expanded');
    $(thischrom).addClass('cp-open');
    //$("#fchrmatchlabel").css('display', 'block').addClass('floating');
    //Class('floating').hide(); 
   
   // chrlabel stuff removed
    if($("#showkl").prop('checked')){
        showKeylines();
    }
    adjustMatchNames( "#p"+currentchrom, '#chr');
    showHideMemButtons(); 

}

function loadTraitsKey(){
    var keyhtml = '';
    var groupsforkey = JSON.parse(JSON.stringify(traitgroups));
    groupsforkey.sort(function(a, b) {
         return (a.name > b.name) ? 1 : -1  
        });



    for(var i in groupsforkey){
        var thiscol = groupsforkey[i].color;
        var thisname = groupsforkey[i].name;

       keyhtml += '<li><strong style="opacity:0.9;background: repeating-linear-gradient(45deg,'+thiscol+','+thiscol+' 2px,#999 3px,#999 3px) !important"></strong><span>'+thisname+'</span></li>';

    }
    $("#traitskey").empty().append(keyhtml);
}
function showTraits(){
    if(!$("#maincontent").hasClass('showtm')){
        $("#maincontent").addClass('showtm');
            
    }
    else {
        
    }

    /*var showtraits = 1;
    if(getFieldValue("closetraits") && getFieldValue("closetraits")==1){
        showtraits = 0;
    }
    if(showtraits==1){
        $("#traits-intro").css('display','block');
    }
    else {
    }*/
    $("#open-traits").css('display','inline-block');

    loadTraitsKey();   

    var c = 1;
        while(c < 23){
            loadTraitSegments(c, 'chr');
            c++;
        }
        loadTraitSegments('X', 'chr');
}

function loadTraitSegments(chrom, context){
    // keeping in in case want to load elsewhere in future
    if(typeof(context)==='undefined'){
        context = 'chr';
    }    
    $('#'+context+" #p" + chrom +" .trait").remove();

    var segstoprint = JSON.parse(JSON.stringify(traits));
    if(segstoprint.length==0){
        return false;
    }    
    for (var i in segstoprint) {
            segstoprint[i].arrayPosition = i;
    }

    segstoprint = segstoprint.filter(function(segstoprint) {
            return segstoprint.chromosome == chrom
        });
        var traitsegs = '';
        if (segstoprint.length > 0) {
            for (var i in segstoprint) {
                traitsegs += printTraitSegment(segstoprint[i].arrayPosition, context, true);                
            }
            // assuming both for simplicity
            //traitsegs = '<div class="trait">'+traitsegs+'</div>'
            $('#'+context+" #p" + chrom + " div.both").append(traitsegs);
        }
   
    return segstoprint;    
}

function getTraitGroup(id){
    return traitgroups[id];

}
function printTraitSegment(seg, context, returndata) {
    // print a trait using the array index or the array item
    // if match isn't an array, it's an index - use this to get the array
    if ((typeof seg !== "object")) {
        var seg = traits[seg];
    }
    if (typeof(context) === 'undefined' || !context ) {
        var context = '';
    }
    else {
        context = "#"+context+' ';       
    }

    var position = traits.indexOf(seg);
    var thisgroup = getTraitGroup(seg.group);
    if (thisgroup && typeof(thisgroup) != 'undefined') {
        var traitstring = "<div class='trait'><strong class='trait tg" + seg.group + "' data-id='tr" + position + "' style='" + getPosition(seg.chromosome, seg.start, seg.end, thisgroup.order) + ";background: repeating-linear-gradient(45deg,"+thisgroup.color+","+thisgroup.color+ " 2px,#999 3px,#999 3px) !important'><span>" + seg.genename + ": "+ seg.name +"</span></strong></div>"

        if(typeof(returndata)==='undefined'){
            setTimeout(function() {
                $(context+"#p" + seg.chromosome + " div." + thisgroup.side).append(traitstring);
            },50);
        }
        else {
            //console.log(fixedmatchstring);
            return traitstring;
        }

    }
}




function hideTraits(){
    $("#maincontent").removeClass('showtm');
    $("#traits-intro, #open-traits").css('display','none');
    $(".trait").remove();
    // tbc - could just do it with the showtm class and just show and hide them.
    // might make more sense.    
}


function enableControlF(){
    //console.log('yeah');
    if(chromomapper.length > 2000){
        $("#maincontent").addClass('enablecf');
           // removeMatches('all');
        setTimeout(function(){
            printMatches('all');
        },100);      
    }
}
function disableControlF(){
     $("#maincontent").removeClass('enablecf');
     //removeMatches('all');

     printMatches('all');

}

function hideKeylines(){
    $("#maincontent").removeClass('showkl');
    $('.cp-open, .chrcontainer').unbind('mousemove');
}

function showSlider(){
    $(".cmslidecontainer, .cmreminder").css('display','inline-block');
    $("#cmsliderconfig").css('display','block');
    hideSegmentsBelow($("#cmDisplayThreshold").val());
    //setTimeout(function(){ 
      //              },200);
}

function hideSlider(){
    $(".cmslidecontainer, .cmreminder, #cmsliderconfig").css('display','none');
    $("strong[data-cm]").parent().css('display','block');      
}

function showKeylines(){
    if(!$("body").hasClass('user-is-touching')){
        if(!$("#maincontent").hasClass('showkl')){
              $("#maincontent").addClass('showkl');
        }
        $(".cp-open").mousemove(function( event ) {
            var parentc = $(this).attr('id');
            var myoffset = $(this).offset();
            var offsetpx = event.pageX-myoffset.left;
            var klv = getKlValue(parentc,offsetpx);
            var offsettoppx = event.pageY-myoffset.top-40;            
            var ww = $(window).width();           
            if(parseInt(klv) <= parseInt($(this).attr('data-length'))){ 
                var mkr = $(this).find('.mkr');
                $(mkr).css('left', offsetpx);
                $(mkr).css('paddingTop', offsettoppx+'px');                
                if(ww-offsetpx >150){
                    $(mkr).attr('data-content', klv);
                    $(mkr).removeAttr('data-precontent');
                }
                else {
                    $(mkr).attr('data-precontent', klv);                    
                    $(mkr).removeAttr('data-content');
                }               
            }
        });
        $(".chrcontainer").mousemove('.cp', function( event ) {
            var parentc = $(event.target).closest('.chrdetailchromosome').attr('id');            
            var myoffset = $(this).offset();
            var chroffset = $("#"+parentc).offset();
            var offsetpx = event.pageX-myoffset.left-34;
            if($("#chromodetail").hasClass('active')){
               offsetpx = event.pageX-myoffset.left-24; 
            }
            var klv = getKlValue(parentc,offsetpx,'.chrcontainer');
            var offsettoppx = 0;
            if(typeof(chroffset)!=='undefined'){
                offsettoppx = event.pageY-chroffset.top-11;
            }
            var ww  = myoffset.left-100+$("#"+parentc).parent().width();

            if(parseInt(klv) <= parseInt($('.chrdetailchromosome#'+parentc).attr('data-length'))){
                var mkr = $(".chrcontainer #"+parentc).find('.mkr');
                $(mkr).css('left', offsetpx);
                $(mkr).css('paddingTop', offsettoppx+'px');

                if(ww-offsetpx >150){             
                    $(mkr).attr('data-content', klv); 
                    $(mkr).removeAttr('data-precontent');

                } else {
                    $(mkr).attr('data-precontent', klv);
                    $(mkr).removeAttr('data-content');
                }
            }
        }); 

    }
}

function getKlValue(chr, offsetpx, context){    
    // get the width of the chr in pixels
    if(typeof(context)==='undefined'){
        var chrw = $('#chr #'+chr).width();    
    }
    else {
        var chrw = $(context + ' #'+chr +' .cp').width();    // fix nov 2021 to add .cp    
    }

    // get the data-length of the chr
    var dl = $('#'+chr).attr('data-length');
    // 

    var myn = ((offsetpx/chrw)*dl).toFixed(0);
    if(myn<0){
        return 0;
    }

    if(parseInt(myn) > parseInt(dl)){
        return '';
        return numberWithCommas(dl);
    }
    return numberWithCommas(myn);
    // return offset/width * data-length

}

function adjustMatchNames(elem, context){
    var viewportwidth = $( window ).width();
    if(typeof(context)!=='undefined'){
        viewportwidth = $(context).first().width();
    }

   // console.log(typeof(elem));
    // if there are more than 1200 segments, run it just onthe first two chroms
    if(chromomapper.length > 1200 &&  elem.substring(0,2)!='#p'){
        elem = $(elem + ' #p1 strong,'+elem + ' #p2 strong'); 
    }
    else if(elem.substring(0,6)!='strong') {
        elem = $(elem +' strong');
    }
    else {
        elem = $(elem);
    }
      elem.each(function(i){
           var leftpos = $(this).position().left;
           var strongwidth = $(this).width();
           var span = $(this).find('> em');
           if($(this).hasClass('trait')){
            span = $(this).find('> span');
           }
          // console.log($(span)[0]);
           var spanwidth = ($(span[0]).width());
         

           if((leftpos+strongwidth+spanwidth) > (viewportwidth-80) ){
           // console.log('got in');
            if(strongwidth+200 < viewportwidth){
                if($(this).hasClass('trait')){                
                    $(this).addClass('cutoff-right');
                }
                else {
                    $(span).attr('style', 'left:auto; right:'+(strongwidth+2)+'px');
                }
            }
            else {
                $(span).attr('style', 'left:auto;');
            }
           }
        });
}
function addNewGroup(pushto, name, side, color, notes, ancestor, position, spec){
    // ADDED - 'sanitize' would have choked on this if somehow it was empty (Belt and braces!)
    if(typeof(name)==='undefined'){
        name = 'Untitled';
    }  
    if(typeof(position)==='undefined'){
        position = 'start';
    }    
    // initalise if not set
    if(typeof(side)==='undefined'){
        side = 'both';
    }
    if(typeof(color)==='undefined'){
        color = '#000000';
    }
    if(typeof(notes)==='undefined'){
        notes = '';
    }
    if(typeof(ancestor)==='undefined'){
        ancestor = 0;
    }
    //add the new group to chromogroups and return the id
    // iterate through chromogroups and raise the order by 1 so we can make this the first
    if(position=='start'){
        for (var i in pushto) {
            pushto[i].order = parseInt(pushto[i].order) + 1;
        }
    }
    newgroupindex = (pushto.push({
        "name": $.sanitize(name),
        "side": $.sanitize(side),
        "color": $.sanitize(color),
        "notes": $.sanitize(notes),
        "ancestor": ancestor
            })) - 1;
    if(position=='start'){
        pushto[newgroupindex].order = 0;
    }
    else {
        pushto[newgroupindex].order = parseInt(newgroupindex);
    }
    if(typeof(spec) !=='undefined'){
        pushto[newgroupindex].spec = spec;
    }
    return newgroupindex;
}  

function addNewSegment(pushto, chr, match, start, end, cms, snps, group, certainty, notes, identifier){
    if(typeof(identifier)=='undefined'){
        identifier = getIdentifier();
    }
   //nm[chrfield] = nm[chrfield].replace(/\"/g,'');
   //console.log(chr);

                pushto.push({
                    "chromosome": $.sanitize($.trim(chr)),
                    "start": String(numberWithoutCommas(start)),
                    "end": String(numberWithoutCommas(end)),
                    "group": parseInt(group),
                    "id": identifier,
                    "cM": String(numberWithoutCommas(cms,1)),
                    "SNPs": String(numberWithoutCommas(snps)),
                    "notes": notes,
                    "match": escape_quotes($.trim($.sanitize(match))),
                    "certainty": parseInt(certainty)
                });
                 //console.log(pushto);

}          

function editGroup(thisgroup){
        var editgroup = chromogroups[thisgroup];
        closePopups();
        $('body').addClass('form-toggled');
        $('.floater').hide().removeClass('active');
        if(typeof(editgroup.ancestor)!== 'undefined' && editgroup.ancestor == 1){
        //if(editgroup.hasOwnProperty(ancestor)){
            $("#ancestor").prop('checked', true);
        } else {
            $("#ancestor").prop('checked', false);
        }
        if(typeof(editgroup.gdivider)!== 'undefined' && editgroup.gdivider == 1){
        //if(editgroup.hasOwnProperty(ancestor)){
            $("#gdivider").prop('checked', true);
        } else {
            $("#gdivider").prop('checked', false);
        } 
        if(typeof(editgroup.spec)!== 'undefined' && editgroup.spec == 'eth'){
        //if(editgroup.hasOwnProperty(ancestor)){
            $("#ethnicityg").prop('checked', true);
        } else {
            $("#ethnicityg").prop('checked', false);
        }        
        $("#groupArrayPosition").val(thisgroup);
        //$("#groupid").val(editgroup.id);
        $("#groupname").val(editgroup.name);
        $("#grouporder").val(editgroup.order);
        $("#groupside").val(editgroup.side); // check if this works in all browseres
        $("#groupcolor").val(editgroup.color);
        $("#groupnotes").val(editgroup.notes);
        $("#groupConfidence").prop('checked', false);      
        $("#groupform .open-group").attr('data-group', thisgroup);
        initialiseColorPicker('groupcolor', editgroup.color);
        $("#groupform").show();
        setupCertainty(3, "groupCertainty");
}

function updateAllGroups(side){
    //console.log('editing all groups to '+side);
    for(var i in chromogroups){
        chromogroups[i].side = side;
    }
    //console.log(chromogroups);
    printMatches('all');
}

function openTransformGroups(side){
    $('body').addClass('form-toggled');
    var mytext = 'unknown or both';
    if(side =='mat'){
        mytext = 'maternal';
    }
    else if(side=='pat'){
        mytext = 'paternal';
    }
    $("#transform-groups strong").text(mytext)
    $("#transform-groups").css('display', 'block');

    $("#tgbtn").attr('data-side', side);

}
function openDuplicate() {
    $('body').addClass('form-toggled');
    $('#duplicate a.btn').attr('href','/api/maps/copy/'+accessKey+'/m/'+currentmap);
    $("#duplicate").show();
}

function openDupeTool() {
    $('body').addClass('form-toggled');
    $("#run-dupetool").removeClass('loading');
    $("#run-dupetool").text('Remove Duplicate Segments');    
    $("#dupetool").show();
 
}



function byMatchName(a,b) {

   var nameA = a.toUpperCase();
            var nameB =  b.toUpperCase();
            var comparison = 0;           
              // sort alphabetically
            comparison = (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;            
            return comparison;


}

function byMatchNameOther(a,b){
    return a.match.localeCompare(b.match);
}
function indexOfMax(arr) {
    if (arr.length === 0) {
        return -1;
    }

    var max = arr[0];
    var maxIndex = 0;

    for (var i = 1; i < arr.length; i++) {
        if (arr[i] > max) {
            maxIndex = i;
            max = arr[i];
        }
    }

    return maxIndex;
}

function chooseSegsToDelete(segstoconsider){

/*
1. the duplication logic needs to decide which one to duplicate by checking
    1. are they in a maternal/paternal group or a both. Favour mat/pat
    2. do they have notes or not. favour having notes.
    3. does the group have 'myheritage, ftdna' etc in title. favour not having it in there.
*/
if(segstoconsider.length){
  //  console.log(segstoconsider.length);
    var scores = [];
  //  console.log(segstoconsider);
    var notestosave = '';
    for(var i = 0; i < segstoconsider.length; i++){
    //    console.log(i);
        //console.log(this[i]);
       // console.log(segstoconsider[i]);
        scores[i] = 0;
        var thisgroup = segstoconsider[i].group;
        //console.log(chromogroups[thisgroup].side);
        if(chromogroups[thisgroup].side !='both'){
            scores[i] +=6;
        }
        if(chromogroups[thisgroup].ancestor ==1){
            scores[i] +=3;
        }        
        if((chromogroups[thisgroup].name).indexOf(' Matches ') ==-1){
            scores[i] +=3;
        }        
        if($.trim(segstoconsider[i].notes) !=''){
            //scores[i] +=5; don't use notes for score since imported files have notes
            if($.trim(segstoconsider[i].notes)!=notestosave){
                notestosave+= $.trim(segstoconsider[i].notes);
            }
        }
    }
    //console.log('scores are');
    //console.log(scores);
    var highestscore = indexOfMax(scores);
    if(segstoconsider[highestscore].notes !=notestosave && notestosave !=''){
        notestosave = notestosave.replace(segstoconsider[highestscore].notes,'');
        var thisindex = segstoconsider[highestscore].arrayPosition;
        chromomapper[thisindex].notes += "\n"+"Note from duplicate segment(s): " + notestosave;
    }
    //console.log('highest index is: ');
    //console.log(highestscore);
    //console.log(segstoconsider[highestscore]);
    }
    segstoconsider.splice(highestscore, 1);
   // console.log(segstoconsider);
    //if(segstoconsider.length){ console.log('the items that are not the highest are:'); console.log(segstoconsider);}
    return segstoconsider;
}

function runDupeTool() {
    var debug = false;
    /*
        duplicate chromomapper
        sort it by chromosome and start position
        loop through it. for each, note the chromosome, match name and start position
        if they are the same as the one before, put the index into an array to delete
        at the end of the loop, delete these segments and redraw the profile.


        improvements required June 2020

        right now it deletes the wrong one, so: 

     the duplication logic needs to decide which one to duplicate by checking
    1. are they in a maternal/paternal group or a both. Favour mat/pat
    2. do they have notes or not. favour having notes.
    3. does the group have 'myheritage, ftdna' etc in title. favour not having it in there.

     new approach
      - put all dupe indexes into an array of dupes so I CAN THEN SORT that
    */

    
    var tempchromomapper = JSON.parse(JSON.stringify(chromomapper));
     for (var i in tempchromomapper) {
            tempchromomapper[i].arrayPosition = i;
        } 
    
    /*tempchromomapper.sort(byMatchNameOther);
    console.log(tempchromomapper);   

    tempchromomapper.sort(byChromosomeAndStart);   
    console.log(tempchromomapper);   */
    // new function from https://stackoverflow.com/questions/6913512/how-to-sort-an-array-of-objects-by-multiple-fields
        tempchromomapper.sort(function(left, right) {
            var chrA = '';
            var chrB = '';
         if(left.chromosome=='X'){
            chrA = 23;
          }
          else {
            chrA = parseInt(left.chromosome);
          }
          if(right.chromosome=='X'){
            chrB = 23;
          }
          else {
            chrB = parseInt(b=right.chromosome);
          } 

            var chromosome_order = chrA - chrB;
            var start_order = parseInt(left.start) - parseInt(right.start);
            var matchname_order = left.match.localeCompare(right.match);

            return chromosome_order || start_order || matchname_order;
        });

    var currentchr = 0;
    var currentmatch = '';
    var currentstart = '';
    var currentnotes = '';
    var segstoconsider = [];
    var segstodelete = [];
    var removedsegs = '';
    var fuzzydupes = $("#fuzzydupes").prop('checked');
    var fuzzythreshold = 2500000;
    for(var i in tempchromomapper){
        if(debug){            
            console.log(tempchromomapper[i]);
            console.log('currentchr is: '+currentchr);
            console.log('currentmatch is: '+currentmatch);
            console.log('currentstart is: '+currentstart);
        }

        if(
            tempchromomapper[i].chromosome == currentchr &&
            tempchromomapper[i].match == currentmatch &&
            (tempchromomapper[i].start == currentstart 
                ||
                fuzzydupes && (parseInt(tempchromomapper[i].start) >=currentstart-fuzzythreshold && parseInt(tempchromomapper[i].start) <=currentstart+fuzzythreshold)

                )
            ){
            if(debug){
                console.log('fuzzydupes is on AND (');
                console.log(parseInt(tempchromomapper[i].start)+' is >= to ('+currentstart+ ' minus '+ fuzzythreshold+ '('+(currentstart-fuzzythreshold)+')')
                console.log(' ('+parseInt(tempchromomapper[i].start)+' is <= to ('+currentstart+ ' plus '+ fuzzythreshold+ '('+(currentstart+fuzzythreshold)+')');

                console.log(tempchromomapper[i].arrayPosition+ ': DUPE DETECTED');
            }
            segstoconsider.push(tempchromomapper[i]);            
            var prevseg = tempchromomapper[i-1];
            if($.inArray(prevseg, segstoconsider)==-1){
                if(debug){
                    console.log(tempchromomapper[i-1].arrayPosition+': PREVIOUS SEG NOT IN ARRAY SO ADDING IT');
                }
                segstoconsider.push(tempchromomapper[i-1]);
                if(debug){
                    console.log(segstoconsider);
                }
            }

        }
        else {
          //  console.log('Not a dupe so collating these dupes for consideration');
          //  console.log(segstoconsider);
            segstodelete = segstodelete.concat(chooseSegsToDelete(segstoconsider));
            segstoconsider = [];

        }

        // append notes from any seg being deleted to the one before
        // along the lines of: if (tempchromomapper[i].notes !='' && tempchromomapper[i].notes !=currentnotes)
        // then set chromomapper[i-1].notes to be currentnotes + ". " + tempchromomapper[i].notes
        currentchr = tempchromomapper[i].chromosome;
        currentmatch = tempchromomapper[i].match;
        currentstart = parseInt(tempchromomapper[i].start);
        currentnotes = tempchromomapper[i].notes;
    }
 

      //console.log(segstoconsider);
      if(segstoconsider.length){
         segstodelete = segstodelete.concat(chooseSegsToDelete(segstoconsider));
      }
      //console.log(segstodelete);

      for (var i in segstodelete){
        removedsegs += getSegmentData(segstodelete[i], true);
      }

      // order them with the highest first.
      segstodelete.sort(function(a, b){return b.arrayPosition-a.arrayPosition});
         for (var i in segstodelete){
            // put this back in when ready
             quickDeleteSegment(segstodelete[i].arrayPosition);

           // unordered_remove(chromomapper, segstodelete[i]);
              //  chromomapper[segstodelete[i]] = chromomapper[chromomapper.length-1];    
           // console.log(segstodelete[i]);
         }
    //console.log(segstodelete.length);
    //console.log(chromomapper.length);
    
    // TODO
    // extract the ones to atually delete out of segs to consider

    //segstodelete = [];
    if(segstodelete.length>0){
        // bug 2 5 2019
        // I need to remove the segments from the display

        // leaving for now. try benchmarking against lowest segstodelete
        printMatches('all');

      //  writeDataToProfile();
        $("#onedupesegment").css('display', 'inline');
        $("#somedupesegments").css('display', 'block');
        $("#nodupesegs").css('display', 'none');
        $("#numberofdupesegs").text(segstodelete.length);
        if(segstodelete.length==1){
            $("#onedupesegment").css('display', 'none');    
        }
        $("#removedata").text(removedsegs);        
    }
    else {
        $("#nodupesegs").css('display', 'block');
        $("#somedupesegments").css('display', 'none');

    }

    closeOverlays();
     
    if($("#settingspanel").css('display')=='block'){
        toggleCpanelItem('settings');
    }
    
    $("#dupetool-confirm").css('display', 'block');
    calculatePaintedPercentage();  
}


$.fn.shuffle = function() {
 
        var allElems = this.get(),
            getRandom = function(max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function(){
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
           });
 
        this.each(function(i){
            $(this).replaceWith($(shuffled[i]));
        });
 
        return $(shuffled);
 
    };


       
function filterGroups(show) {
    $("#stats > span").hide();
    $("#chr").removeClass("filter-pat filter-mat");
    if (show == 'all') {
        $("#chrkey li").show();
        $("#chr .cp > div").css('visibility', 'visible');
        $("#stats span.sall").show();
        showAllGroups();
    } 
    else if (show == 'none') {
        $("#chrkey li").show();
        $("#chr .cp > div").css('visibility', 'visible');
        $("#stats span.sall").show();
        hideAllGroups();
    }

    else {
        $("#chr").addClass("filter-"+show);
        $("#chrkey li").hide();
        $("#chrkey li[data-side=" + show + "]").show();
        $("#chr .cp > div").css('visibility', 'hidden');
        $("#chr .cp > div." + show).css('visibility', 'visible');
        $("#chr .cp > div.both").css('visibility', 'hidden');;
        $("#stats span.s" + show).show();
        showAllGroups(); //todo check if this breaks something

    }
    $("#chrfilter li a").removeClass('active');

    $("#chrfilter li a[data-chrfilter=" + show + "]").addClass('active');


}

function getDataForMatch(match){
    // query chromomapper for this match and return the total cms
    // actually just count the cm on the page
    var matchitems = $(".groupdetailcontainer strong.highlight");
    //console.log(matchitems);
    var sharedcm = 0;
   
     var data = [];
     data.sharedcm = sharedcm;
    // data.mynotes = mynotes;
    return data;
}

function getDataForMatchFromGroup(match){
    // query chromomapper for this match and return the total cms
    // actually just count the cm on the page
    var matchitems = $(".groupdetailcontainer strong.highlight");
    //console.log(matchitems);
    var sharedcm = 0;
    var mynotes
     $(matchitems).each(function(){
        var thisitem = $(this).attr('data-id');
        thisitem = thisitem.replace("match","");
        var thisitemcms = parseFloat(chromomapper[thisitem].cM);
        if(typeof(chromomapper[thisitem].notes) !=='undefined' && chromomapper[thisitem].notes!=''){
            mynotes = chromomapper[thisitem].notes;
        }
        if($.isNumeric(thisitemcms)){
            sharedcm += thisitemcms;
        }
    });
     var data = [];
     data.sharedcm = sharedcm.toFixed(1);
     data.mynotes = mynotes;
    return data;
}


function toggleMatchHeader(matchslug){
    //matchslug = escape_quotes(matchslug);
    //console.log(matchslug);
  $("#mdcurrentsharedcm").css('display','block');

  if ($(".indmatch a[data-match='"+matchslug+"']").hasClass('active')) {
    //console.log('it is active - make it inactive');
    $(".groupdetailcontainer strong").removeClass('highlight');
    $(".indmatch a").removeClass('active');
    $("a[data-match='"+matchslug+"']").removeClass('active');
    $("#mdcmp").text('');
    $("#matchdetailheader").css('display', 'none');

    } 
  else {
    //console.log('it is not active - make it active');

    $(".groupdetailcontainer strong").removeClass('highlight');
    $(".indmatch a").removeClass('active');
    $(".groupdetailcontainer strong[data-match='" + matchslug + "']").addClass('highlight');
    $("a[data-match='"+matchslug+"']").addClass('active');


    var thisgroup = $("#editgroupbutton").attr('data-group');
    // to get the name I'm going to have to get the first segment. cludgetastic!
    var firstseg = $("strong[data-match='"+matchslug+"']").get(0);

    var thismatchno = ($(firstseg).attr('data-id')).replace('match','');
    var thismatch = chromomapper[thismatchno].match;
    var thismatchname = getMatchById(thismatch, 'name');
    if(thismatch=='' || typeof(chromomapper[thismatchno].match)=='undefined'){
        thismatch = 'Not specified';
    }
    $("#matchdetailheader .view-match").attr('data-match',thismatch);
    $("#matchdetailheader .view-match").attr('data-return','g~|'+thisgroup);

    //console.log(matchslug);
    //console.log($(".groupdetailcontainer strong[data-match='"+matchslug+"']"));
    var segmentstotal = $(".groupdetailcontainer strong[data-match='"+matchslug+"']").length;
    $("#matchdetailheader").show();
    $("#mdcurrentmatchname").html('<strong>'+thismatchname+'</strong><br />'+segmentstotal+ ' segment');
    if(segmentstotal >1){
        $("#mdcmp").text('s in this group');
    }
    else {
        $("#mdcmp").text(' in this group');
    }

    var mymatchdata = getDataForMatchFromGroup(thismatch);
    var currentcm = mymatchdata.sharedcm;
    if(parseInt(currentcm)>0){
        $("#mdcurrentsharedcm").text(currentcm+" cM shared");
        $("#mdcurrentsharedcm").attr('href','/tools/sharedcmv4/'+currentcm);
    }
    else {
        $("#mdcurrentsharedcm").css('display','none');
    }

    scrollToMatch();

        }
}

function scrollToMatch(){
    var gdoffset = -1*($("#groupdetail").offset().top);
    var myoffset = $("#matchdetailheader").offset().top;
    $('#modal').animate({
        scrollTop: (myoffset+gdoffset)
    }, 500);
}



function getSegmentData(thismatch, includenotes){
    if ((typeof thismatch !== "object")) {
        var thismatch = chromomapper[thismatch];
    }    
    //var thismatch = chromomapper[seg];
    var thiscmstring = '';
    if(typeof(thismatch.cM)!=='undefined'){
        thiscmstring = thismatch.cM;
    }
    var thissnpstring = '';
    if(typeof(thismatch.SNPs)!=='undefined'){
        thissnpstring = thismatch.SNPs;
    }
    notestring = '';
    if(includenotes && typeof(thismatch.notes) !=='undefined'){
        notestring = "\t" + thismatch.notes;
    }
    var thismatchname = getMatchById(thismatch.match, 'name');
    return thismatchname + "\t" + thismatch.chromosome + "\t" +thismatch.start+ "\t" +thismatch.end + "\t" + thiscmstring + "\t" + thissnpstring + notestring + "\n";

}
function isValidChromosome(number){
    return (number =='X' || ($.isNumeric(number) && 0 < parseInt(number) && 24 > parseInt(number)));
}

function cancelDeletion(){
        if($("#segs-confirm-delete").css('display')=='block'){
            $("#segs-confirm-delete").css('display','none');
            $(".del-segs-area").removeClass('confirm');

        }
        else {
            $(".del-segs-area").removeClass('active started');
            $("#datareport").removeClass('cdeleting');
            $("#datareport .confirm-delete").css('display','none');
            $(".chkcol input").prop('checked', false);            
        }
}

function fixNumberFormats(comparedata){
    var fixsegs = comparedata.trim().split("\n"); // split into lines
    for(var i in fixsegs){
        var cseg = fixsegs[i];
        cseg = cseg.replace(/    /g,'\t');
        var cbits = cseg.split('\t');
        //console.log(cbits);

        if(typeof(cbits[1])!=='undefined'){cbits[1] = cbits[1].replace(/\./g,'');}
        if(typeof(cbits[2])!=='undefined'){cbits[2] = cbits[2].replace(/\./g,'');}
        if(typeof(cbits[3])!=='undefined'){cbits[3] = cbits[3].replace(/,/g,'.');}
        if(typeof(cbits[4])!=='undefined'){cbits[4] = cbits[4].replace(/\./g,'');}
        fixsegs[i] = cbits.join('\t');
    }
    return fixsegs.join('\n');

}

function numbersLookOff(comparedata){
    var funny = /[0-9]+\.[0-9]+\./;
    var fixsegs = comparedata.trim().split("\n"); // split into lines

    for(var i in fixsegs){        
        if(fixsegs[i].match(funny)){
            return true;
        }
    }
  
    return false;
}

function processMatchData(comparedata, existingmatch, returnSegs, filterx) {
    if(typeof(returnSegs)==='undefined'){
        returnSegs = false;
    }
    if (comparedata.length == 0) {
        return false;
    } else {
        // identify Q data
        var isQ = false;
        var QFormat = /(.*)\t\nQ\n/;
        if(QFormat.test(comparedata)){
            isQ = true;
        }
        if(numbersLookOff(comparedata)){
            comparedata= fixNumberFormats(comparedata);
        }



        var threshold = parseInt($("#threshold").val());
        if(isNaN(threshold)){threshold = 1;}
        $("#newmatchkey").empty();
        // test for CSV.  If we have CSV, let's replace the commas with tabs! (specifically looking for the 'rs' string since not sure otherwise how to exclude gedmatch comma'ed numbers)
        var csvFormat =  /(.+),(.+),(.+),(.+),(.+),rs(.+)/;
        // another CSV test but for ftDNA
        // changed 22/11/19 to add a space for when copied and pasted out of big file.
        var csvFormat2 =  /(.+),(.+),([ 0-9X]+),(.+),(.+),(.+),(.*)/;

      

        if( csvFormat.test(comparedata) || csvFormat2.test(comparedata)  ) {
            comparedata = comparedata.replace(/,/g, "\t");
        }       
        var isInverted = false;
        var geneaNetFormat =  /(.+);(.+);(.+);(.+);(.+);(.+)identical/;
        if( geneaNetFormat.test(comparedata)) {
            comparedata = comparedata.replace(/(.+);(.+);(.+);(.+);(.+);(.+)identical/g,"$1\t$2\t$3\t$5\t$4");
            comparedata = comparedata.replace(/(.+);(.+);(.+);(.+);(.+);(.+)individuals/g,"$1\t$2\t$3\t$5\t$4"); // added 31/10/2022

            comparedata = comparedata.replace(/;/g, "\t");
            isInverted = true;
           
            /*
            var comparedatabits = comparedata.trim().split(';')
            console.log(comparedatabits);
            var gcm = comparedatabits[4];
            var gsnp = comparedatabits[3];
            comparedatabits[3] = gcm;
            comparedatabits[4] = gsnp;
            comparedata = comparedatabits.join("\t");*/
        } 

        var ieFormat = /([0-9X ]+) ([0-9\, ]+) ([0-9\, ]+) ([0-9rs\. ]+) ([0-9rs\, ]+)/;
        //1 82525076 88791432 7.4 3328
        var edgeFormat = /([0-9X ]+)\n([0-9\, ]+)\n([0-9\, ]+)\n([0-9rs\. ]+)\n([0-9rs\, ]+)/;

        var swedishNumbers = /([0-9X ]+) ([0-9X ]+)[\t\n]/; // Nov 2023 - make it recognise more swedish numbers and also do so when the myh chromosome browser is used in firefox
        var wholePageGedmatch = /Software Version/;
        var wholePageGedmatch2 = /Ver:/;
        var weHaveSwedishNumbers = swedishNumbers.test(comparedata) && 
            !wholePageGedmatch.test(comparedata) && 
            !wholePageGedmatch2.test(comparedata);
       
        if(weHaveSwedishNumbers){
            comparedata = comparedata.replace(/ /g,'');
            comparedata = comparedata.replace(/,/g,'.');
        }

        
        if (edgeFormat.test(comparedata) && !ieFormat.test(comparedata)) {
            //console.log('e format');
            comparedata = comparedata.replace(/\n/g, "\t");
            //console.log(comparedata);
            //tweak to allow comma in SNPs value and X in chrom
            // this is what I first had.  Still run it, but it will miss ones where there's no . in the cm amount.
            //console.log(comparedata);
            comparedata = comparedata.replace(/([0-9X]+)\.([0-9 ]+)\t([0-9, ]+)\t/g,"$1.$2\t$3\n"); 
            //console.log(comparedata);
                       // use 'rsanything' tab 'rsanything' tab [] to get the cms
            // adjusted 14/7/18 so that it doesn't rely on a . in the cm amount.
            // first attempt
            //comparedata = comparedata.replace(/([0-9X]+)\t([0-9.]+)\t([0-9,]+)\t/g,"$1\t$2\t$3\n"); 

            //new attempt:
            // this will take care of MyHeritage ones, but what about others? There will be instances where the . isn't there
            // or will there?  gedmatch always put the dot in. Looks like 23andme does too.

            // overall rationale:
            // need to break the line for each new segment
            // in most cases it's simple as the company will always put a . in for cM
            // Myheritage doesn't, so in their case we have to test on the rs value instead.
            // simple!

            //comparedata = comparedata.replace("SNPs\t","\n"); 
            comparedata = comparedata.replace(/SNPs([\s]+)/g,"\n"); 
            comparedata = comparedata.replace(/([0-9rs]+)\t([0-9rs]+)\t([0-9.]+)\t([0-9,]+)\t/g,"$1\t$2\t$3\t$4\n"); 

           // console.log(comparedata);

            comparedata = comparedata.replace(/([0-9X]+)\t/,"\n$1\t");
                       //console.log(comparedata);

        }

       
        // OK now - in order to handle the strange table format with embedded divs tags from ftDNA, let's
        // - look for lines with no tab in them followed by a line with a number and then a tab!
        // this will put the names onto the same lines as the segments 
        // m flag means multiline and is needed for the ^ operator to work for beginning of line.
        comparedata = comparedata.replace(/^([^\t]+)\n([0-9X]+)\t/gm,"$1\t$2\t");
        //console.log(comparedata);        

        var dnalandFormat = /(.+)\t\nrecent\n\n([0-9\.]+)\t(.+)/;
        var dnalandAncient = /(.+)\t\nancient\n\n([0-9\.]+)\t(.+)/;

        if (dnalandFormat.test(comparedata)) {
            comparedata = comparedata.replace(/(.+)\t\nrecent\n\n([0-9\.]+)\t(.+)/g,"$1\t$3\t$2\n"); 
           // comparedata = comparedata.replace(/recent(\t)/g,""); 

            //console.log('dnaland!');
            //console.log(comparedata);

        }
        if (dnalandAncient.test(comparedata)) {
            comparedata = comparedata.replace(/(.+)\t\nancient\n\n([0-9\.]+)\t(.+)/g,"$1\t$3\t$2\n"); 
           // comparedata = comparedata.replace(/recent(\t)/g,""); 

            //console.log('dnaland ancient!');
            //console.log(comparedata);
        } 


        // updated 5/10/18 with a tab 
        var t3andmeFormat = /(.+)\tHalf\n/; // updated Nov 22 to stop catching names with 'Half' in them! (by putting \n on end)
        var t3m = 0;
        if (t3andmeFormat.test(comparedata)) {
            var t3m = 1;        
        }


        //console.log(comparedata);
        // 2021 new FTDNA.  Check for no tabs. This means it won't catch gedmatch data and due to position won't catch space data.
        var hasTabs = /\t/;
           if(!hasTabs.test(comparedata) ) {
            comparedata = comparedata.replace(/,/g, "\t");
        }  
        //console.log(hasTabs.test(comparedata));



        //console.log(comparedata);

        newmatches = comparedata.trim().split("\n"); // split into lines
        //console.log(newmatches);
        newmatches.sort();
        $(".newmatchlink").remove();
        $(".gnewmatch").remove();
        newmatcharray = [];
        matchnametouse = '';
       // console.log(newmatches);
        for (m in newmatches) {
            // if 23andme, make sure spaces are turned into tabs only for the fields after the name, otherwise the name will be split and we won't know how many cols we have
           /* apparently not working*/
            if(t3m==1){
                //console.log('1');
                //newmatches[m] = $.map(newmatches[m], $.trim);
                var mname = newmatches[m].split(/\t[0-9X]/)[0];
                //console.log(mname);
                newmatches[m] = newmatches[m].replace(mname,"");
                // latest fun!
                newmatches[m] = newmatches[m].split(' \t').join('\t');
                newmatches[m] = newmatches[m].split('     ').join('\t');
                newmatches[m] = newmatches[m].split(' ').join('\t');
                // go in for X
             
                /*if(mname.substr(-3,3)==' X '){
                    // we have a rogue X 
                    mname = mname.substr(0, mname.length-3);
                    newmatches[m] = "X"+"\t"+newmatches[m];
                    removed this and added X detection above
                } */             
                newmatches[m] = $.trim(mname)+"\t"+newmatches[m];
                // go in for X             
                /*if(mname.substr(-3,3)==' X '){
                    // we have a rogue X 
                    mname = mname.substr(0, mname.length-3);
                    newmatches[m] = "X"+"\t"+newmatches[m];
                } */                             
                if(mname.split(" / ")[1]){
                    matchnametouse = $.trim(mname.split(" / ")[1]);
                    //console.log(matchnametouse);
                }

            }
            //console.log(newmatches[m]);

            var matchelement = newmatches[m].split("\t");
            // or try sets of 5 spaces
            if (matchelement.length == 1) {
                //console.log('1');
                // keeping this
                matchelement = newmatches[m].split("     ");
                matchelement = newmatches[m].split("    ");
                matchelement = newmatches[m].split("  ");

                var spaces = 1;
            }

            // or try spaces if tabs didn't work
            if (matchelement.length == 1) {
                matchelement = newmatches[m].split(" ");
                var spaces = 1;
            }
            // remove excess spaces
            matchelement = $.map(matchelement, $.trim);
            //console.log(matchelement);

            // no good for 23andme and IE. What a combo!


            //console.log(matchelement.length);
            // OK now I have an array in which the elements are:
            // 0 = chromosome / 1 = start / 2 = end / 3 = cMs / 4 = SNPs
            // OBVIOUSLY NEED TO VALIDATE THE INPUT!
            // Now test for 23andMe data which has a match field as the first column!
            // Test for pad columns at the start
            //console.log(matchnametouse);
            matchelement[0] = matchelement[0].replace('chr','');
            if (matchelement[0] != 'X' && !$.isNumeric(matchelement[0]) && (matchelement[0] !='Ver:')) {
                // the first column is a name and the second is a chromosome.
                if(isValidChromosome(matchelement[1])){
                    var colstosplice = 1;
                    if(matchnametouse==''){
                        // if not already set by 23andme above
                        matchnametouse = matchelement[0];
                    }
                    matchelement.splice(0, colstosplice);

                }

                // the second col is a name and the third is as chromosome
                else if (matchelement[1] != 'X' && !$.isNumeric(matchelement[1]) && isValidChromosome(matchelement[2])) {
                    colstosplice = 2;
                    //console.log(matchelement);
                    if(matchnametouse==''){
                        matchnametouse = matchelement[1];
                    }
                    matchelement.splice(0, colstosplice);
                    //console.log('2');
                    //console.log(matchelement);
                }

            }

            if(typeof(existingmatch)!=='undefined' && existingmatch!=''){
                matchnametouse = existingmatch;
            }

            // test for pad columns 'rs'
            if(matchelement[3] && matchelement[3].substring(0,2)=='rs'){
                // splice two cols
                matchelement.splice(3, 2);

            }
            // check the cM field for comma and replace if needed
            if(typeof(matchelement[3]) !=='undefined' && matchelement[3].indexOf(',')!==-1){
                matchelement[3] = matchelement[3].replace(',','.');    
            }
            // do the same for the string ' cM'
            if(typeof(matchelement[3]) !=='undefined' && matchelement[3].indexOf(' cM')!==-1){
                matchelement[3] = matchelement[3].replace(' cM','');    
            }

            if(typeof(matchelement[4]) !=='undefined'){
                matchelement[4] = matchelement[4].replace(' ','');
            }
            if (
                (!(matchelement[3]) || matchelement[3] >= threshold) &&
                (matchelement.length > 2 && (($.isNumeric(matchelement[0]) && 0 < matchelement[0] && 24 > matchelement[0]   )|| matchelement[0] == 'X'))

                &&
                $.isNumeric(numberWithoutCommas(matchelement[1])) &&
                $.isNumeric(numberWithoutCommas(matchelement[2])) &&
                (parseInt(numberWithoutCommas(matchelement[1])) < parseInt(numberWithoutCommas(matchelement[2])))
            ) {
                if(matchelement[0]==23){
                    matchelement[0]='X';
                }
                var nml = newmatcharray.push(matchelement) -1;
                var cmstouse = '';
                if(typeof(matchelement[3])!=='undefined' && $.isNumeric(matchelement[3])){
                    cmstouse = matchelement[3];
                }
                var posinfo = getPosition(matchelement[0], matchelement[1], matchelement[2], -1, null, 4);
                if(!returnSegs){                    
                    if($("#maincontent").hasClass('enablecf') || chromomapper.length <= 2000){
                        $("#p" + matchelement[0] + ' div.both').prepend("<div class='gnewmatch'><strong class='gnewmatch' data-id='newmatch" + nml + "' style='" + posinfo + ";' data-cm='"+cmstouse+"'><em class='mna' data-cm='"+cmstouse+"'>New match "+matchnametouse+"</em></strong></div>");
                    }
                    else {
                        $("#p" + matchelement[0] + ' div.both').prepend("<div class='gnewmatch'><strong class='gnewmatch' data-id='newmatch" + nml + "' style='" + posinfo + ";' data-cm='"+cmstouse+"' data-mn='New match "+matchnametouse+"'></strong></div>");
                    }
                }
                var posinfoarr = posinfo.split(';');
                //console.log(posinfoarr[0].replace('left:',''));
                addMatchTrack('', posinfoarr[0].replace('left:',''), posinfoarr[1].replace('width:',''), matchelement[0])
                //console.log(newmatcharray)
            }

        }
       // console.log(newmatches);
       newmatcharray.sort(function(a,b){return a[0] > b[0];})
              //  console.log(matchelement);

       var processdata = {};
       processdata.length = newmatcharray.length;
       processdata.matchname = matchnametouse;
       if(returnSegs){
            if(filterx===true){
                var s = newmatcharray.length;
                while(s--){
                    if(newmatcharray[s][0]=='X'){
                        newmatcharray.splice(s,1);    
                    }
                }
            }
            processdata.data = newmatcharray;
       }
        if (newmatcharray.length > 0) {
            $("#compareform").hide();
            //console.log(newmatcharray.length);
            return processdata;
        } else {
            return false;
        }
    }
}

function addMatchTrack(segid, leftpos, width, chr){
    if(typeof(chr)!=='undefined'){
       var mychrom = chr;
       var myside = 'both';
    }
    else {
        var mygroup = chromomapper[segid].group; 
        var myside = chromogroups[mygroup].side;
        var mychrom = chromomapper[segid].chromosome;        
    }


    var mytrack = '<strong class="matchtrack" style="left:'+leftpos+';width:'+width+'"></strong>';
    $("#p"+mychrom+' div.'+myside).prepend(mytrack);
    if(myside=='both'){
       // if($("#p"+mychrom+' div.mat > div').length){
            $("#p"+mychrom+' div.mat').prepend(mytrack);
       // }
       // if($("#p"+mychrom+' div.pat > div').length){
            $("#p"+mychrom+' div.pat').prepend(mytrack);
       // }        
    }
    else{
        if($("#p"+mychrom+' div.both > div:not(.fixed)').length){
            $("#p"+mychrom+' div.both').prepend(mytrack);
        }
    }
}

function getInlineStyle(prop, stylestring){
    var stylebits = stylestring.split(';');
  //  console.log(stylebits);
    for(var s in stylebits){
        var thisitem = stylebits[s].split(':');
        if($.trim(thisitem[0])==prop){
            return thisitem[1];
        }
    }
    return '';
}

function highlightMatch(match){
    $("span.swr").remove();
    $(".matchtrack").remove();
    var matchsegments = $("#chr strong[data-match='"+match+"']");
    $("#chr").addClass('searching');
    $(".cp strong").removeClass('hilite firsthilite popped');
    $(".popup").remove();
    if(matchsegments.length>0){
        setTimeout(function(){
        matchsegments.each(function(){
            $(this).addClass('hilite').show();
            // if not clone, add a track for this id       
            // have to do this because otherwise it converts to a px value           
            if(!$(this).parent().hasClass('clone')){
                var myleft = getInlineStyle('left', $(this).attr('style'));
                var mywidth = getInlineStyle('width', $(this).attr('style'));
                addMatchTrack($(this).attr('data-id').replace('match',''),myleft,mywidth);
            }
        });
              $(matchsegments[0]).addClass('firsthilite');
              var thisfirstseg = $(matchsegments[0]).attr('data-id');
                //openSegPopup($("strong[data-id="+thisfirstseg+']'),'');
              handleCutoffs($(matchsegments[0]));
              var scrollto = $(matchsegments[0]).offset().top-20;
              if(scrollto == -20){
                // handle clones
                scrollto = $(matchsegments[1]).offset().top-20;
              }
              //console.log($(matchsegments[0]).offset().top-20);
            $('html, body').animate({
                scrollTop: scrollto               
            }, 1000);
            showSegSummary(thisfirstseg.replace('match',''));
        },750);// adjusted - 50 wasn't doing it.        
    }

    //matchsegments[0] firsthilite
    //console.log(url_slug(match));

}

function getSegmentSimilarity(needle, haystacks, includesMatchName){
      // NEEDED
    // - for each seg I'm parsing chr, start, end, and optionally match name
    // a function should return 1 if chr, start and end match, 2 if all these and also match name match, or false otherwise.
    // this needs to be done at a segment level
    //console.log(haystacks);
    var matchesIncludingName = 0;
    var matchesNumbers = 0;
    var thischr = needle[0];
    var thisstart = needle[1];
    var thisend = needle[2];

    if(includesMatchName){
        // put it at the end of the array
//        console.log(needle);
        var thismatchname = needle[0];
        thismatchname = thismatchname.replace(/\"/g, '');
        thischr = needle[1];
        thisstart = needle[2];
        thisend = needle[3];
    }
    // the haystack is an array of arrays (the matches for each segment)
    // so make a new flat one
    if(haystacks){
        haystacks = [].concat.apply([], haystacks);
    }
    else {
        haystacks = chromomapper;
    }
    $(haystacks).each(function(){
            //console.log(this);
            if(
                this.chromosome==thischr &&
                parseInt(this.start)==parseInt(thisstart) && 
                parseInt(this.end)==parseInt(thisend)
                ){
                matchesNumbers = 1;
                if(includesMatchName && this.match==thismatchname){
                   matchesIncludingName =1; 
                }
            }
    });
    if(matchesNumbers >0){
        //console.log('bingo2');
        if(matchesIncludingName>0){
            //console.log('dupe with match name');
            return 2;
        }
        return 1
    }
    return false;
}

function checkNewMatch(data, context){
    // check data against chromomapper
    //console.log(data);
    var overlappingSegments = [];
    var matchesExistingSegmentCount = 0;
    // For each segment in the data, check for overlapping segments
    $(data).each(function(){
        var matchingSegs = getOverlappingSegments(this);
        if(matchingSegs.length>0){
            overlappingSegments.push(matchingSegs);        
        }
        // push the values returned by getOverlappingSegments 
    });

    // Now I have all the overlapping segments, I can check them for similarity

    // for each overlappingSegments, run a function getSegmentSimilarity
    // add the results to matchesExistingSegmentCount
    // this could get massive, so perhaps it's acceptable just to check the first value


    //console.log('overlap segments');
    //console.log(overlappingSegments);
    if(overlappingSegments.length ==0 && chromomapper.length >0){
        $("#"+context).show();
        return false;

    }
    // return an array with the groups
    var overlapdetails = [];

    for (var i in overlappingSegments) {
        var segmatches = overlappingSegments[i];
            for (var s in segmatches) {
                var segmatch = segmatches[s];
                overlapdetails.push(parseInt(segmatch.group));
            }
    }

    overlapdetails = overlapdetails.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });

    // check for duplicate input
    // compare data to overlappingSegments
    //console.log(data[0][1]);
    //console.log(overlappingSegments);

    // CURRENT half-arsedness:
    // fucking weird!
    // I'm saying if the number of segments it overlaps with is the same as the number in the new match, and if the starting point of the first one is the same as the starting point in the overlapping one (and same for end!)

  
    //if(data.length ==overlappingSegments.length && (data[0][1]==overlappingSegments[0][0].start) && (data[0][2]==overlappingSegments[0][0].end)){
    //    $("#"+context+"-dupe-warning").show();
    //}
    
    var aSegmentIsIdentical = getSegmentSimilarity(data[0],overlappingSegments,false);
    if(aSegmentIsIdentical){
        $("#"+context+"-dupe-warning").show();

    }

    printOverLapGroups(overlapdetails, context);
    //console.log(data);
}

function printOverLapGroups(groups, context){
    var masterstring = '', paternaloverlapstring = '', maternaloverlapstring= '', unknownoverlapstring = '';
    var count = 1;
    for (var i in groups){
        var thisgroup = groups[i];
        if(chromogroups[thisgroup].side=='pat'){
            paternaloverlapstring += '<li data-group="'+thisgroup+'">'+chromogroups[thisgroup].name + '</li>';
        //console.log(chromogroups[thisgroup]);
        }
        else if(chromogroups[thisgroup].side=='mat'){
            maternaloverlapstring += '<li data-group="'+thisgroup+'">'+chromogroups[thisgroup].name + '</li>';
        }
        else {
             unknownoverlapstring += '<li data-group="'+thisgroup+'">'+chromogroups[thisgroup].name + '</li>';
        }
    }
    if(paternaloverlapstring){
        masterstring +='<h4>Paternal</h4><ul>' + paternaloverlapstring + '</ul>';
       // console.log(paternaloverlapstring);
    }
    if(maternaloverlapstring !=''){
        masterstring +='<h4>Maternal</h4><ul>' + maternaloverlapstring + '</ul>';
    }  
    if(unknownoverlapstring !=''){
        masterstring +='<h4>Unknown or Shared</h4><ul>' + unknownoverlapstring + '</ul>';
    }
    if(masterstring){
        var prestring = '<label>Your match includes segments that overlap with the following groups:';
        if(context=='overlap-info'){
            prestring += '<br /><small>Click on a group name to select it.</small>';
        }
        masterstring = prestring +'</label>'+masterstring;
        masterstring = masterstring+ '<small>(If a match overlaps a group, this does not necessarily mean it belongs in that group, since the site does not know if your match is on the maternal or paternal chromosome; to establish this you will need to compare your match to other known matches)</small>';
    }   
    // arguably:
    // if it overlaps more than 5 groups, just say it overlaps more than 5 groups?
    // anyway
    $("#"+context).empty();
    $("#"+context).html(masterstring).show();
}

function getOverlappingSegments(segment, side, fuzzythreshold){
    // Takes a segment, check it against chromomapper and returns an array of matching segments
    // replace commas in numbers
    //console.log(segment);
  // cause of previous error. belt and braces
    segment[1] = (segment[1].toString()).replace(/\,/g, '');
    segment[2] = (segment[2].toString()).replace(/\,/g, '');
    // note group if supplied
    if(typeof(segment[5]) !=='undefined'){
            var thisgroup = segment[5];
            //console.log(thisgroup);
        }
    if(typeof(fuzzythreshold)==='undefined'){
        var fuzzythreshold = 2500000;
    }
   
   var checksegments = chromomapper;
     return checksegments.filter(function(checksegments, fuzzythreshold) {
        // eliminate 'fuzzy matches' where the overlap isn't real
       
        if(typeof(side)!=='undefined' && $.isNumeric(thisgroup) && chromogroups[thisgroup].side !='both'){
            // check for overlaps on a specific chromosome (mat or pat)        
            return checksegments.chromosome == segment[0] && 
                (chromogroups[checksegments.group].side == chromogroups[thisgroup].side || chromogroups[checksegments.group].side =='both') && 
                   (
                    ((parseInt(checksegments.start)+fuzzythreshold) <= parseInt(segment[1]) && (parseInt(checksegments.end)-fuzzythreshold) > parseInt(segment[1])) ||
                    ((parseInt(checksegments.end)-fuzzythreshold) > parseInt(segment[1]) && (parseInt(checksegments.start)+fuzzythreshold) < parseInt(segment[2]))
                   );
        }
        else {
            // check for overlaps, not taking specific chromosome into consideration
            return checksegments.chromosome == segment[0] && 
                (
                    (parseInt(checksegments.start)+fuzzythreshold <= parseInt(segment[1]) && (parseInt(checksegments.end)-fuzzythreshold) > parseInt(segment[1])) ||
                    (parseInt(checksegments.end)-fuzzythreshold > parseInt(segment[1]) && (parseInt(checksegments.start)+fuzzythreshold) < parseInt(segment[2]))
                );
        }       
    });
}

function saveMatchForm() {
    $('body').addClass('form-toggled');
    $("#groupError").hide();
    $("#overlap-info-dupe-warning").hide();
    $("#overlap-info").text('This match does not overlap with any previously painted segments.');
    $("#segplural").empty();
    var threshold = $.sanitize($("#threshold").val());
    $("#excluding").text(threshold);   
    checkNewMatch(newmatcharray,'overlap-info');
    $("#segnumber").text(newmatcharray.length);
    if (newmatcharray.length > 1) {
        $("#segplural").text('s');
    }

    // set certainty level
    setupCertainty(4, "newmatchCertainty");

    // populate select with options
    // initialise view

    var emn = $.sanitize($("#emn").val());
    if(emn !=''){
        matchnametouse = getMatchById(emn, 'name');
    }

    if(matchnametouse!=''){
        $("#matchname").val(escape_quotes(matchnametouse, true));
    }


    
    getOptions('ancestor');
    getOptions('group');
    $(".newgroupfields").show();
    var egr = $.sanitize($("#egr").val());

    if(egr !=''){
        //console.log(chromogroups[egr]);
        if(chromogroups[egr].ancestor==0){
            $("#unknownancestor").trigger('click');            
        }
        selectGroup(egr);
    }  
    else {
        $("#knownancestor").click();
    }

    $('body').addClass('form-toggled');
    initialiseColorPicker('newgroupcolor', 'random');
    // pull in existing colours    
    if(chromogroups.length>0){
        drawExistingColours();
        $(".existingcolours").show();
    }
    else {
        $("#existingcolours").empty();
    }    
    $("#newmatchform").show();
}


function getSortedGroupOptions(type, exclude, current, existingonly) {
    var options = '<option value="">Please select</option>';
    if(typeof(existingonly)==='undefined'){
        options += '<option value="createnewgroup">-> Create a new group</option>';
    }

    var count = 0;
    var groupsforsort = JSON.parse(JSON.stringify(chromogroups));
    for (var i in groupsforsort) {
        groupsforsort[i].arrayPosition = i;
    }
    sortedgroups = groupsforsort.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    // console.log(sortedgroups);
    $(sortedgroups).each(function(index) {
            
        if(
            (type=='all' && typeof(exclude) === 'undefined') ||
            (type=='all' && typeof(exclude) != 'undefined' && exclude !=this.arrayPosition) ||
            (type == 'ancestor' && typeof(this.ancestor) != 'undefined' && this.ancestor == 1) ||
            (type == 'group' && (typeof(this.ancestor) == 'undefined' || this.ancestor == 0))
            ){
            options += '<option value="' + this.arrayPosition + '"';
            if ( typeof(current) != 'undefined' && this.arrayPosition == current) {
                options += ' selected="selected"';
            }
            options += '>' + this.name + '</option>';
            count++;
        }

       
        
    });
    //if(typeof(exclude) != 'undefined' && count ==0){
    //    return false;
    //}
    if(type=='all'){
        return options;
    }
    $("#new" + type).show();
    $("#existing" + type).empty();
    $("#existing" + type).append(options);
    if (count == 0) {
        $("#existing" + type + "field").hide();
        $("#new" + type).hide();
    } else {
        $("#existing" + type + "field").show();
    }
}

function getOptions(type) {


    var options = '<option value="">Please select</option>';
    var count = 0;
    var groupsforsort = JSON.parse(JSON.stringify(chromogroups));
    for (var i in groupsforsort) {
        groupsforsort[i].arrayPosition = i;
    }
    sortedgroups = groupsforsort.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    // console.log(sortedgroups);
    $(sortedgroups).each(function(index) {
        if (type == 'ancestor' && typeof(this.ancestor) != 'undefined' && this.ancestor == 1) {
            options += '<option value="' + this.arrayPosition + '"';
            options += '>' + this.name + '</option>';
            count++;
        } else if (type == 'group' && (typeof(this.ancestor) == 'undefined' || this.ancestor == 0)) {
            options += '<option value="' + this.arrayPosition + '"';

            options += '>' + this.name + '</option>';
            count++;
        } else {
            options += '<option value="' + this.arrayPosition + '"';

            options += '>' + this.name + '</option>';
            count++;
        }
    });
    $("#new" + type).show();
    $("#existing" + type).empty();
    $("#existing" + type).append(options);
    if (count == 0) {
        $("#existing" + type + "field").hide();
        $("#new" + type).hide();
        //console.log('hiding '+type);
    } else {
        $("#existing" + type + "field").show();
    }
}


function exportTableToCSV($table, filename) {
    //console.log(filename);
    var $rows = $table.find('tr:visible:has(td,th)'),

        // Temporary delimiter characters unlikely to be typed by keyboard
        // This is to avoid accidentally splitting the actual contents
        tmpColDelim = String.fromCharCode(11), // vertical tab character
        tmpRowDelim = String.fromCharCode(0), // null character

        // actual delimiter characters for CSV format
        colDelim = '","',
        rowDelim = '"\r\n"',

        // Grab text from table into CSV formatted string
        csv = '"' + $rows.map(function(i, row) {
            var $row = $(row),
                $cols = $row.find('td:not(.chkcol),th:not(.chkcol)');

            return $cols.map(function(j, col) {
                var $col = $(col),
                    text = $col.text();

                return text.replace(/"/g, '""'); // escape double quotes

            }).get().join(tmpColDelim);

        }).get().join(tmpRowDelim)
        .split(tmpRowDelim).join(rowDelim)
        .split(tmpColDelim).join(colDelim) + '"';

    // Deliberate 'false', see comment below
    if (window.navigator.msSaveBlob) {

        var blob = new Blob([decodeURIComponent(csv)], {
            type: 'text/csv;charset=utf8'
        });

        // Crashes in IE 10, IE 11 and Microsoft Edge
        // See MS Edge Issue #10396033
        // Hence, the deliberate 'false'
        // This is here just for completeness
        // Remove the 'false' at your own risk
        window.navigator.msSaveBlob(blob, filename);

    } else if (window.Blob && window.URL) {
        // HTML5 Blob  
        var blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8'
        });
        var csvUrl = URL.createObjectURL(blob);
        $(this)
            .attr({
                'download': filename,
                'href': csvUrl
            });
    } else {
        // Data URI
        var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

        $(this)
            .attr({
                'download': filename,
                'href': csvData,
                'target': '_blank'
            });
    }
}




function validateMatch() {
    var segmentgroup = $("#chromogroupfield").find(':selected').val(); 
    if (!$.isNumeric($("#start").val()) ||
        !$.isNumeric($("#end").val()) ||
        parseInt($("#start").val()) > parseInt($("#end").val()) ||
        ($("#chromosome").val() != 'X') && !$.isNumeric($("#chromosome").val()) || ($("#chromosome").val() < 1 || $("#chromosome").val() > 22) ||
        (!$.isNumeric(parseInt(segmentgroup)) && $("#newexistingmatchgroupname").val()=='')
            

        // group field isn't numeric and newgrpupname is empty
    ) {
                //console.log(segmentgroup);   

        return false;
    }
    return true;
}

function replaceElement($elem) {
    var html = $elem[0].outerHTML;
    var parent = $elem.parent();
    $elem.remove();
    $(html).appendTo(parent);
    //console.log(html);
}

function setupCertainty(certaintyvalue, element) {
  

   // console.log(certaintyvalue);
        if ($("#" + element + "Slider").length > 0) {
            $('#' + element).slider('destroy');
        }
  //      replaceElement($('#' + element));

        $('#' + element).slider({
            tooltip: 'always',
            value: certaintyvalue,
            formatter: function(value) {
                return certaintyToText(value);
            }
        });
}

function certaintyToText(value) {
    if (value == 4) {
        return 'Certain (triangulated or close relative)';
    }
    if (value == 3) {
        return 'Very likely';
    }
    if (value == 2) {
        return 'Possible';
    }
    if (value == 1) {
        return 'Speculative';
    }
    return false;
}

function textToCertainty(text) {

    if (text == 'Certain (triangulated or close relative)') {
        return 4;
    }
    if (text == 'Very likely') {
        return 3;
    }
    if (text == 'Possible') {
        return 2;
    }
    if (text == 'Speculative') {
        return 1;
    }

    if($.isNumeric(text) && parseInt(text)<5 && parseInt(text) >0){
        return text;
    }
    return 3;
}


function getExistingColours(map){
    // for a stated map or the current one, return an array of colours used in the groups
    existing = [];
    if(typeof(map)==='undefined' || map ==''){
        var groupobject = chromogroups;
    }
    else {
        var groupobject = comparisongroups[map];
    }
    for (var i in groupobject){
        existing.push(groupobject[i].color);
    }
    return existing;
}


function sortGroups() {   
    $(".saved-flash").text('Saving...').show();

    setTimeout(function(){
      $("#chrkey li").each(function(index) {
        // insertion to cover extra list items in key 
            if($(this)[0].hasAttribute('data-group')){                
                chromogroups[$(this).attr('data-group')].order = index;
            }
            //console.log(chromogroups[$(this).attr('data-group')]);

        });
        // if in readonly mode, write the segments as well so these are saved locally
        if (typeof(readonly) !== "undefined") {
            writeDataToMap('all');
        } else {
            writeDataToMap('groups');        
        }
        // don't know if this can be avoided
        printMatches('all');
        filterSegmentsIfNecessary();        
        drawKey();
        setTimeout(function(){
            if($("#chrfilter ul a.active").length){
                var filterside = $("#chrfilter ul a.active").first().attr('data-chrfilter');
                filterGroups(filterside);            
            }
        },50);        
    },50);
  

}

function hideAllGroups() {
    // unpop
    closePopups();
    //  hide all segments from all groups
    $("#chrkey li span").removeClass('dphidden').addClass('dphidden');
    $(".cp >div >div").css('display', 'none');   
    if($("#showtm").prop('checked')){
        showTraits();
    }   
}

function showAllGroups() {
    // unpop
    closePopups();

    //  hide all segments from all groups
    $("#chrkey li span").removeClass('dphidden');
    $(".cp >div>div").css('display', 'block');
    filterSegmentsIfNecessary();    
}

function reHideHiddenGroups() {
    $("#chrkey li").each(function(){
        var groupnumber = $(this).attr('data-group');
        if($(this).find('span').first().hasClass('dphidden')){
            $("div.g" + groupnumber).css('display','none');
        }
    });
}

function toggleGroupVisibility(obj) {
    // unpop
    $("a[data-chrfilter=none]").removeClass('active');
    closePopups();

    // show hide any segments from this group
    var groupnumber = $(obj).parent().attr('data-group');
    $("div.g" + groupnumber).toggle();
    $(obj).toggleClass("dphidden");
    filterSegmentsIfNecessary();    
}


function numberDisplay(cm, snps) {
    var snpdisplay = '';
    var cmdisplay = '';
    if (cm) {
        cmdisplay = ' (' + cm + 'cM';
    }
    //console.log(snps);
    if (snps && typeof(snps) != 'undefined' && snps !='NaN') {
        snpdisplay = snps + ' SNPs)';
    }
    if (cmdisplay && snpdisplay) {
        cmdisplay += '/';
    } else if (cmdisplay) {
        cmdisplay += ')';
    }
    return cmdisplay + snpdisplay;

}

function getGroup(id) {

    return chromogroups[id];
    //  return chromogroups.filter(function(chromogroups){ return chromogroups.id == id });
}


function getFixedGroup(id) {
    return fixedgroups[id];
}
// ranodm 

function getGroupArrayPosition(id) {
    return chromogroups.index(id);
}

// helper functions


function removeMatches(group, chromosome, match, context, startAt, endAt) {

    if (typeof(context) === 'undefined') {
        context = '';

    } else {
        context = context + ' ';
    }

    if (group == 'all') {
        $(context + ".cp > div > div").remove();
    } 
    else if(match !=='undefined' && match!='null'){
        $("#matchdetail .cp > div").empty();
    }
    else if (group !== 'undefined' && group !='null') {
       // console.log('3');
       // console.log($(context + ".cp strong.g" + group));
        $(context + ".cp div.g" + group).remove();
    }
    else if (chromosome !== 'undefined' && chromosome !='null') {
     //   console.log('chrom is defined!');
        $(context + "#p" + chromosome + " > div > div").remove();
        $("#chr-detail .cp > div").empty();
        //console.log('should remove '+"#p"+chromosome+" > strong.match");
    }
    /*
    removing this because it takes too long
    else if(endAt !=='undefined' && startAt !=='undefined'){
        // we have an array of items to remove
        var i = startAt;
        while(i < endAt){
            $("strong[data-id='match"+i+"']").parent().remove();
            i++;
        }      
    }*/
    
    // put match stuff in here
}

function initialiseSearch(){
    var searchdata = buildSearchIndex();
    // todo: dp.map.index = searchdata ???
    //console.log(searchdata);
        $("#searchentry").autocomplete({
            source: function(request, response) {
                var results = $.ui.autocomplete.filter(searchdata, $.trim(escape_quotes(request.term)));
                
                if(results.length==0){
                var result = [
                    {
                    label: 'No matches found', 
                    value: response.term
                    }
                    ];
                    response(result);
                }
                else {
                    response(results.slice(0, 30));
                }
                //$("#search-info").css('display', 'block');
            },
            select: function( event, ui ) {                    
                if(ui.item.value=='No matches found'){
                    return false;
                }
                // the 'wothers' fix!
                //ui.item.value = ;
                //highlightMatch(ui.item.value.replace('\\','\\\\'));
                highlightMatch(ui.item.name);
               // $("#search-info").css('display', 'none');
            },
            focus: function(event, ui) {
                if(!$("#topcontent").hasClass('enableHover')){
                    //console.log(ui.item.value);
                    //$(this).val(ui.item.value);
                    highlightMatch(ui.item.name);
                    $(".ui-menu").hide(); // skip the focus state in iOS
                }
            }

        });
}

function getPosition(chrom, start, end, order, context, certainty) {
    var length = $("#p" + chrom).attr('data-length');
    start = String(start).replace(/,/g, "");
    end = String(end).replace(/,/g, "");
    
    if(typeof(certainty) !=='undefined'){
        if(certainty==4){
            opacity = .95;
        }
        else if(certainty==3){
            opacity = .8;
        }
        else if(certainty ==2){
            opacity = .65;
        }
        else {
            opacity = .5
        }
    }
    else {
        opacity = .9;
    }

    var styles = "";
    styles += "left:" + ((start / length) * 100).toFixed(3) + "%;";
    styles += "width:" + (((end - start) / (length)) * 100).toFixed(3) + "%;";
    if(context!='.groupdetailcontainer'){
        if(order > 979){
            order = 979;
        }
        styles += "z-index: " + (999 - order) + ";";
    }
    styles += "opacity:" + opacity;

    return styles;
}

function numberWithCommas(x) {
    if(typeof(x)==='undefined' || isNaN(x)){
        return '';
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function numberWithoutCommas(x, places) {
    if (!x) return '';
    if (typeof(places) === 'undefined') {
        var places = 0;
    } 
      //  console.log(x);

    x = String(x).replace(/\,/g, ''); // 1125, but a string, so convert it to number

    if(places==0){
    //    x = parseInt(x, 10);
        x = parseFloat(x);

    }
    else {
        x = parseFloat(x).toFixed(places);
    }
    return x;
}

Storage.prototype.setArray = function(key, obj) {
    return this.setItem(key, JSON.stringify(obj));
}

Storage.prototype.getArray = function(key) {
    return JSON.parse(this.getItem(key));
}

function getGroupItems(id, chromosome, match, startAt) {
    //console.log('called getgroupitems');

    if (id == 'all') {
        if(typeof(startAt)!=='undefined' && parseInt(startAt) >0){
            return chromomapper.filter(function(chromomapper, index) {
                return index >= startAt
            });
        }
        return chromomapper;

    } else if ($.isNumeric(id) && ($.isNumeric(chromosome) || chromosome=='X')) {
        return chromomapper.filter(function(chromomapper) {
            return (chromomapper.group == id && chromomapper.chromosome == chromosome)
        });
    } else if ($.isNumeric(id)) {
        return chromomapper.filter(function(chromomapper) {
            return chromomapper.group == id
        });
    } else if (typeof(match)!=='undefined') {
        // need array position in this case!
        /*
        segsformatch = JSON.parse(JSON.stringify(chromomapper));
          for (var i in segsformatch) {
            segsformatch[i].arrayPosition = i;
            }
        return segsformatch.filter(function(segsformatch) {
            return segsformatch.match == match
        });*/
        return chromomapper.filter(function(chromomapper) {
            return chromomapper.match == match;
        });
    }

    return chromomapper.filter(function(chromomapper) {
        return chromomapper.chromosome == chromosome
    });

}


function redrawGroup(group) {
    // remove all matches for this group (those with class 'g'+id)
    $('#chrcontainer div.g' + group).remove();
    //console.log('just removed the segments possibly')
    //console.log($('#chrcontainer strong.g' + group));
    // now gather them again and redraw so we get any new colours/sides
    var groupItems = getGroupItems(group);
    var thisgroup = getGroup(group);
    printMatches(groupItems, '#chr');
    $("li#group" + group + " span").css('background', thisgroup.color);
}


function removeSegment(match) {
    $('strong[data-id="match' + match + '"]').parent().remove();
}




function closeAndMark(form, action) {
    if(form){
        $("#" + form).removeClass('active').fadeOut();
    }
    $('body').removeClass('form-toggled');
    $(".confirm-delete").hide();
    clearSearch();    
    if(action !='saved'){
        $("." + action + "-flash").delay(500).fadeIn().delay(2500).fadeOut();
    }
}

function printMatch(match, context, hidden, wrap, append) {
    // print a match using the array index or the array item
    // if match isn't an array, it's an index - use this to get the array
    //if(!$.isArray(match)){
    if (typeof(context) === 'undefined' || context =='') {
        var context = '';
    } else {
        context = context + ' ';
    }

    if ((typeof match !== "object")) {
        var match = chromomapper[match];
    }
    var hideitem = '';
    //if(typeof(hidden) !='undefined'){
    if (hidden) {
        hideitem += ' style="display:none"';
    }
    //}
    /*var matchslug = '';
    if (typeof(match.match) !== 'undefined' && match.match != '') {
        matchslug = url_slug(match.match);
    } else {
        matchslug = 'not-specified';
    }*/
    var position = chromomapper.indexOf(match);
    // TODO - possibly skip if no group.  Leaving now for debug purposes
    var thisgroup = getGroup(match.group);
    if (thisgroup && typeof(thisgroup) != 'undefined') {

        //var delay = randomIntFromInterval(0, 300);
        delay = 10;
        //var thisindex = chromomapper.indexOf(match);

        var mymatchname = 'Not specified';
        //console.log(match.match);

        if (typeof(match.match) !== 'undefined' && match.match != '') {
            mymatchname = getMatchById(match.match, 'name');
        }           
        var printname = mymatchname;
                //console.log(printname);
        var startdiv = '';
        var enddiv = '';
       
       
        //var wrapperdivclass = '';
        //if(context =='#chr-detail '){
             wrapperdivclass = ' class="g' + match.group+'"';
        //}
        var cmstouse = '';
        if(typeof(match.cM)!=='undefined'){
            cmstouse = match.cM;
        }
       
        // original

        //var matchstring = "<div"+wrapperdivclass+hideitem + "><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + escape_quotes(match.match) + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context, match.certainty) + ";border-color: " + thisgroup.color + ";" + "'><span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(match.start)+"-"+numberWithCommas(match.end)+"</span></span></span><a href='#' class='entire-group' data-group='" + match.group + "' data-match='"+match.match+"'>View entire group</a></strong></div>";
        //var matchstring = "<div"+wrapperdivclass+hideitem + "><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match=\"" + match.match + "\" data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context, match.certainty) + ";border-color: " + thisgroup.color + ";" + "'><em class='mna' data-cm='"+cmstouse+"'>"+mymatchname+"</em></strong></div>";

        if($("#maincontent").hasClass('enablecf') || chromomapper.length <= 2000){
            var matchstring = "<div"+wrapperdivclass+hideitem + "><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + match.match + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context, match.certainty) + ";border-color: " + thisgroup.color + ";" + "' data-cm='"+cmstouse+"'><em class='mna' data-cm='"+cmstouse+"'>"+mymatchname+"</em></strong></div>";
        }    
        else {
            var matchstring = "<div"+wrapperdivclass+hideitem + "><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + match.match + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context, match.certainty) + ";border-color: " + thisgroup.color + ";" + "' data-cm='"+cmstouse+"'></strong></div>";
        }



//        <span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(match.start)+"-"+numberWithCommas(match.end)+"</span></span></span>

        //var matchstring = 'hello';

        // shorter version loads in about half the time but doesn't have the matchname
      //  var matchstring = "<div"+wrapperdivclass+"><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + matchslug + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context) + ";border-color: rgba(" + thiscolor.r + "," + thiscolor.g + "," + thiscolor.b + "," + (parseInt(match.certainty)) / 4 + ");" + hideitem + "'></strong></div>";
        

        // try putting match name in 
       // var matchstring = "<div"+wrapperdivclass+"><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + matchslug + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context) + ";border-color: rgba(" + thiscolor.r + "," + thiscolor.g + "," + thiscolor.b + "," + (parseInt(match.certainty)) / 4 + ");" + hideitem + "'><span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em></span></span></strong></div>";
        // (this would work - I'd just need to pull in the other info on hover)
        

        //var matchstring = "<div"+wrapperdivclass+"><strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + matchslug + "' data-id='match" + position + "' style='" + 'egg'+ ";border-color: rgba(" + thiscolor.r + "," + thiscolor.g + "," + thiscolor.b + "," + (parseInt(match.certainty)) / 4 + ");" + hideitem + "'><span class='swr'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(match.start)+"-"+numberWithCommas(match.end)+"</span></span></span><a href='#' class='entire-group' data-group='" + match.group + "'>View entire group</a></strong></div>";
        
        if(typeof(append) !=='undefined' && append){
            //console.log('returning rather than printing');
            return matchstring;
        }

        var chrdiv = context + "#p";
        if(context =='#chr-detail '){
            chrdiv +='d';
        }

        if (context != '' || chromomapper.length > 300) {
            //console.log(context);

// orig            $(context + "#p" + match.chromosome + " div." + thisgroup.side).append(startdiv+"<strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + matchslug + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context) + ";border-color: rgba(" + thiscolor.r + "," + thiscolor.g + "," + thiscolor.b + "," + (parseInt(match.certainty)) / 4 + ");" + hideitem + "'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'>"+numberWithCommas(match.start)+"-"+numberWithCommas(match.end)+"</span></span><a href='#' class='entire-group' data-group='" + match.group + "'>View entire group</a></strong>"+enddiv);
            // $(context + "#p" + match.chromosome + " div." + thisgroup.side).append(startdiv+"<strong class='match s" + thisgroup.side + " g" + match.group + "' data-match='" + matchslug + "' data-id='match" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order, context) + ";border-color: rgba(" + thiscolor.r + "," + thiscolor.g + "," + thiscolor.b + "," + (parseInt(match.certainty)) / 4 + ");" + hideitem + "'><span><em class='gn'>" + thisgroup.name + "</em><em class='mn'>"+printname + "</em>"+lcm+"<span class='lsse'></span></span><a href='#' class='entire-group' data-group='" + match.group + "'>View entire group</a></strong>"+enddiv); 

           // $(context + "#p" + match.chromosome + " div." + thisgroup.side).append('hello');
            $(chrdiv + match.chromosome + " div." + thisgroup.side).append(matchstring);

        } else {
            setTimeout(function() {
                $(chrdiv + match.chromosome + " div." + thisgroup.side).append(matchstring);
             }, delay);
        }

        
    }
}

function printCentromere(centromere, context){
    // PoSS todo: if context, check if empty first. but seems a bit complicated.
    if (typeof(context) === 'undefined' || !context ) {
        var context = '#p';
    }
    else if(context =='#chromodetail'){
        context = context + ' #pd';
    }    
    else {
        context = context + ' #p';
    }
    setTimeout(function() {
        $(context+ centromere.chr + " div.mat, "+context+ centromere.chr + " div.pat,"+context + centromere.chr + " div.both" ).append("<em class='centromere' style='" + getPosition(centromere.chr, centromere.start, centromere.end, 0) + "'></em>");
    },50);
}

function printFixedMatch(match, context, returndata) {
    // print a match using the array index or the array item
    // if match isn't an array, it's an index - use this to get the array
    //if(!$.isArray(match)){
    if ((typeof match !== "object")) {
        var match = fixedsegments[match];
    }
    if (typeof(context) === 'undefined' || !context ) {
        var context = '';
    }
    else {
        context = "#"+context+' ';
        // todo - see if needed. if so do contextulayy only if it's visible.
        //$("#p" + match.chromosome+" div.both").show();

    }

    var position = fixedsegments.indexOf(match);
    // TODO - possibly skip if no group.  Leaving now for debug purposes
    var thisgroup = getFixedGroup(match.group);
    if (thisgroup && typeof(thisgroup) != 'undefined') {
        var fixedmatchstring = "<strong class='fixed fg" + match.group + "' data-id='fmatch" + position + "' style='" + getPosition(match.chromosome, match.start, match.end, thisgroup.order) + "'><span>" + thisgroup.name + "</span></strong>"

        if(typeof(returndata)==='undefined'){
            setTimeout(function() {
                $(context+"#p" + match.chromosome + " div." + thisgroup.side).append(fixedmatchstring);
            },50);
        }
        else {
            //console.log(fixedmatchstring);
            return fixedmatchstring;
        }

    }
}

function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function printMatches(groupItems, context, startAt, endAt) {
    //TODO- add a 'startfrom' attribute to this and to removeMatches to save time.

    // print a set of matches using an array of items
    //$(".cp-open .pat strong, .cp-open .mat strong, .cp-open .both strong:not(.fixed)").unwrap();
    //removeMatches(groupItems);
    //console.log(groupItems);

    // hardcoding for now
    startAt = 0;
    if (typeof(context) === 'undefined') {
        var context;
    }
    if(typeof(startAt)==='undefined'){
        startAt=0;
    }
    if(typeof(endAt)==='undefined'){
        endAt=chromomapper.length;
    }    

    if (groupItems == 'all') {

        var groupItems = getGroupItems('all', '','',startAt);

       // if(startAt==0){ // now reverting startat/endat stuff because the process of removing matches takes too long. 
            removeMatches('all', 'null', 'null', '#chr');
            loadFixedSegments();
        //}
        //else {
        //    removeMatches('null','null','null','null',startAt, endAt);
        //}
    }
    var hiddengroups = getHiddenGroups();

    for (var i in groupItems) {
        var segment = groupItems[i];
        //console.log(match.group);   
        var hidden = false;
        if (jQuery.inArray(segment.group, hiddengroups) !== -1) {
            hidden = true;
        }
        printMatch(segment, context, hidden);
        //paintSegmentInPosition(chromomapper.indexOf(groupItems[i])); // this doesn't work because the segment in the append position might not yet have been painted.
        
        //$("#p"+match.chromosome+" div."+thisgroup.side).append("<strong class='match g"+match.group+"' data-id='match"+i+"' style='"+getPosition(match.chromosome,match.start,match.end,thisgroup.order)+";background: rgba("+hexToRgb(thisgroup.color).r+","+hexToRgb(thisgroup.color).g+","+hexToRgb(thisgroup.color).b+","+match.certainty/4+")'><span>"+thisgroup.name+"</span></strong>");
    }
   // close any open groups
   //console.log('egg');

  // $(".cp-open .chrmatchlabel").remove();

  // $(".cp").removeClass('cp-open');
  // $("#chr h4").removeClass('expanded');

    //calculatePaintedPercentage();

}

function printDetailMatches(chromosome) {
    // print all matches for a chromosome
    //$("#chromodetail .cp > div.both").hide();

    // check if unknown groups are to be included
    
  


    var context = "#chr-detail";
    // TODO - check this. 
    removeMatches(null, chromosome, null,context);
    var detailItems = getGroupItems(null, chromosome);
    //console.log(detailItems);


    var hideunknown = hideUnknown();
    var hideethnicity = hideEthnicity();  


    if(hideunknown || hideethnicity){

        detailItems = detailItems.filter(function(detailItems){
            var mygroup = detailItems.group;
            var isUnknown = chromogroups[mygroup].ancestor!=1 && (typeof(chromogroups[mygroup].spec)==='undefined' || chromogroups[mygroup].spec !='eth');
            var isEth = chromogroups[mygroup].spec=='eth';
            //return true;
            //return !(hideunknown && isUnknown);
            if(hideunknown && isUnknown){
                return false;
            }
            if(hideethnicity && isEth){
                return false;
            }            
            return true;
          
        });
    }

   // console.log(detailItems);

    var detailGroups = [];
    // sort in group order
    detailItems = detailItems.sort(function(a, b) {

        return parseInt(a.group) - parseInt(b.group);
    });



    detailItems = detailItems.sort(function(a, b) {

        return parseInt(chromogroups[a.group].order) - parseInt(chromogroups[b.group].order);
    });


    // plot fixed segments too

    //console.log(detailItems);
    for (var i in detailItems) {
        
        var match = detailItems[i];
      //  console.log(match);
        // todo protect against the group not existing.
        if (chromogroups[match.group].side == 'both') {
            $("#chromodetail .cp > div.both").show();
        }
        //var thisgroup = match.group
        //match.group = thisgroup.replace('"','');
        detailGroups.push(parseInt(match.group));
        printMatch(match, context);
    }
   // console.log(detailGroups);


    var details = [];
    details.keygroups = detailGroups.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });
    //var a = chromogroups[details.keygroups[i]].order;
    // sort according to group order
    details.keygroups.sort(function(a,b){return chromogroups[a].order - chromogroups[b].order});
    //console.log(details.keygroups);
    details.highest = getHighestVal(detailItems, 'end');
   // console.log(details.keygroups);
    return details;
}

//get the highest value in array for specific index
//usage: getHighestVal(data,index)
//data = array
//index = index of array to analyse
function getHighestVal(data, index) {
    var max = 0;
    $.each(data, function(i, v) {
        thisVal = parseInt(v[index]);
        max = (max < thisVal) ? thisVal : max;
    });
    return max;
}

function calculateASide(side, segments) {
    if (segments.length == 0) {
        return 0;

    }
    var sidetotal = 0;
    //console.log('definitely '+side);
    var calculatePosition = 0;
    var previous_side;
    var previous_end;
    var previous_side;
    var doNotCountUnknown = $("#hideunknown").prop('checked');

    $.each(segments, function(index, segment) {
        groupinhand = getGroup(segment.group);
        // robustness against data issues!
        if(typeof(groupinhand) ==='undefined'){
            return false;
        }
        var isEthnicity = (typeof(groupinhand.spec)!=='undefined' && groupinhand.spec =='eth');
        var isUnknown =  (typeof(groupinhand.ancestor)==='undefined' || parseInt(groupinhand.ancestor) ==0);
        //console.log(groupinhand);
            //console.log(isEthnicity);
            //console.log(isUnknown);
            //console.log(parseInt(groupinhand.ancestor));

        if ((!doNotCountUnknown || (doNotCountUnknown && !isUnknown)) && 
            groupinhand.side == side && !isEthnicity) {
            if (previous_side != groupinhand.side) {
                previous_end = 0;
                previous_start = 0;
            }
            if (typeof(groupinhand.side) === 'undefined') {
                sidetotal += 0;
            } else if (groupinhand.side != side) {
                sidetotal += 0;
            } else {
                if ($.isNumeric(previous_end) && parseInt(previous_end) > parseInt(segment.start)) {
                    // there's an overlap
                    if (parseInt(previous_end) > parseInt(segment.end)) {
                        // the current segment is entirely within the previous one, so don't count it (this should give 0-0)
                        calculatePosition = segment.end;
                    } else {
                        calculatePosition = previous_end;
                    }
                } else {
                    calculatePosition = segment.start;
                }
            }
            previous_start = segment.start;
            if (parseInt(segment.end) > parseInt(previous_end)) {
                previous_end = segment.end;
            }
            previous_side = groupinhand.side;
            var numbertoadd = parseInt(segment.end) - parseInt(calculatePosition);
            if(numbertoadd >0){
                sidetotal += numbertoadd;
            }
            //console.log('Calc='+calculatePosition+'Start='+segment.start+'End='+segment.end+'Total='+(parseInt(segment.end) - parseInt(calculatePosition)));
        }
    });

    return parseInt(sidetotal);

}

function getChromosomeTotal(c, targetgroup) {
    if(typeof(targetgroup)!=='undefined'){
        var items = getGroupItems(targetgroup, c);
    }
    else {
        var items = getGroupItems(null, c);
    }
    previous_start = '';
    previous_end = '';
    var mytotal = [];
    mytotal.all = 0;
    sortedsegments = items.sort(function(a, b) {
        return parseInt(a.start, 10) - parseInt(b.start, 10);
    });
    var sides = ['pat', 'mat'];

    $.each(sides, function(index, side) {
        //console.log('calculating '+side+ ' side for chrom '+c);
        if (side == 'mat') {
            mytotal.mat = 0;
            mytotal.mat = calculateASide(side, sortedsegments);
            mytotal.all += mytotal.mat;
        } else if (side == 'pat') {
            mytotal.pat = 0;
            mytotal.pat = calculateASide(side, sortedsegments);
            mytotal.all += mytotal.pat;
        }
        //console.log('chromosome '+c+' total for '+side+' is '+ calculateASide(side,sortedsegments));
    });
    //console.log(mytotal);
    return mytotal;
}

function getPercentageForGroup(group) {
    // go through each chromosome
    var runningtotal = 0;

    for (c = 1; c < 23; c++) {
        var chromtotal = getChromosomeTotal(c, group);
         runningtotal += chromtotal.all;       
    }    
    // and the X
    var xchromtotal = getChromosomeTotal('X', group);
    runningtotal += xchromtotal.all;
  

    var subtotalbp = getTotalBp();


    painted = runningtotal;   
  
    subtotalbp +=getAdditionalMaleBp();
    var accountforuntested = 0; //198000000
    var totalbp = subtotalbp - parseInt(accountforuntested);    

    // add up the base pairs for all segments in the group (do the clever overlapping thing)
    // compare with the total
    var percentage = (100 * (painted / totalbp)).toFixed(1);
    var writtenperc;
    if(painted==0){
        return false;
    }
    if(percentage==0){
        writtenperc = 'less than 1%'
    }
    else {
        writtenperc = 'about '+percentage+'%'
    }
    return 'This represents '+writtenperc+' of the base pairs in this map';

}

function getAdditionalMaleBp(){
 var mapGender = $("#mapGender").text();   
 if (mapGender && mapGender != 'Male') {
        return parseInt($("#pX").attr('data-length'));
 }
 else if(typeof(pgen)!=='undefined'){
    if(pgen!='m'){
        return parseInt($("#pX").attr('data-length'));
    }
 }
 return 0;
}

function getTotalBp(side){
    var c = 1;
    runningtotal = 0;
    while(c <= 22){
        runningtotal +=parseInt($("#p"+c).attr('data-length'));
        c++;
    }
    if(typeof(side)==='undefined'){
        runningtotal = runningtotal*2;
    }

    if(typeof(side)==='undefined' || side ==='mat'){
        runningtotal += parseInt($("#pX").attr('data-length'));
    }
    return runningtotal;
}

function calculatePaintedPercentage() {
    var painted = parseInt(0);
    $("#stats").hide();
    //var sortedsegments = JSON.parse(JSON.stringify(chromomapper));;
    var items;
    var sortedsegments;
    var runningtotal = 0;
    var matrunningtotal = 0;
    var patrunningtotal = 0;
    var groupinhand;
    var previous_start;
    var previous_end;

    //for each chromosome
    for (c = 1; c < 23; c++) {
        //if(getChromosomeTotal(c) >0){
        //console.log('updating the total for chromosome '+c);
        var chromtotal = getChromosomeTotal(c);
        runningtotal += chromtotal.all;
        matrunningtotal += chromtotal.mat;
        patrunningtotal += chromtotal.pat;
        //}
        //console.log(getChromosomeTotal(c));

    }

    var xchromtotal = getChromosomeTotal('X');
    runningtotal += xchromtotal.all;
    matrunningtotal += xchromtotal.mat;
    patrunningtotal += xchromtotal.pat;

    //var totalbp = 3031042417;
    var totalmatbp = getTotalBp('mat'); // all maternal sides have X
    var totalpatbp = getTotalBp('pat');

    //var subtotalbp = getTotalBp();

    painted = runningtotal;

    totalpatbp +=getAdditionalMaleBp();

    var totalbp = totalmatbp + totalpatbp;
    //console.log(painted);
    if (painted >= 0) {
        var percentage = (100 * (painted / totalbp)).toFixed(0) + '%';
        var patpercentage = (100 * (patrunningtotal / totalpatbp)).toFixed(0) + '%';
        var matpercentage = (100 * (matrunningtotal / totalmatbp)).toFixed(0) + '%';

        // TODO - make it so it can't be more than 100!
        var segments = ' / ' + chromomapper.length + ' segment';

        if (chromomapper.length > 0 && percentage == '0%') {
            percentage = '<1%';
        }
        if (chromomapper.length != 1) {
            segments += 's';
        }

        $("#stats .sall strong").text(percentage + segments);
        $("#stats .spat strong").text(patpercentage);
        $("#stats .smat strong").text(matpercentage);

        $("#stats").addClass('activated');
        $("#stats").css('display','block');
        Tipped.create('#stats');

    }
}


function checkIds(){
    var ids = []
    for (var i in chromomapper){
        if(typeof(chromomapper[i].id)==='undefined'){
            console.log(i+' is undefined');
        }
        else {
            if($.inArray(chromomapper[i].id, ids)==-1){
                ids.push(chromomapper[i].id);
            }
            else {
                console.log(chromomapper[i].id+' already exists');
            }
        }        
    }
    console.log('chromomapper length: '+chromomapper.length);
    console.log('distinct ids: '+ids.length);

}
function copySegment(seg){
    // copy this segment and add it to the end with the note 'Copy of ...'
        var newsegment = JSON.parse(JSON.stringify(chromomapper[seg]));
        newsegment.notes = 'Copied segment. '+newsegment.notes;
        newsegment.id = getIdentifier();

        var copiedseg = chromomapper.push({
            "chromosome": newsegment.chromosome,            
            "start": newsegment.start,
            "end": newsegment.end,
            "group": parseInt(newsegment.group),
            "id": newsegment.id,
            "cM": newsegment.cM,
            "SNPs": newsegment.SNPs,
            "notes": newsegment.notes,
            "match": escape_quotes(newsegment.match),
            "certainty": newsegment.certainty
            }) -1;
      //  console.log(newsegment);

        // save this addition
        writeDataToMap('matches');

        // at this point we'll need to close this group (if open) and redraw this it.        
        //$("#chr #p"+newsegment.chromosome + ".cp-open div > div > strong").unwrap();

        // remove the cp-open class
        //$(".cp").removeClass('cp-open');
        // commenting this out
        //redrawGroup(newsegment.group);
        // let's just paint it in position instead
        paintSegmentInPosition(copiedseg);

        closeAndMark('matchform', 'duplicated');    
        // check 'copied' is happening.
        return copiedseg;
}



function updateSegmentTotals(totals) {
    if(totals.mat==1){
      totals.mat +=' segment';
    }
    else{
      totals.mat +=' segments';
    }
    if(totals.pat==1){
      totals.pat +=' segment';
    }
    else{
      totals.pat +=' segments';
    }    
    $("#stats span.smat .segs").text(' / ' +totals.mat);
    $("#stats span.spat .segs").text(' / ' +totals.pat);
    //console.log($("strong.smat").length);
}

function getHiddenGroups() {
    var hiddengroups = [];
    $.each($("#chrkey li > span"), function(index, value) {
        if ($(this).hasClass('dphidden')) {
            hiddengroups.push(parseInt($(this).parent().attr('data-group')));
        }
    });
    return hiddengroups;
}

function drawExistingColours(){
    $("#existingcolours").empty();
    var groupsforkey = JSON.parse(JSON.stringify(chromogroups));;
    var matgroups = groupsforkey.filter(function(groupsforkey){ return groupsforkey.side == 'mat' });
    var patgroups = groupsforkey.filter(function(groupsforkey){ return groupsforkey.side == 'pat' });
    var bothgroups = groupsforkey.filter(function(groupsforkey){ return groupsforkey.side == 'both' });

    matgroups = matgroups.sort(function(a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    patgroups = patgroups.sort(function(a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });    
    bothgroups = bothgroups.sort(function(a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }); 
    var appendString = ''
    if(matgroups.length >0){
        appendString +='<li><strong>Maternal</strong></li>';
        for (var g in matgroups) {
            var keygroup = matgroups[g];
            appendString +="<li><span title='" + keygroup.name + "' style='border-top:1.5rem solid " + keygroup.color + "'></span> " + (keygroup.name).substring(0,35) + "</li>"; 
        }
    }
    if(patgroups.length >0){
        appendString +='<li><strong>Paternal</strong></li>';
        for (var g in patgroups) {
            var keygroup = patgroups[g];
            appendString +="<li><span title='" + keygroup.name + "' style='border-top:1.5rem solid " + keygroup.color + "'></span> " + (keygroup.name).substring(0,35) + "</li>";            
        }
    } 
    if(bothgroups.length >0){
        appendString +='<li><strong>Unknown or shared</strong></li>';
        for (var g in bothgroups) {
            var keygroup = bothgroups[g];
            appendString +="<li><span title='" + keygroup.name + "' style='border-top:1.5rem solid " + keygroup.color + "'></span> " + (keygroup.name).substring(0,35) + "</li>";            
        }
    }         
    $("#existingcolours").append(appendString);
}

function drawKey() {
    // make a note of the hidden state

    var hiddengroups = getHiddenGroups();
    $("#chrkey").empty();

    //var groupsforkey = sortmyarray(chromogroups, 'order');
    var groupsforkey = JSON.parse(JSON.stringify(chromogroups));;
    for (var i in groupsforkey) {
        groupsforkey[i].arrayPosition = i;
    }
    groupsforkey = groupsforkey.sort(function(a, b) {
        return parseInt(a.order, 10) - parseInt(b.order, 10);

    });
    var grippy = '';
    if (groupsforkey.length > 1) {
        grippy = "<em class='grippy'></em>";
    }
    //console.log(groupsforkey);
    if (groupsforkey.length > 1) {
        $("#chrfilter").show();
    }
    //console.log(groupsforkey[0]);
    //console.log(parseInt(groupsforkey[0].order)+groupsforkey[0].name);
    var totalsegments = {};
    totalsegments.pat = 0;
    totalsegments.mat = 0;
    var mygroupstring = '';
    for (var g in groupsforkey) {
        //  console.log(g+'o'+groupsforkey[g].order+groupsforkey[g].name);
       
        var keygroup = groupsforkey[g];
        var hidegroup = '';
       
        if (jQuery.inArray(parseInt(keygroup.arrayPosition), hiddengroups) >=0) {
            hidegroup = " class='dphidden'";
        }      
        if(keygroup.name ==''){
            keygroup.name = 'Blank';
        }
        var gdivider = '';
        //console.log(keygroup);
        if(typeof(keygroup.gdivider !=='undefined') && keygroup.gdivider ==1){
            gdivider = ' class="gdivider"';
        }       
        mygroupstring += "<li"+gdivider+" id='group" + keygroup.arrayPosition + "' data-side='" + keygroup.side + "' data-group='" + keygroup.arrayPosition + "'>" + grippy + "<span title='" + keygroup.name + "' style='border-top:1.5rem solid " + keygroup.color + "'" + hidegroup + "><i class='fa fa-eye-slash dphide' aria-hidden='true'></i><i class='fa fa-eye dpshow' aria-hidden='true'></i></span><a href='#' data-group='" + keygroup.arrayPosition + "' class='groupview'>" + keygroup.name + "</a></li>";
        var segmentsinthisgroup = chromomapper.filter(function(chromomapper){ return chromomapper.group == keygroup.arrayPosition });
        totalsegments[keygroup.side] += segmentsinthisgroup.length; 
        if(!$("body").hasClass('user-is-touching')){
            Tipped.create("#group" + keygroup.arrayPosition +" a", keygroup.name+': Click to edit or view all segments in this group', {        
                position: 'left', offset: { x: -21 }
            });
        }
    } 
//            console.log(mygroupstring);

    if(mygroupstring!=''){
        $("#chrkey").append(mygroupstring);
    }

    if($("#hideunknown").prop('checked')){
        var unkgroups = getGroupsOfType('unknown');
        if(unkgroups.length>0){
            appendToKey('unknown', unkgroups.length);           
        }
    }
    if($("#hideethnicity").prop('checked')){
        var ethgroups = getGroupsOfType('ethnicity');
        if(ethgroups.length>0){
            appendToKey('ethnicity', ethgroups.length);
        }
    }

    
    if (groupsforkey.length == 0) {        
        $("#chrkey").append("<li>Click 'Paint a new match' and paste in match data to start painting.</li>");
    } else {
        //filterGroups('all'); //removed because it reset hidden groups
        for(var i in hiddengroups){
            $("div.g" + hiddengroups[i]).css('display','none');
        }   
    }
    updateSegmentTotals(totalsegments);       
}

function drawDetailKey(groups, fixedsegs) {
   // console.log(groups);
    $(".chr-detail-key").empty();

    if($("#showcmslider").prop('checked')){ // || $("#chrkey span.dphidden").length (commenting out because right now hidden groups still show unless slider is on - will improve this later)
        groups = [];
        $("#chr-detail .cp > div > div:visible").each(function(){ 
            // exclude if no visible children
            if($(this).find('div:visible').length){
                var thisgroup = (this.className).replace('g','');
                if(!isNaN(thisgroup)){
                    groups.push(thisgroup);                
                }                
            } else {
                $(this).css('display','none');
            }
        });
    }
    $.each(groups, function(index, value) {
        // console.log( index + ": " + value );

        $(".chr-detail-key").append("<li><span style='background:" + chromogroups[value].color + "'></span><a href='#' title='view details' data-group='" + value + "'>" + chromogroups[value].name + "</a></li>");

    });

    if(fixedsegs){
         var distinctgrps = fixedsegs.filter(function(group, i, ar) {
            return ar.indexOf(group) === i;
        });
         // tried to filter by distinct group but that's not working.  below is a hack!
        $(".chr-detail-key").prepend("<li><span class='fixedkey'></span>" + fixedgroups[0].name + "</a></li>");
    
    }

}

function dateFromTimestamp(timestamp){
    var date = new Date((timestamp*1000));
    var nowtime = date.toLocaleTimeString();
    var now = date.toLocaleDateString();
    return now + ' '+nowtime;
}

function retrieveMap(){
    //console.log('retrieving');
   $("#retrievemsg").css('display', 'none');
   chromomapper = window.localStorage.getArray(currentmap + "cachedMatches");
   chromogroups = window.localStorage.getArray(currentmap + "cachedGroups");
   printMatches('all');
   writeDataToMap();
   drawKey();
   calculatePaintedPercentage();
}


function getDataForMap() {
    // if chromomapper is empty, try and get it from stored values
    //console.log('called');
    //console.log(getFieldValue("Matches"));
    // TODO - update this so it looks for the updated key value (e.g. dp153cachedupdated) and compares it to the updated date

    // EXPERIMENT!
    // JUST COMMENT THIS OUT SO IT WILL NEVER CONSULT THE LOCAL STORAGE
    /*
    if (getFieldValue("Matches") && getFieldValue("Groups") && getFieldValue('updated')) {
        // this is to catch rare instances where they may update after they have already been logged out.
        // TODO - in the new version, do this on the basis of the 'local version' flag being set in addition to this date check.

        // get number of segments in local version
        var localchromomapper = window.localStorage.getArray(currentmap + "cachedMatches");
        var localchromogroups = window.localStorage.getArray(currentmap + "cachedGroups");
        var localsavedate = parseInt(getFieldValue('updated'));
       //console.log(localsavedate);
       // console.log(lastUpdated);

        if(localchromomapper.length > chromomapper.length && localsavedate < parseInt(lastUpdated)){
            // we have a locally stored map that's bigger than the saved one, but which has been saved earlier
            // action: print a message offering to restore it
            //console.log(dateFromTimestamp(localsavedate));
            //console.log(dateFromTimestamp(parseInt(lastUpdated)));
            var displayremotedate = dateFromTimestamp(parseInt(lastUpdated));
            var displaylocaldate = dateFromTimestamp(localsavedate);
            var message = '<h4>Versioning issue</h4><ul><li>The copy of this map displayed below was last saved '+displayremotedate+'</li><li>But you have a locally saved version of this map (last saved '+displaylocaldate+') that has more segments ('+localchromomapper.length+') than the saved version.</li></ul><p>Would you like to retrieve the version with '+localchromomapper.length+' segments?<button class="btn btn-primary yes-retr">Yes</button></p><a href="#" class="no-retr">No, continue with the version below</a></p>';
            $("#retrievemsg").html(message).show();
        }   
        else if (localsavedate > (parseInt(lastUpdated)+10)) {
            // allow for a tiny delay since this won't be based on a separate set of data
            chromomapper = localchromomapper;
            chromogroups = localchromogroups;
            // local is newer than remote, so force a 'write' here
            writeDataToMap();

        }
    }*/

    /* New plan:
        Check for localsavedate.
        If a local save date exists. If it does, and it's newer than the last recorded save date, then use the data
        This should handle cases where a save fails and the user refreshes the page.
        Poss todo - change 'updated' to 'updatedlocal' or something so no cross-fertilisation from old version
    */
    if(getFieldValue('lastsaved')){
        var localsavedate = parseInt(getFieldValue('lastsaved'));
        // check for 'emergency' parameter. This says the data has been saved locally when a save failed
        var emergency = false;
        if(window.localStorage.getItem(currentmap + "emergency")){
            emergency = true;
        }
       /* 
        console.log(emergency);
        console.log(localsavedate);
        console.log(parseInt(lastUpdated)+20);
        */

        if ( (localsavedate > (parseInt(lastUpdated)+20)) && emergency) {
            // hcanged from 10 to 1000
            var storedchromomapper = window.localStorage.getArray(currentmap + "cachedMatches");
            var storedchromogroups = window.localStorage.getArray(currentmap + "cachedGroups");
            if(storedchromomapper && storedchromogroups){
                chromomapper = storedchromomapper; 
                chromogroups = storedchromogroups;

                //removing 27/1/21 as think it may pollute the names sometimes. odd. poss 'currentmap' is not yet defined when this is called?
                /*var mapName = getFieldValue('mapName');
                            console.log(mapName);


                // probably needs something here to check currentmap is not empty
              

                if(mapName !=''){
                    $("#mapName").text(mapName);
                }
                var mapGender = getFieldValue('mapGender');
                if(mapGender !=''){
                    $("#mapGender").text(mapGender);
                } */                        
            }             
        }
        else {   
            saveTimeStampLocally(true);
        }
    } else {
        saveTimeStampLocally(true);
    }



    /*
    if (getFieldValue('mapName')) {
        $("#mapName").text(getFieldValue('mapName'));
    }*/
    /*if (getFieldValue('mapGender')) {
        $("#mapGender").text(getFieldValue('mapGender'));
        $("#chr").addClass('gender-' + getFieldValue('mapGender').toLowerCase());
    } else*/
    if ($("#mapGender").text() != '') {
        $("#chr").addClass('gender-' + $("#mapGender").text().toLowerCase());
        $("body").attr('data-mapgender','gender-' + $("#mapGender").text().toLowerCase());

    } else if ($("#mapGenderro").text() != '') {
        $("#chr").addClass('gender-' + $("#mapGenderro").text().toLowerCase());
        $("body").attr('data-mapgender','gender-' + $("#mapGenderro").text().toLowerCase());
    }
    //console.log(dp.map.matches.length);
    if(!dp.map.matches.length){
        setupMatchIds();
    }
    calibrateOptions();
    adjustChromosomeLengths();
    calculatePaintedPercentage();
}

function buildSearchIndex(){
    var flags = [], output = [], l = dp.map.matches.length, i;
        for( i=0; i<l; i++) {
            if(typeof(dp.map.matches[i].id)==='undefined') continue;
            if( flags[dp.map.matches[i].id]) continue;
            flags[dp.map.matches[i].id] = true;
            var myentry = {
                label: escape_quotes(dp.map.matches[i].name),
                name: dp.map.matches[i].id
            }
            output.push(myentry);
        }
    //output.sort();
    return output;
}


function calibrateOptions() {
    // check if there are ethnicity groups
    var ethgroups = getGroupsOfType('ethnicity');
    if(ethgroups.length==0){
        $("#etholder").css('display', 'none');
    }
    else {
        $("#etholder").css('display', 'block');
    }
    var unkgroups = getGroupsOfType('unknown');
    if(unkgroups.length==0){
        $("#huholder").css('display', 'none');
    }
    else {
        $("#huholder").css('display', 'block');
    }    
   
}

function writeDataToMap(which) {     
    calibrateOptions();
    // have to hide this because the undo button will not work after a save
    $("#dupetool-confirm").css('display','none');
    // Write these to the database.  check user is currently logged in user.
    if (currentmap != 'example' && typeof(readonly) === "undefined") {
       // console.log('well woop 2');
        $(".saved-flash").text('Saving...').show();
        var fun = $(".saved-flash")[0];
        var fun2 = $(fun).offset();
        document.getElementsByTagName('body')[0].focus();
        //return;
        var data = {};
        if(typeof(openID)!=='undefined'){
            data['openID'] = openID;
        }
        // if a save is in progress, send data[saveinprogress] = true
        if(getFieldValue('saving')){
            data['saveinprogress'] = true;    
        }
        // then set it to true for this save
        saveFieldLocally('saving', true); 

        data[site.csrf.keys.name] = site.csrf.name;
        data[site.csrf.keys.value] = site.csrf.value;
          if(getFieldValue('lastsaved')){
             data['lastsaved'] = getFieldValue('lastsaved');
          }
          else {
            // if never saved on this device befores
            data['lastsaved'] = 'never';
          }
          //console.log('sending '+data['lastsaved'])
        data['accessKey'] = accessKey;
        data['scount'] = chromomapper.length;
        //if (which != 'groups') {
            // only save segments if need to
        data['matches'] = JSON.stringify(dp.map.matches);

        data['chromomapper'] = JSON.stringify(chromomapper);
            // test dummy!
           // data['chromomapper'] = data['chromomapper'].substring(0,400);
            //console.log(data['chromomapper']);
        //}
        data['chromogroups'] = JSON.stringify(chromogroups);
       // $(".saving-flash").delay(10).fadeIn();
      // console.log(data);
        //console.log(data);
        //console.log("/api/maps/p/" + currentmap);
        setTimeout(function(){
        $.ajax({
            type: "PUT",
            url: "/api/maps/m/" + currentmap,
            data: data,
            success: function(result) {
                //console.log('hit success');
                // $("#alerts-page").ufAlerts().ufAlerts('fetch').ufAlerts('render');
                //console.log('success');
                
                $(".saved-flash").text('Saved').delay(2500).fadeOut();
                // get server time

                //console.log('tsnote is '+tsnote)
                saveTimeStampLocally(true, result); // put true in

                // save was successful - can remove 'saving' now
                window.localStorage.removeItem(currentmap + "cachedsaving");
                window.localStorage.removeItem(currentmap + "emergency");
                
                //console.log(result);
                $("#alerts-page").ufAlerts('clear'); 
                //console.log('successful save');
            },
            error: function(exception) {
                //console.log('hit failure');
                // SAVE THE DATA LOCALLY
                try {
                    saveDataLocally();
                }
                catch(err) {
                // was not able to save locally
                    $("#notsavedlocally-warning").show();
                }

                
                 $("#alerts-page").ufAlerts('destroy');
                 // Create new instance of ufAlerts

               //  $("#alerts-page").ufAlerts().ufAlerts('fetch').ufAlerts('render');
                $(".saved-flash").hide().text('Saved');
                 $("#alerts-page").ufAlerts().ufAlerts('render');

               
                 // if the request has reached the server, there will be responsetext
                 if(typeof(exception.responseText)!=='undefined'){
                    //console.log(exception.responseText);
                    try {
                        var errornotes = JSON.parse(exception.responseText);
                        var errorcode = errornotes.code;                        

                    }
                    catch(err){
                        // if JSON parse doesn't work, assume it's a generic error.
                        var errorcode = 500;
                    }

                 }
                 else {
                    var errorcode = 503;
                 }
                 //console.log(exception);

                  //console.log(errornotes);
                if(errorcode==409){
                    var segs = errornotes.segs;
                    var alert = '<strong>Possible versioning issue.</strong><ul><li>The copy of this map saved in the site database appears to be more recent than this one, and includes '+segs+' segments.<br />This may happen if you have the map open in more than one browser or device.</li><li>Please confirm what you\'d like to do by clicking a button below:</li></ul><p><button class="btn" id="revert-map">Revert to more recent saved version with '+segs+' segments</button></p><p><button class="btn btn-secondary" id="overwrite-map">Overwrite with this version</button></p>';
                }
                else{
                    var alert = '<strong>Sorry, but your map did not save to the server!</strong><ul><li>Your session may have timed out, or you might have had a temporary connection issue.</li><li>As a precaution, the site has saved your map to your computer\'s local storage.</li><li>Please refresh this page and try again.</li><li>If the problem recurs, please make a backup and contact <a href="mailto:info@dnapainter.com">info@dnapainter.com</a> quoting error code '+errorcode+'</li></ul>';

                }
                //console.log(errornotes);
                //console.log('e'+JSON.stringify(exception));

                 //$("#alerts-page").ufAlerts('push', 'danger', 'Your map did not save to the server. Please refresh the page and try again. If the problem recurs, please make a backup and contact info@dnapainter.com').ufAlerts('render');
                  $("#alerts-page").ufAlerts('push', 'danger', alert).ufAlerts('render');

            }
        });
      }, 10);
    } else {
        $(".saved-flash").hide();        
        return true;
    }
}

function saveDataLocally(){
    if (supportsLocalStorage()) {
        //var unixtimestamp = Math.round(+new Date() / 1000);
        //saveFieldLocally('updated', unixtimestamp); 
        saveTimeStampLocally();
        saveFieldLocally('mapName', $("#mapName").text());   
        saveFieldLocally('mapGender', $("#mapGender").text());   
        window.localStorage.setArray(currentmap + "cachedGroups", chromogroups);
        window.localStorage.setArray(currentmap + "cachedMatches", chromomapper);
        window.localStorage.setItem(currentmap + "emergency", true);
    }
}

function saveTimeStampLocally(lastsaved, result){
    // if lastsaved is passed, then use the last save date. otherwise, get current timestamp from server
    if (supportsLocalStorage()) {        
        if(lastsaved){
            if(typeof(result)!=='undefined'){
                var tsbits = JSON.parse(result);
                var tsnote = tsbits.ts;
                lastUpdated = tsnote; 
            }

           saveFieldLocally('lastsaved', lastUpdated); 

        }
        else {
            var unixtimestamp;
            var myroot = window.location.origin;
            $.ajax({
                url: myroot + "/api/st",
                type: 'GET',
                cache: false,

                success: function (response){
                    unixtimestamp = response; // you can use jsonData variable in outside of the function
                    //console.log(3);
                    saveFieldLocally('lastsaved', unixtimestamp); 
                    //console.log(response);
                }, 
                error: function(response){
                    // assume no timestamp is gettable so use local one.
                    var unixtimestamp = Math.round(+new Date()/1000);
                    //console.log(4);
                    saveFieldLocally('lastsaved', unixtimestamp); 
                    //console.log('b');

                }
            });
        }
       
        //var unixtimestamp = Math.round(+new Date() / 1000);
    }

}

function getCopyOfGroups(){
    var groupsforkey = JSON.parse(JSON.stringify(chromogroups));;
    for (var i in groupsforkey) {
        groupsforkey[i].arrayPosition = i;
    }
    return groupsforkey;
}

function orderGroups(method, draw){
    // default - alphabetical
    var groupsforkey = getCopyOfGroups();
    if(method=='alphabetical'){
        groupsforkey.sort(alphanumCase); // handle 'cluster' mixed stuff.
        // go through groupsforkey and update the order for each chromogroup with the index
        for(var i in groupsforkey){
            chromogroups[groupsforkey[i].arrayPosition].order = i;
        }
    }
    if(typeof(draw)!=='undefined'){
        drawKey();
    }
}

function deleteEmptyGroups(draw){
    var i = chromogroups.length;            
    while (i--) {
        var mysegs = getGroupItems(i);
        if(mysegs.length==0){
            deleteGroup(i);
        }
    }
    if(typeof(draw)!=='undefined'){
        drawKey();
    }    
}


/* alphanum.js (C) Brian Huisman
 * Based on the Alphanum Algorithm by David Koelle
 * The Alphanum Algorithm is discussed at http://www.DaveKoelle.com
 *
 * Distributed under same license as original
 *
 * Released under the MIT License - https://opensource.org/licenses/MIT
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

 function alphanumCase(a, b) {
  function chunkify(t) {
    var tz = new Array();
    var x = 0, y = -1, n = 0, i, j;

    while (i = (j = t.charAt(x++)).charCodeAt(0)) {
      var m = (i == 46 || (i >=48 && i <= 57));
      if (m !== n) {
        tz[++y] = "";
        n = m;
      }
      tz[y] += j;
    }
    return tz;
  }

  var aa = chunkify(a.name.toLowerCase());
  var bb = chunkify(b.name.toLowerCase());

  for (x = 0; aa[x] && bb[x]; x++) {
    if (aa[x] !== bb[x]) {
      var c = Number(aa[x]), d = Number(bb[x]);
      if (c == aa[x] && d == bb[x]) {
        return c - d;
      } else return (aa[x] > bb[x]) ? 1 : -1;
    }
  }
  return aa.length - bb.length;
}

function updateShareStatus(state) {
    var data = {};
    data[site.csrf.keys.name] = site.csrf.name;
    data[site.csrf.keys.value] = site.csrf.value;
    data['accessKey'] = accessKey;
    data['share_status'] = state;
    $.ajax({
        type: "PUT",
        url: "/api/maps/m/" + currentmap,
        data: data,
        success: function(result) {

            
            //console.log(result);
        },
        error: function(exception) {
            //console.log('e'+exception);
        }
    });

}



function clearSession() {
    $.get('/api/maps/m/clearsession/' + currentmap);
}

function viewChromosomeDetail(number) {
     
    //resetMasterChr();
    closeOverlays();
    if(inMassEditMode()){
        cancelMassEditMode();
    }

    if(number=='X' && $("#mapGender").text()=='Male'){
        $("#chromodetail h2 span").css('display', 'none');        
    }
    else {
        $("#chromodetail h2 span").css('display', 'inline');        
    }

    // plot the chromosome
    $('body').addClass('form-toggled');
    $('#chromodetail .chrcontainer').removeClass('showmatchnames');
    $('.tpd-tooltip').hide();
    $("#chromodetail h2 strong").text(number);
    $("#chromodetail").addClass('active');
    printIndividualChromosomeDetail(number);

    if($("#showcentromeres").prop('checked')){
        loadCentromeres(number, "#chromodetail");
    }
    $("#chromodetail").show();
}


function adjustChromosomeLengths(){
    // for each chromosome, get the highest 'end'
// if this is higher than  $("#chromodetail div.cp").attr('data-length', chromosomeLength);, change that.
    
    var chroms = $("#chr .cp");
    $(chroms).each(function(){
        var thischrom = $(this).attr('id');
        var chromItems = '';
        var chromHighest = '';
        thischrom = thischrom.replace('p','');
        chromItems = getGroupItems(null, thischrom);
        chromHighest = getHighestVal(chromItems, 'end');
        if(chromHighest > $(this).attr('data-length')){
            $(this).attr('data-length',chromHighest);    
        }
        if(thischrom != 'p1'){
            var mywidth = $(this).attr('data-length')/$("#p1").attr('data-length')*100;
            $(this).css('width',mywidth+'%');
        }        
    });
}

function printIndividualChromosomeDetail(number) {
    var context = "#chr-detail";
    $("#chr-detail h4").text(number);
    $("#chr-detail div.pat, #chr-detail div.mat, #chr-detail div.both").empty();
    //$("#chr-detail div.both").hide();
    var chromosomeLength = $("#chr > div#p" + number).attr('data-length');
//    $("#chromodetail div.cp").attr('id', 'p' + number);
    //$("#chromodetail div.cp").attr('data-length', chromosomeLength);

    $("#chr-detail .chrdetailchromosome").attr('id', 'pd' + number);
    $("#chr-detail .chrdetailchromosome").attr('data-length', chromosomeLength);
   

    var fixedsegs = loadFixedSegments(number, 'chr-detail');
  
  

    var details = printDetailMatches(number, context);
   // removed highest bits from here

    // wrap each group in its own div to keep on one line
    $.each(details.keygroups, function(index, value) {
        //alert( index + ": " + value );
        $("#chr-detail .cp > div > div.g" + value).wrapAll('<div class="g'+value+'"></div>');
    });

    setTimeout(function(){drawDetailKey(details.keygroups, fixedsegs); setUpMBLinesDetail();},50);

}

//String.prototype.nl2br = function() {
//    return this.replace(/\n/g, "<br />");
//}


function nl2br(mystring, retain) {
    var nlstring = '';
    if(typeof(retain)!=='undefined'){
        nlstring = getEOL();
    }
    return mystring.replace(/\n/g, "<br />"+nlstring);
}


function getTotalcMForGroup(group){
    var myitems = getGroupItems(group);

    var groupsforsort = JSON.parse(JSON.stringify(myitems));
    for (var i in groupsforsort) {
        groupsforsort[i].arrayPosition = i;
    }
    groupitems = groupsforsort.sort(function(a, b) {
        if(typeof(a.match)!=='undefined' && typeof(b.match)!=='undefined'){
            return a.match.localeCompare(b.match);
        }
        //return a;
    });

//    var total = 0;
    var groupMatches = 0;
    var currentmatch = '';
    //console.log(groupitems);
  $(groupitems).each(function(index) {
        if(currentmatch!=groupitems[index].match){
      //      console.log(groupitems[index].match);

            groupMatches++;
        //    console.log(groupMatches);
        }
        currentmatch = groupitems[index].match;
       // if($.isNumeric(groupitems[index].cM)){
       //     total = total + parseInt(groupitems[index].cM);
       // }
    });
    var printmatchnumber = ''; 
    if(groupMatches==0){
        return 'There are no matches in this group';
    }
    else if(groupMatches==1){
        printmatchnumber = '1 match';
    }
    else {
        printmatchnumber = groupMatches+ ' matches';
    }
    //console.log(groupitems);    
//    return  printmatchnumber + ' / '+ total+'cM painted';
    return  printmatchnumber;

}

function resetMasterChr(){
    $(".cp, .chrcontainer").removeClass('showmatchnames');
    $(".cp .chrmatchlabel").remove();
}

function getCommonMatches(data, currentmatch){
    var comparedata = $.map(data, function(n,i){
        return [[ n.chromosome, n.start, n.end, n.cM, n.SNPs, n.group ]];
    });

    //console.log(comparedata);
    //checkNewMatch(comparedata, 'commonmatches .cmatches');
    var overlappingSegments = [];
    $(comparedata).each(function(){
        var matchingSegs = getOverlappingSegments(this, true);
        if(matchingSegs.length>0){
            overlappingSegments.push(matchingSegs);        
        }
        // push the values returned by getOverlappingSegments 
    });
  // return an array with the groups
    var master = [];
    var overlapdetails = [];
    var overlapgroups = [];
    var overlapsegments = [];
    var sides = [];

    for (var i in overlappingSegments) {
        var segmatches = overlappingSegments[i];
            for (var s in segmatches) {
                var segmatch = segmatches[s];
                if(segmatch.match==''){
                    segmatch.match='Not specified';
                }
                if(segmatch.match !=currentmatch){
                    overlapsegments.push(segmatch);
                    overlapdetails.push(segmatch.match);
                    overlapgroups.push(parseInt(segmatch.group)); 
                }
            }
    }

    master.matches = overlapdetails.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });
    master.groups = overlapgroups.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });
    master.segments = overlapsegments.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });
    for(var g in master.groups){
        var thisg = master.groups[g];       
        if($.inArray(chromogroups[thisg].side,sides)==-1){
            sides.push(chromogroups[thisg].side);
        }
    }
    master.sides = sides;
    //console.log(master);
    return master;

}


function checkSQMatches(match){
    // filter chromomapper for matches with name match
    // change them
    var sqmatches = chromomapper.filter(function(chromomapper) {
            return chromomapper.match == match;                               
        });
    for(var i in sqmatches){
        sqmatches[i].match = escape_quotes(match);
    }
}

function viewMatchDetail(match, returnto){
    if(inMassEditMode()){
        cancelMassEditMode();
    }
    
    closePopups();
    $("#returntolink").attr('class','').css('display','none');
    $("#matchnotes").empty().hide();


    if(typeof(returnto)!=='undefined' && returnto !==false){
        $("#returntolink").css('display','block');
        $("#returntolink a").attr('class','');
        if(returnto.substring(0,3)=='m~|'){
            var returnmatch = returnto.replace('m~|','');
            $("#returntolink a").attr('data-match',returnmatch)
            $("#returntolink a").addClass('view-match');
            $(".returntoname").text('match detail for '+returnmatch);
        }
        else if(returnto.substring(0,3)=='g~|'){
            var returngroup = returnto.replace('g~|','');
            $("#returntolink a").attr('data-group',returngroup)
            $("#returntolink a").addClass('open-group');
            $(".returntoname").text('the group '+chromogroups[returngroup].name);
        } 
        else if(returnto=='matchlist'){        
            $("#returntolink a").addClass('view-matchlist');
            $(".returntoname").text('all matches');
        }     
        else if(returnto=='asd'){        
            $("#returntolink a").addClass('view-report');
            $(".returntoname").text('all segment data');
        }     
    }
    

    $("#oswitchnote").text('');
    $("#matchnswarning").css('display', 'none');
    /*if($("#showkl").prop('checked')){
        setTimeout(function(){
            showKeylines();
        },100);
    } believe no longer needed */ 
    //console.log(match);
    if(match=='Not specified'){
        $("#matchnswarning").css('display', 'block');
    }
    var thismatchname = getMatchById(match, 'name');
    // if the match name has a smart quote in it, 
    $("#oswitch").css('display', 'block');
    var currentmatch = match;
    $(".matchdetailcontainer").removeClass('showmatchnames');
    $("#show_common").prop('checked', false);
    $("#totalmatchcm a").empty();
    $("#avgseg").empty();
    $(".detailmatchname").html(thismatchname);
    $("#currentmatchdetail").attr('data-match', match);
    $("#matchdetailoldname").val(thismatchname);
    $('body').addClass('form-toggled');
    $('#matchdetailformholder, #matchdetailform').hide();
    $("#matchdetail").addClass('active');
    $("#matchdetailformholder").css('display', 'block');
    $("#commonmatches").css('display', 'none');
    // initialise switch
    //$("[name='show_common']").prop('checked', false);
    $("#bothnotice, #matchbothnotice, #mbothwrapper").css('display', 'none');



   // figure out which chromosomes need to be printed out
  
    var chromdata = printDetailChromosomes('',match);

    chromosomesineed = chromdata.distinctChromosomes;
    if(chromosomesineed.length==0){
        chromdata = printDetailChromosomes('',match);
        chromosomesineed = chromdata.distinctChromosomes;
    }
    var detailitems = chromdata.detailItems;
    //console.log(chromosomesineed);
     if($("#showcentromeres").prop('checked')){
        for (var i in chromosomesineed){
            loadCentromeres(chromosomesineed[i],'.matchdetailcontainer');
        }
    }
    //  get match segments using an existing function
    var matchMeta = redrawDetailMatch(match, detailitems);
    var overlapdetails = getCommonMatches(matchMeta.data, match);

    if($.inArray('both', matchMeta.sides)!='-1'){
        $("#verbiage").text('may');
        $("#mbothwrapper, #bothnotice").css('display', 'inline');
    }
    else {
        $("#verbiage").text('appears to');
        if((overlapdetails.sides).indexOf('both')!=-1){
            $("#mbothwrapper, #matchbothnotice").css('display','inline');
        }        
    }

    // calculate total shared cM with this match
    var sharedcm = 0;
    for (var i in matchMeta.data){        

     var thisitemcms = parseFloat(matchMeta.data[i].cM);
        if($.isNumeric(thisitemcms)){
            sharedcm += thisitemcms;
        }
    }
    sharedcm = sharedcm.toFixed(1);
    // get overlapping matches and groups
    //console.log((overlapdetails.segments).length);
  

    if((overlapdetails.segments).length > 1500){
     //   console.log('more than 1000');
        $("#oswitch").css('display','none');
        $("#oswitchnote").text('There more than 1,500 overlapping segments, too many to display at one time');
    }

    $("#commonmatches .cmatches").empty();
    $("#show_common").bootstrapSwitch('destroy');
    //$("[name='show_common']").bootstrapSwitch('state', 'destroy');
    //console.log(overlapdetails);
    if((overlapdetails.matches).length>0){
        $("[name='show_common']").bootstrapSwitch({ 
            state: false,
            onText: 'Yes',
            offText: 'No',
            onSwitchChange: function(event, state) {
                if (state === true) {
                   
                    printMatches(overlapdetails.segments, '.matchdetailcontainer');
                    $(".matchdetailcontainer").addClass('showmatchnames');

                    var groupsneeded = (overlapdetails.groups).concat(matchMeta.keygroups);
                    setTimeout(function(){
                        adjustMatchNames('.matchdetailcontainer', '#matchdetail');
                        //console.log(groupsneeded);
                        var ug = uniqueVals(groupsneeded);
                        //console.log(uniqueVals(groupsneeded));
                        drawDetailKey(ug);
                    }, 100);     
                    $(".bootstrap-switch-container").css('transform', 'translateZ(0)');


                    //paintCommonMatches();
                } else {
                    //removeCommonMatches();
                    viewMatchDetail(currentmatch);
                    $(".matchdetailcontainer").removeClass('showmatchnames');
                    drawDetailKey(matchMeta.keygroups);

                }
            }
        });

        var cmatchstring = '';
        var lone = '';
        if((overlapdetails.matches).length==1){
            lone = ' class="lone"';
        }
        overlapdetails.matches.sort(byMatchName);
        for (var i in overlapdetails.matches){
            var segmatch = overlapdetails.matches[i];
            var thismatchname = getMatchById(segmatch, 'name');
            if(segmatch !=match){
            // (the seg itself will always be in there!)
                cmatchstring += '<li'+lone+'><a href="#" class="view-match other-views" data-return="m~|'+match+'" data-match="'+segmatch+'">'+thismatchname+'</a></li>';
            }
        }
        $("#commonmatches .cmatches").append(cmatchstring);

        $("#commonmatches .cgroups").empty();
        var cgroupstring = '';
        var lone = '';
        if((overlapdetails.groups).length==1){
            lone = ' class="lone"';
        }        
       
        overlapdetails.groups.sort(byGroupName);
        for (var i in overlapdetails.groups){
            var groupmatch = overlapdetails.groups[i];
                cgroupstring += '<li'+lone+'><a href="#" class="open-group other-views" data-return="m~|'+match+'" data-group="'+groupmatch+'">'+chromogroups[groupmatch].name+'</a></li>';
        }
        $("#commonmatches .cgroups").append(cgroupstring);        
        $("#commonmatches").css('display', 'block');

    }
    else {
        $("#commonmatches").css('display','none');
        $("#oswitchnote").text('There are no matches that overlap significantly with '+thismatchname);

    }
   


   

    // get segment count
    var segcount = $(".matchdetailcontainer strong[data-match='"+match+"']");

    if(segcount.length==1){
        $(".matchsegcount").text('1 segment');    
    }
    else {
        $(".matchsegcount").text(segcount.length+' segments');
    }
    if(sharedcm >0){
       $("#totalmatchcm a").text(sharedcm+'cM shared');
       $("#totalmatchcm a").attr('href','/tools/sharedcmv4/'+sharedcm);
       if(segcount.length >1){
           $("#avgseg").text("(average: "+(parseFloat(sharedcm)/segcount.length).toFixed(1)+"cM)");
       }
       else {
        $("#avgseg").text('');
       }
        $("#totalmatchcm").css('display','block');
    }
    else {
        $("#totalmatchcm").css('display','none');
    }

    // go through the groups and output links
    // get rid of old ones
    $(".detail-group-link").remove();

    for (var i in matchMeta.keygroups) {
        var clone = $("#group_link_template").clone();
        $(clone).prop('class', 'detail-group-link').removeAttr("id");
        var thisgroup = matchMeta.keygroups[i];
        var anchor = $(clone).find('a');
        $(anchor).attr('data-group',thisgroup);
        $(anchor).attr('data-match',match);

        var namespan = $(clone).find('span');
        namespan.text(chromogroups[thisgroup].name);
        $(clone).appendTo($("#detail_group_links"));
    }

    var pastestring = '';
    if(matchMeta.keygroups.length ==1){
        $(".detailheader .add-segments").attr('data-group',matchMeta.keygroups[0] );
    }
   

    for (var i in matchMeta.data){
        pastestring += getSegmentData(matchMeta.data[i]);
    }
    $("#match-seg-data").text(pastestring);
    var matchdatasource = $("#match-seg-data");    
    var clipboard = new Clipboard('.copy-match-segments', {
        text: function(trigger) {
            return matchdatasource.val();
        }
    });
    clipboard.on('success', function(e) {
        $("#copied-match").delay(200).fadeIn().delay(500).fadeOut();
    });
    clipboard.on('error', function(e) {
        $("#copiedmatch-flash-ctrl").delay(200).fadeIn().delay(500).fadeOut();
    });    

    var matchnotes = compileMatchNotes(match);
    if(matchnotes !=''){
        $("#matchnotes").html(matchnotes).css('display','block');
    }

    // hide any sides not being used!
    // TODO - go through chromosomes.
    /*
    var sides = ['mat', 'pat', 'both'];
    for (var i in sides){
        //console.log(sides[i]);
        //console.log($.inArray(sides[i],matchMeta.sides));
         if($.inArray(sides[i],matchMeta.sides)==-1){
            $("#matchdetail .cp div."+sides[i]).css('display','none');
         }
         else {
            $("#matchdetail .cp div."+sides[i]).css('display','block');
         }
    }*/
    setTimeout(function(){
        adjustMatchNames('.matchdetailcontainer', '#matchdetail');
    }, 100);

    drawDetailKey(matchMeta.keygroups);
    
    setTimeout(function(){
        filterSegmentsIfNecessary();
    },100);

    $("#matchdetail").show();
}


function compileMatchNotes(match){
    var mynotes = '';
    var thismatch = getMatchById(match);
    if(typeof(thismatch.notes)!=='undefined' && thismatch.notes !=''){
        mynotes = thismatch.notes;
    }
    
    else {
        var segs = getMatchSegments(match, "all", "#matchdetail");
        // segs holds the array position of each match segment
        // loop through these. if trimmed notes are not an empty string and not equal to the current one, add them
        var matchnotes = [];
        for (var i in segs){
            var thesenotes = nl2br($.sanitize(chromomapper[segs[i]].notes));
            if(thesenotes !='' && $.inArray(thesenotes, matchnotes)==-1){
                // prob with this is it inserts empty records
                //matchnotes[i] = thesenotes;
                matchnotes.push(thesenotes);
                // todo - make this an object and put the index in too...        
            }
        }
        //console.log(segs);
        var mynotes = (matchnotes.join('<br />')).replace(/^<br \/>/,'');

    }
   
    //mynotes = mynotes.replace(/<br>\n/, '');
      var editlink = ' <a class="editmatch" data-match="' + match + '">edit</a>';
      var title = '<strong>Match notes</strong><br />';
            
                mynotes = addLinks(mynotes);
                if(mynotes==''){
                    return false;
                }
                var printnotes = title+ nl2br(mynotes) + '<br />'+editlink;
                return printnotes;
            }

function byGroupName(a,b){
            var nameA = chromogroups[a].name.toUpperCase();
            var nameB =  chromogroups[b].name.toUpperCase();
            var comparison = 0;           
              // sort alphabetically
            comparison = (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;            
            return comparison;
}

function viewGroupDetail(group, match, force) {
    if(inMassEditMode()){
        cancelMassEditMode();
    }  
    closePopups();
    $("#filterdatagroup").val('');
   
    $(".groupdetailcontainer .openmem").css('display','block');
   //  console.log(group);
    //$("input.togglematches").prop("checked", false);
    $("#load-group").css('display', 'block');
    //return false;
    //console.log('loading group');
    $(".merge-groups").css('display','none');
    $(".btncell").remove();

    $("#matchdetailheader").hide();
    if(chromogroups.length>1){
        $(".mergegroup-choose").css('display','inline');
    }
    else {
        $(".mergegroup-choose").css('display','none');
    }
    //resetMasterChr();
    if (typeof(match) !== 'undefined' && match.match != '') {
        var activeMatch = match;
    }
    else {
        var activeMatch = false;
    }
        // this is the bit I had to put in to get the loading message to come up.  
        setTimeout(function(){
          //  var t0 = performance.now();

            $("#totalgroupcm").empty();
            $("#knownunknown").empty();
            $('body').addClass('form-toggled');

            $('.tpd-tooltip').hide();
            // count groups and hide nav buttons if only one
            if (chromogroups.length == 1) {
                $(".next-group").hide();
                $(".prev-group").hide();
            } else {
                $(".next-group").show();
                $(".prev-group").show();
            }

            $("#groupdetail").addClass('active');

            //populate the data id of the button with the id
            var thisgroup = getGroup(group);
            //console.log(thisgroup);
            $("#totalgroupcm").text(getTotalcMForGroup(group));
            if(typeof(thisgroup.ancestor) !=='undefined' && thisgroup.ancestor==1){
                $("#knownunknown").text('Known ancestor');
            }
            else {
                $("#knownunknown").text('Not a known ancestor');
            }
            //if(!isTouchDevice()){
            //        Tipped.create('#totalgroupcm', 'The total cM for segments painted in this group (even if they overlap)');
            //}
            var grouptext = getPercentageForGroup(group);
            if(grouptext){
                $("#totalgroupperc").text(grouptext);
            }
            else {
                $("#totalgroupperc").text('');

            }
            $("#detailgroupnotes").empty().hide();
            $(".del-empty-group").hide()
            $("#chr-groupdetail-key ul").remove();
            $("#showallmatches").css('display', 'none');

            // print out the name
            $("#detailgroupname").text(thisgroup.name);
            $("#detailgroupname").attr('data-group',group);

            $(".editgroup").attr('data-group', group);
            $(".del-empty-group").attr('data-group', group);

            // figure out which chromosomes need to be printed out
            // passing 'true' so that it returns the element rather than appending it.
            var chromdata = printDetailChromosomes(group, '', true);
            if((chromdata.detailItems).length >1500){
                $(".groupdetailcontainer .openmem").css('display','none');
            }
            chromosomesineed = chromdata.distinctChromosomes;
            //console.log(chromosomesineed);
            var groupItems = chromdata.detailItems;
            if(chromosomesineed.length==0){
                $(".del-empty-group").css('display','block');
                $(".groupdetailcontainer .openmem").css('display','none');
            }
           

            // new - try doing the appending here to container
            // (if you pass true to printdetail chromosomes, it creates a document fragment and returns it for you.)
            var container = chromdata.container;
            // pass temp as container
            redrawDetailGroup(group, chromosomesineed, container);



            if($("#showcentromeres").prop('checked')){
                for (var i in chromosomesineed){
                    loadCentromeres(chromosomesineed[i],'.groupdetailcontainer');
                }
            }

            // if group is maternal, hide paternal and vice versa
            $(".groupdetailcontainer").removeClass('groupsideboth groupsidemat groupsidepat');
            $(".groupdetailcontainer").addClass('groupside' + thisgroup.side);
            //console.log(thisgroup.side);
            if (thisgroup.side == 'mat') {
                $("#detailgroupside").text('Maternal');
              //  $(".chrdetailchromosome .pat").hide();
              //  console.log($(".chrdetailchromosome .pat"));
            } else if (thisgroup.side == 'both') {
                $("#detailgroupside").text('Unknown or Shared');
               // $(".chrdetailchromosome .mat").hide();
            } else {
                $("#detailgroupside").text('Paternal');
               // $(".chrdetailchromosome .mat").hide();
            }
            if (thisgroup.notes != '') {
                var editlink = ' <a class="editgroup" data-group="' + group + '">edit</a>';
                var mynotes = $.sanitize(thisgroup.notes);
                //mynotes = mynotes.replace(/\&gt;/g, ">");
                //mynotes = mynotes.replace(/\&gt;/g, ">");
                //console.log(mynotes);
                //mynotes = mynotes.replace(/\&lt;/g, "<");
                mynotes = mynotes.replace(/\>/g, "&gt;");
                mynotes = mynotes.replace(/\</g, "&lt;");

                // Set the regex string
                //var regex = /(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig
                // Replace plain text links by hyperlinks
                //mynotes = mynotes.replace(regex, "<a href='$1' target='_blank'>$1</a>");
                //console.log(mynotes);
                mynotes = addLinks(mynotes);
                var printnotes = nl2br(mynotes) + editlink;
                $("#detailgroupnotes").html(printnotes).show();
            }

            //var groupItems = getGroupItems(group);
            // sort them on item match
            /*groupItems= groupItems.sort(function (a, b) {
              return a.match.localeCompare( b.match );
            });*/
            //console.log(groupItems);

            // print the key

            if(groupItems.length < 1000 || typeof(force)!=='undefined') {
                var distinctMatches = printGroupDetailKey(groupItems, activeMatch);
                if (distinctMatches.length > 1) {
                    $("#showallmatches").css('display', 'inline');
                }
                $(".keytitle").css('display','block');
                $(".btncell").remove();

            }
            else {
                //console.log('group has '+groupItems.length+' segments');
                $(".keytitle").css('display','none');
                $("#chr-groupdetail-key").append('<ul><li class="btncell"><button class="btn btn-secondary load-mn" data-group="'+group+'">Load match names</button></li></ul>');
                $(".filtergroupblock").css('display', 'block');
                // TODO - print a button that says 'Load match key for this group'
                // when you click on this it loads the key
            }
                   

            // check for 'default to show names option'
            if($("#gshownames").prop('checked')){
                if(!$("#showmatchnames").prop('checked')){
                    $("#showmatchnames").trigger('click');
                    $(".groupdetailcontainer").addClass('showmatchnames'); 
                }
            }
            if($("#gshowcm").prop('checked')){
                $(".groupdetailcontainer").addClass('showmatchcm'); 
            }            
            else {
                $(".groupdetailcontainer").removeClass('showmatchcm'); 
            }        
            setTimeout(function(){
                filterSegmentsIfNecessary();
            },100);

            $("#load-group").css('display','none');
    //   var t1 = performance.now();
    //console.log("Print group took " + (t1 - t0) + " milliseconds.")              
            // try moving this in here
           //console.log($(".togglematches").prop('checked'));
           
          

          if(activeMatch){
               setTimeout(function(){
                match = match.replace('&quot;','"');
               // console.log(match);
                   toggleMatchHeader(match);
               }, 500);// extended this.
            }
    },100);
       

    // wrap each group in its own div to keep on one line
    //$.each(distinctMatches, function( index, value ) {
    //console.log("[data-match="+url_slug(value)+"]");
    //  $(".chrdetailchromosome strong[data-match="+url_slug(value)+"]").wrapAll('<div></div>');
    //});



    //  console.log(chromosomesineed);

    $("#groupdetail").css('display', 'block');   
  
   // $("#load-group").hide();
    //console.log('finished loading group');
    //$("#loadme").removeClass('loading');
   // $("#grouploader").remove();

}

function uniqueVals(array) {
    return $.grep(array, function(el, index) {
        return index == $.inArray(el, array);
    });
}

function redrawDetailGroup(group, chromosomesineed, container){
    //var t0 = performance.now();
    //console.log(container);
// remove
    //console.log($('.groupdetailcontainer strong.g' + group));
    //console.log($('.chrdetailchromosome .cp > div'));
    //console.log('heaving');
    if(typeof(container)==='undefined'){
        $('.chrdetailchromosome .cp > div').empty();
    }
    //$('.groupdetailcontainer strong.g' + group).remove();
    //var groupItems = getGroupItems(group);
    for (var i in chromosomesineed){
        printChromosomeMatches(chromosomesineed[i], group, container);
    }

    if(typeof(container)!=='undefined'){
     if($(".togglematches").prop('checked')){
                //console.log('ok then will adjust');
                setTimeout(function(){
                    adjustMatchNames('.groupdetailcontainer', '#groupdetail');
                }, 100);                
            }
    }
   // console.log($(container));
    setTimeout(function(){
        if(typeof(container)!=='undefined'){
            //console.log($(container));
            //$(".groupdetailcontainer").append($(container).innerHTML);
            $(".groupdetailcontainer").append(container);
            //$(".groupdetailcontainer").append("<div>hello</div>");

        }
    },10);


    //printChromosomeMatches('all', group);

    //printMatches(groupItems, ".groupdetailcontainer");
    //$(".chrdetailchromosome strong").wrap('<div></div>');
    //var t1 = performance.now();
    //console.log("redrawDetailGroup took " + (t1 - t0) + " milliseconds.");
 //return groupItems;
}

function redrawDetailMatch(match, detailItems){
// remove
    $('.matchdetailcontainer .cp > div').empty();
    //var detailItems = getGroupItems('','',match);
    printMatches(detailItems, ".matchdetailcontainer");
    //$(".chrdetailchromosome strong").wrap('<div></div>');
    // return an array of the sides being used
    //console.log(detailItems);
    var uniqueGroups = [];
    for(i = 0; i< detailItems.length; i++){    
        //console.log(parseInt(detailItems[i].group));
        if(uniqueGroups.indexOf(parseInt(detailItems[i].group)) === -1){
            uniqueGroups.push(parseInt(detailItems[i].group));
        }        
    }
    var uniqueSides = [];
    for(i = 0; i< uniqueGroups.length; i++){    
        var thisgroup = uniqueGroups[i];
       
        if(uniqueSides.indexOf(chromogroups[thisgroup].side) === -1){
            uniqueSides.push(chromogroups[thisgroup].side);        
        }        
    }
    var matchMeta = [];
    matchMeta.sides = uniqueSides;
    matchMeta.keygroups = uniqueGroups;
    matchMeta.data = detailItems;
    return matchMeta;
    // get the distinct groups
    // get the distinct sides
    //return detailItems;
}

function invertColor(r, g, b, bw) {

    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ?
            '#000000' :
            '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return

    return [r, g, b];
    //return "#" + padZero(r) + padZero(g) + padZero(b);
}

function addLinks(mystring){
     // Set the regex string
     var regex = /(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/\-_\.]*(\?\S+)?)?)?)/ig
        // Replace plain text links by hyperlinks
     return mystring.replace(regex, "<a href='$1' target='_blank'>$1</a>");
}


function printGroupDetailKey(groupItems, activeMatch) {
    // data-match
    // get the distinct data-match items
    $(".filtergroupblock").hide();
    var myMatches = [];
    for (var i in groupItems) {
        var match = groupItems[i];
        if (typeof(match.match) === 'undefined' || match.match == '') {
            myMatches.push('Not specified');
        } else {
            myMatches.push(match.match);
        }
    }    
    var distinctMatches = myMatches.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });

    //groupItems.filter(function(item, i, ar){  return ar.indexOf(item.match) === i; });  
    //console.log(distinctMatches);
        for (var i in distinctMatches) {
            distinctMatches[i].arrayPosition = i;
        }
    //distinctMatches.sort();
    // case insensitive sort
    distinctMatches.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    //console.log(distinctMatches);
    var indmatches = '';  
    var container = document.createDocumentFragment();
    var tempul = document.createElement("ul");

    for (var m in distinctMatches) {
        //console.log(distinctMatches[m]);
        if (distinctMatches[m] == 'undefined' || typeof(distinctMatches[m]) === 'undefined') {
            distinctMatches[m] = 'Not specified';
        }
        var slug = distinctMatches[m];
        //console.log(distinctMatches[m]);
        //indmatches += "<li class='indmatch dr'><em class='grippy'></em><a href='#' title='click to highlight and view more options for this match' data-match='" + slug + "'><span>" + distinctMatches[m] + "</span></a></li>";
       
        var temp = document.createElement("li");
        $(temp).addClass('indmatch dr');
        var thismatchname = getMatchById(distinctMatches[m], 'name');
        temp.innerHTML = "<em class='grippy'></em><a href='#' title='click to highlight and view more options for this match' data-match='" + slug + "'><span>" + thismatchname + "</span></a>";
        //var temp =  "<li class='indmatch dr'><em class='grippy'></em><a href='#' title='click to highlight and view more options for this match' data-match='" + slug + "'><span>" + distinctMatches[m] + "</span></a></li>";

        tempul.appendChild(temp);
    }
    //$("#chr-groupdetail-key").append(indmatches);
    container.appendChild(tempul);
    $("#chr-groupdetail-key").append(container);

    if(groupItems.length>0){
        $("#chr-groupdetail-key").show();
        initiateDraggables(match.group);
    }
    if(activeMatch){
        var item = $(".indmatch a[data-match='"+activeMatch+"']");
        /*if(item.length==1){
            setTimeout(function() {
                toggleMatchEdit(item);
            }, 100);
        }*/
    }
    //console.log(distinctMatches);
    if(distinctMatches.length > 4){
        $(".filtergroupblock").show();
    }
    return distinctMatches;

}


function initiateDraggables(group){
    // populate the .groupbuckets
     getGroupBuckets(group);

     $(".groupbuckets li").droppable({
            accept: ".dr",
            drop: function (event, ui) {     
            // mark it as dropped
  // call the function to move the match into that group
            // delete the dragged item and its associated matches
                       // print a 'moved' message
            var currentgroup = $(".editgroup").attr('data-group');
            var newgroup =  $(event.target).attr('data-group');
            //var myelem = $(ui.draggable).find('a');
            //var matchslug = ($(myelem).attr('data-match'));
            var mymatch = $(ui.draggable).find('a').text();
            if(newgroup=='new'){
                $("#movingmatch").text(mymatch);
                $("#ngcurrentgroup").val(currentgroup);
                $("#ngmatch").val(mymatch);

                initialiseColorPicker('ngnewgroupcolor', 'random'); 
                $(ui.draggable).hide();
                $("#ngnewgroupname").val('');
                $(".newgroupformholder").show();
                $("#ngnewgroupname").focus();
                //console.log('new group');
                return false;
            }
            $(ui.draggable).remove();

            // console.log( ui.draggable.attr('data-match') );
            switchmatchgroup(mymatch, currentgroup, newgroup);

            }

     });

     
        $('#btop').droppable({
            greedy:true,
            over: function(event, ui){
                $('.groupbuckets').autoscroll({
                    direction: 'up',
                    step: 500,
                    scroll: true
                });
                $(".groupbuckets li").droppable('disable');
            },
            out: function(event, ui){
                $('.groupbuckets').autoscroll('destroy');
                $(".groupbuckets li").droppable('enable');

            },
            drop: function(event,ui){
                $(ui.draggable).removeAttr("style");
            }
        });

        $('#bbottom').droppable({
            greedy:true,
            over: function(event, ui){
                $('.groupbuckets').autoscroll({
                    direction: 'down',
                    step: 500,
                    scroll: true
                });
                $(".groupbuckets li").droppable('disable');                
            },
            out: function(event, ui){
                $('.groupbuckets').autoscroll('destroy');
                $(".groupbuckets li").droppable('enable');                
            },
            drop: function(event,ui){
                $(ui.draggable).removeAttr("style");
            }
        });



     $("li.indmatch").draggable({
        cursor: 'move',
        scroll: 'true',
        handle: '.grippy',
        refreshPositions: true,
        start: function(event, ui){
            // show a set of buckets to drop the match into
           $(".groupbucketsholder").show();
           $("#chr-groupdetail-key").addClass('drg');
           $(this).attr('title','Drop this match into a new group to move it');
           //$(this).appendTo(".groupbucketsholder");
            //ui.helper.data('dropped', false);
        },  
        revert: "invalid",        
        stop: function(event, ui){
            $(".groupbucketsholder").fadeOut();   
            $("#chr-groupdetail-key").removeClass('drg');        
        }
    });
}


function getGroupBuckets(exclude) {  
    var buckets = '';
    var groupsforsort = JSON.parse(JSON.stringify(chromogroups));
    for (var i in groupsforsort) {
        groupsforsort[i].arrayPosition = i;
    }
    sortedgroups = groupsforsort.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    // console.log(sortedgroups);
    $(sortedgroups).each(function(index) {
        if(exclude !=this.arrayPosition)         
            {
            
            buckets += '<li data-group="'+this.arrayPosition+'"><div style="border:3px solid '+this.color+'"><strong>'+this.name+'</strong><span></span></div></li>';
            }            
    });
    buckets += '<li data-group="new"><div style="border:3px solid #333"><strong>Add to a new group</strong><span></span></div></li>';
    $(".groupbuckets").empty().append(buckets);

    //if(typeof(exclude) != 'undefined' && count ==0){
    //    return false;   
}

function switchmatchgroup(match, currentgroup, newgroup, undoing){
    // get all the chromomapper segments with this match and this group
    // change them to the new group
    //console.log('moving '+match+ ' from '+chromogroups[currentgroup].name+' to '+chromogroups[newgroup].name);

    $("#matchdetail").hide();
    var matchsegments = getMatchSegments(match, currentgroup, "#groupdetail");
    
    for (var i in matchsegments) {
        var arrayPosition = matchsegments[i];
        if($.isNumeric(newgroup)){
            removeSegment(arrayPosition);
            chromomapper[arrayPosition].group = newgroup;
            printMatch(arrayPosition);            
            //console.log(arrayPosition);
        }                         
    }
    writeDataToMap('all');
    // don't need to redraw groups- just close and open.
   
    setTimeout(function(){
        viewGroupDetail(currentgroup, '', true);
    },100);
/* end paste */
    if(typeof(undoing)==='undefined'){
        $("#match-flash").html('Match "'+match+'" moved to group "'+chromogroups[newgroup].name+'" <a href="#" data-match="'+match+'" data-group="'+currentgroup+'" data-currentgroup="'+newgroup+'" class="undo-move">Undo</a>').delay(500).fadeIn().delay(7000).fadeOut();
    }
    else {

        $("#match-flash").text('Undone');
    }
}


function url_slug(Text) {
    return Text
        .toLowerCase()
        .replace(/ /g, '-')
        /*.replace(/[^a-zA-Z0-9_U+0590-U+05FF\s-]/g,'');*/
        .replace(/[^\w-]+/g, '');
}


function createFragment(htmlStr) {
    var frag = document.createDocumentFragment(),
    temp = document.createElement('div');
    temp.innerHTML = htmlStr;
    while(temp.firstChild) {
        frag.appendChild(temp.firstChild);
    }
    return frag;
}

function printDetailChromosomes(group, match, append) {
    if(typeof(match)!=='undefined' && match !=''){
        removeMatches(null, null, match, ".chrdetailchromosome");
        var detailItems = getGroupItems('','',match);
        var cloneitem = "#match_detail_template";
        var container = '.matchdetailcontainer';
        //console.log(detailItems);
    }
    else {
        // it's a group
        removeMatches(group, null, null, ".chrdetailchromosome");
        var detailItems = getGroupItems(group);
        var cloneitem = "#group_detail_template";
        var container = '.groupdetailcontainer';
    }
    if(append){
        //var container = createFragment('<div id="tempcontainer"></div>');
        var container = document.createDocumentFragment();
     }
    // TODO - should the above have the context? not sure.
    // I think they can be removed from anywhere.
    $("#groupdetail .chrdetailchromosome, #matchdetail .chrdetailchromosome").remove();
      //console.log('removed chrdetailchromosome');
    var detailChromosomes = [];
    // sort in group order
    detailItems = detailItems.sort(function(a, b) {
        return parseInt(a.chromosomes) > parseInt(b.chromosome);
    });
    //console.log(detailItems);
    for (var i in detailItems) {
        var match = detailItems[i];
        detailChromosomes.push(match.chromosome);
    }
    var distinctChromosomes = detailChromosomes.filter(function(item, i, ar) {
        return ar.indexOf(item) === i;
    });
    // if it has X in it, take it out for the sort
    var Xposition = $.inArray('X', distinctChromosomes);
    if(Xposition >-1){
      distinctChromosomes.splice(Xposition,1);
    }
    //console.log(distinctChromosomes);
    distinctChromosomes.sort(sortNumber);
    //console.log(distinctChromosomes);
    if(Xposition >-1){
      distinctChromosomes.push('X');
    }
    //setTimeout(function(){
        for (i in distinctChromosomes) {
            var clone = $(cloneitem).clone();
            $(clone).prop('class', 'chrdetailchromosome').removeAttr("id");

            // $(clone).prop('id','');
            $('h4', clone).text(distinctChromosomes[i]);
            $(clone).appendTo($(container));

            var chromosomeLength = $("#chr > div#p" + distinctChromosomes[i]).attr('data-length');
            $(clone).attr('data-length', chromosomeLength);
            $(clone).attr('id', 'p' + distinctChromosomes[i]);
            //console.log(distinctChromosomes[i]);
        }      
    //},15);
    //console.log(container);
    $(".chrdetailchromosome").show();
    var detail = {};
    detail.distinctChromosomes = distinctChromosomes;
    detail.detailItems = detailItems;
    detail.container = container;
    console.log(detail);
    return detail;
}

function sortNumber(a, b) {
    return parseInt(a) - parseInt(b);
}

function fixSeg(seg){
    // excerpt to fix legacy data from when there was a bug
    // create a new group for the segment and apply it
    chromomapper[seg].group = addNewGroup(chromogroups);    
    // draw the key
    drawKey();
    // save the data
    writeDataToMap();
    closeOverlays();
    // save
    // create an untitled group
    // set the group for this seg to be that group
}


function viewAllMatchesReport() {
    console.log('called');
    $('body').addClass('form-toggled');
    $("#matchlist").css('display', 'block');
    $("#matchlistpeople").empty();
    $("#filtermatchlist").val('');
    // go through chromomapper and get a list of matches
    var currentmatch = '';
    var allmatches = [];
    //chromomapper.sort(compare);
    testcm = JSON.parse(JSON.stringify(chromomapper));
    testcm.sort(compare);
    // make a copy of chromomapper but sort on match name
    console.log(testcm);
    // I would like to add largest segment and average segment size in
    var currentcm = 0;
    var rtotalcm = 0;
    var highestcm = 0;
    var currentcount = 0;
    var overallcount = 0;
    var currentmatchside = '';
    var currentover20count = 0;
    var tempgs = '';
    for (var i in testcm){
        if (typeof(testcm[i].match) === 'undefined' || testcm[i].match == '') {
            thismatch = 'Not specified';
        } else {
            thismatch = testcm[i].match;
        }
        overallcount++;
        //console.log(thismatch);
        if(thismatch !=currentmatch){
            // we have a new match. store the last one
            var matchtopush = {};
            matchtopush.side = printMatchSide(currentmatchside);
            matchtopush.match = currentmatch;
            matchtopush.matchname = getMatchById(currentmatch, 'name');
            matchtopush.lg = highestcm;
            matchtopush.av = parseFloat((rtotalcm/currentcount).toFixed(1));
            matchtopush.tl = rtotalcm.toFixed(1);
            matchtopush.sg = currentcount;
            matchtopush.over = currentover20count;

            if(currentcount>0){
                allmatches.push(matchtopush);
            }
            currentcount = 0;
            currentover20count = 0;
            if($.isNumeric(testcm[i].cM)){
                highestcm = parseFloat(testcm[i].cM);
            }
            else {
                highestcm = '';
            }
            //allmatches.push(thismatch);
            rtotalcm = 0;
            tempgs = '';
            currentgroupside = '';
            //if(overallcount> 15) break;
        }
        if($.isNumeric(testcm[i].cM)){

            if(parseFloat(testcm[i].cM) > highestcm){
                highestcm = parseFloat(testcm[i].cM);
            }
            if(parseFloat(testcm[i].cM) >= 20){
                currentover20count++;
            } 
            currentcm = parseFloat(testcm[i].cM);
            rtotalcm += parseFloat(testcm[i].cM);

        }
        currentmatchside = chromogroups[testcm[i].group].side;
       
        if((tempgs !=currentmatchside && currentmatchside !='' && tempgs !='')|| tempgs =='both'){
            currentmatchside = 'both';        
        }
      
        tempgs = currentmatchside; 
          
        currentmatch = thismatch;
        currentcount++;

    }
    
    // push the final match.
    if(testcm.length){

        var matchtopush = {};
        matchtopush.match = currentmatch;
        matchtopush.matchname = getMatchById(currentmatch, 'name');
        matchtopush.side = printMatchSide(currentmatchside);
        matchtopush.lg = highestcm;
        matchtopush.sg = currentcount;
        matchtopush.av = parseFloat((rtotalcm/currentcount).toFixed(1));
        matchtopush.tl = rtotalcm.toFixed(1);
        matchtopush.over = currentover20count;

        allmatches.push(matchtopush);
    }

    //console.log(allmatches);
    //allmatches = uniqueVals(allmatches);
        // alphabetise it
    //allmatches = allmatches.sort(function (a, b) {
    //    return a[nm].toLowerCase().localeCompare(b[nm].toLowerCase());
    //});
    allmatches = allmatches.sort(compare);
    mystring = '';
    for(var i in allmatches){
        // todo - if it's 0.00 / 0 - put a blank or something in there.
        mystring += '<tr><td class="mlname"><a href="#" class="view-match" data-return="matchlist" data-match="'+allmatches[i].match+'">'+allmatches[i].matchname+'</a></td><td class="side">'+allmatches[i].side+'</td><td class="mltotal">'+allmatches[i].tl+'</td><td class="mlsegs">'+allmatches[i].sg+'</td><td>'+allmatches[i].lg+'</td><td>'+allmatches[i].av+'</td><td>'+allmatches[i].over+'</td></tr>';
    }
    $("#matchlistpeople").append(mystring);
    // make a string of <li>
    // append to 
    $("#matchlisttable").tablesorter({
        sortList: [
            /*[2, 1],*/
            [2, 1],
            [4, 1]            
        ]
    });    
    var sorting = [
        /*[2, 1],*/
        [2, 1],
        [4, 1]
    ];
    $("#matchlisttable").trigger('update', [sorting]);



}

/*function oldviewMatchList() {
    $('body').addClass('form-toggled');
    $("#matchlist").css('display', 'block');
    $("#matchlistpeople").empty();
    $("#filtermatchlist").val('');
    var currentmatch = '';
    var allmatches = [];
    testcm = JSON.parse(JSON.stringify(chromomapper));
    testcm.sort(compare);

    for (var i in testcm){
        if (typeof(testcm[i].match) === 'undefined' || testcm[i].match == '') {
            thismatch = 'Not specified';
        } else {
            thismatch = testcm[i].match;
        }
        if(thismatch !=currentmatch){
            allmatches.push(thismatch);
        }
        currentmatch = thismatch;
    }
    allmatches = uniqueVals(allmatches);
    allmatches = allmatches.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    mystring = '';
    for(var i in allmatches){
        mystring += '<li><a href="#" class="view-match" data-match="'+allmatches[i]+'">'+allmatches[i]+'</a></li>';
    }
    $("#matchlistpeople").append(mystring);

}*/

function getIdentifier(){
    return getHighestID()+1;
}
function assignIDs(){
    var currentID = getHighestID();
    for(var i in chromomapper){
        if(typeof(chromomapper[i].id==='undefined')){
            currentID +=1;
            chromomapper[i].id = currentID;
        }
    }
}

function getHighestID(){
    if(chromomapper.length==0){
        return 0;
    }
    var mymax = Math.max.apply(Math, chromomapper.map(function(o) { return o.id; }));
    if(isNaN(mymax)){
        return 0;
    }
    return mymax;
}

function printMatchSide(currentmatchside){
    if(currentmatchside=='pat'){
        return 'Paternal';
    }
    else if (currentmatchside=='mat'){
        return 'Maternal';
    }
    return 'Unknown or Both';    
}



var groupMutator = function(value, data, type, params, component){
  if(typeof(chromogroups[value])!=='undefined'){
    return chromogroups[value].name;
  }
  return 'Unknown';
}

var sideMutator = function(value, data, type, params, component){
  console.log(value);
  if(typeof(chromogroups[value])!=='undefined'){
    return chromogroups[value].side;
  }
  return 'Unknown';
}

function getFormattedGroup(cell){
    var thiscell = cell.getValue();
 if(typeof(chromogroups[thiscell])!=='undefined'){
    console.log(chromogroups[thiscell].name);

    return chromogroups[thiscell].name;
  }
  return 'Unknown';
}

function getGroupKeyValues(){
    var myobj = {};
    for (var i in chromogroups){
        myobj[i] = chromogroups[i].name;
    }
    return myobj;
}

function getMatchKeyValues(){
    var myobj = {};
    for (var i in dp.map.matches){
        myobj[dp.map.matches[i].id] = dp.map.matches[i].name;
    }
    return myobj;
}




function matchAny(data, filterParams){
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter

    var match = false;
    for(var key in data){
        //console.log(data[key]);
        //console.log(typeof(data[key]));
        if(typeof(data[key])!='undefined' && (data[key].toString().toLowerCase()).indexOf((filterParams.value).toLowerCase())!==-1){
            match = true;
        }
        if(key=='certainty'){
            if((certaintyToText(data[key]).toLowerCase()).indexOf((filterParams.value).toLowerCase())!==-1){
                match = true;
            }
        }
        if(key=='group'){
            var thisgroup = data[key];
            if(
                (chromogroups[thisgroup].name).toLowerCase().indexOf((filterParams.value).toLowerCase()) !==-1){
                match = true;
            }
            if(
                (chromogroups[thisgroup].side == 'mat' && ('maternal').indexOf((filterParams.value).toLowerCase()) !==-1)
                || (chromogroups[thisgroup].side == 'pat' && ('paternal').indexOf((filterParams.value).toLowerCase()) !==-1)
                || (chromogroups[thisgroup].side == 'both' && ('unknown or shared').indexOf((filterParams.value).toLowerCase()) !==-1)

                ){
                match = true;
            }
        }
    }
    return match;
}


function printInlineSegmentEditor(){
  $('body').addClass('form-toggled');



    if ($("#mapName").text() != '') {
        var reportname = $("#mapName").text();
    }
// validator to prevent start from being after end 
var startValidator = function(cell, value, parameters){
    //cell - the cell component for the edited cell
    var row = cell.getRow();
    var rowdata = row.getData();
    value = value.replace(/,/g,'');
    if(isNaN(value)===false && (parseInt(value) < parseInt(rowdata.end))){
        return true;
    }
    return false;
}

// validator to prevent start from being after end 
var endValidator = function(cell, value, parameters){
    //cell - the cell component for the edited cell
    var row = cell.getRow();
    var rowdata = row.getData();    
    value = value.replace(/,/g,'');
    if(isNaN(value)===false && (parseInt(value) > parseInt(rowdata.start))){
        return true;
    }
    return false;
}

var snpValidator = function(cell, value, parameters){
    //cell - the cell component for the edited cell
 
    var rowdata = cell.getData();    
    value = value.replace(/,/g,'');
    if(isNaN(value)===false && value < 130000){
        return true;
    }
    return false;
}

var cMValidator = function(cell, value, parameters){
    //cell - the cell component for the edited cell
 
    var rowdata = cell.getData();    
    value = value.replace(/,/g,'');
    // could make this a bit more thorough but for now: 286 is max for chr1
    if(isNaN(value)===false && value < 290){
        return true;
    }
    return false;
}

var editedNumberMutator = function(value, data, type, params, component){
    return Math.abs(parseInt(numberWithoutCommas(value)));
}

    var table = new Tabulator("#reportnew", {        
    height:  window.innerHeight-60,
    layout:"fitDataStretch",
    selectable:true,
   /* selectableRangeMode:"click",*/
    reactiveData:true,
    columnHeaderSortMulti:true,
    data: chromomapper,
    rowSelected:function(row){
        $("#delete-tabulator-rows").css('display', 'block');
    //row - row component for the selected row
    },    
    columns:[
        {title:"", cssClass: "repcheck",headerSort:false,
        headerClick: function(e, column) {
            if (column.getTable().getSelectedRows().length !== column.getTable().getDataCount()) {
                document.querySelectorAll('.select-row,.select-all-row').forEach(function (cb) {
                return cb.checked = true;
            });
          column.getTable().selectRow("visible");
          $(".tabulator-headers .repcheck").addClass('repselected');
           $("#delete-tabulator-rows").css('display', 'block');
        } else {
            document.querySelectorAll('.select-row,.select-all-row').forEach(function (cb) {
              $("#delete-tabulator-rows").css('display', 'none');               
              return cb.checked = false;
            });
          column.getTable().deselectRow();
          $(".tabulator-headers .repcheck").removeClass('repselected');

        }
    column.getCells().forEach(function (cell) {
      return cell.getData().IsSelected = !cell.getData().IsSelected;
    });      
    }
    },
        {title:"Chr", field:"chromosome", 
            editor:"select", editorParams:{ 
            values: 
            {"1":1,
            "2":2,
            "3":3,
            "4":4,
            "5":5,
            "6":6,
            "7":7,
            "8":8,
            "9":9,
            "10":10,
            "11":11,
            "12":12,
            "13":13,
            "14":14,
            "15":15,
            "16":16,
            "17":17,
            "18":18,
            "19":19,
            "20":20,
            "21":21,
            "22":22,
            "X":"X"
            }
        }
        , cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }, sorter: function(a, b, aRow, bRow, column, dir, sorterParams){
            //a, b - the two values being compared
            //aRow, bRow - the row components for the values being compared (useful if you need to access additional fields in the row data for the sort)
            //column - the column component for the column being sorted
            //dir - the direction of the sort ("asc" or "desc")
            //sorterParams - sorterParams object from column definition array
            if(a=='X'){
                a = 23;
            }
            if(b=='X'){
                b = 23;
            }
            return a - b; //you must return the difference between the two values
}


        , visible: true, width:60},
        {title:"Start", field:"start", editor:"input", 
        mutatorEdit: editedNumberMutator,
       validator:[{ type: startValidator}], formatter:function(cell, formatterParams, onRendered){return numberWithCommas(parseInt(cell.getValue()))},cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }},
        {title:"End", field:"end", editor:"input",
        mutatorEdit: editedNumberMutator, validator:[{ type:endValidator}], formatter:function(cell, formatterParams, onRendered){return numberWithCommas(parseInt(cell.getValue()))},cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }},
        {title:"cM", field:"cM", mutatorEdit: editedNumberMutator, validator:[{ type: cMValidator}], sorter:"number", editor:"input", formatter:function(cell, formatterParams, onRendered){return numberWithCommas(cell.getValue())},cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }},
        {title:"SNPs", field:"SNPs", mutatorEdit: editedNumberMutator, validator:[{ type: snpValidator}], sorter:"number", editor:"input", formatter:function(cell, formatterParams, onRendered){return numberWithCommas(cell.getValue())},cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }},
        {title:"Match", field:"match", 
        width: 200, editor:"select", cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }, editorParams: 
           { values: getMatchKeyValues() }    
        ,
        formatter:function(cell, formatterParams, onRendered){
            var thiscell = cell.getValue();
            var thismatchname = getMatchById(thiscell, 'name');
            if(typeof(thismatchname)!=='undefined'){
            //console.log(chromogroups[thiscell].name);
            return thismatchname;
            }
        return 'Unknown';
        }}, 




        {title:"Confidence", field:"certainty", width: 120, cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
        }, editor:"select", editorParams:{ 
                values: 
                {"1":certaintyToText(1),
                "2":certaintyToText(2),
                "3":certaintyToText(3),
                "4":certaintyToText(4)}
            },
            formatter:function(cell, formatterParams, onRendered){return certaintyToText(cell.getValue())
    }}, 
        {title:"Group", field:"group", 
        width: 200, editor:"select", cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    }, editorParams: 
           { values: getGroupKeyValues() }    
        ,
        formatter:function(cell, formatterParams, onRendered){
            var thiscell = cell.getValue();
            if(typeof(chromogroups[thiscell])!=='undefined'){
            //console.log(chromogroups[thiscell].name);
            return chromogroups[thiscell].name;
            }
        return 'Unknown';
        }}, 
    {title:"Side", field:"group", visible: false, formatter:function(cell, formatterParams, onRendered){
            var thiscell = cell.getValue();
            if(typeof(chromogroups[thiscell])!=='undefined'){
            //console.log(chromogroups[thiscell].name);
            if(chromogroups[thiscell].side=='mat'){
                return 'Maternal';
            }
           if(chromogroups[thiscell].side=='pat'){
                return 'Paternal';
            }            
            return 'Unknown or shared';
            }
        return 'Unknown or shared';
        }},        
        /*{title:"Side", field:"group", mutator:sideMutator}, // need mutator*/
        {title:"Notes",cellClick:function(e, cell){
        e.stopPropagation(); //prevent click event from reaching the row.
    },  field:"notes", formatter:"textarea", editor:true}
       
    ],
    });
    $("#filterdatanew").val('');
    $("#newreport").show();
    table.setData(chromomapper);
   
    $("#loadme").hide();
    

    $("#filterdatanew").on("keyup", function(e){
       
         table.setFilter(matchAny, { value: $("#filterdatanew").val() });
            if ($("#filterdatanew").val() == " "){
               table.clearFilter();   
            }    
    });

    $(".cancel-filternew").on("click", function(e){
        $("#filterdatanew").val('');
        table.clearFilter();   
    });   

    $("#delete-tabulator-rows").on("click", function(e){
        // bring up a confirmation
        $("#tsdno").text(table.getSelectedRows().length);
         if(table.getSelectedRows().length !=1){
            $("#tsdnos").text('s');
        }
        else {
            $("#tsdnos").text('');
        }
        $("#delete-tabulator-rows-confirm").css('display','block');
        // then delete
       // console.log(table.getSelectedRows());
    });
    $("#delete-tabulator-rows-confirm button.btn").on('click', function(){
        var selectedRows = table.getSelectedRows();
        for(var i in selectedRows){
            table.deleteRow(selectedRows[i]);
            var thisdata = selectedRows[i].getData();
            markAsDeleted(thisdata.id);
        }

        // remove all with deleted
            chromomapper = chromomapper.reduce(function (p, c) {
              return typeof(c.deleted) =='undefined' && p.push(c), p;
            }, []);


        // this should then remove
        printMatches('all');
        writeDataToMap('matches'); 
        initialiseSearch();
        // works well it seems. not super efficient but feels safe

        $("#delete-tabulator-rows-confirm, #delete-tabulator-rows").css('display','none');
    });
    function toggleRowSelection(){
            console.log('hi');
            var rows = $("#reportnew").tabulator("getRows");
            rows.forEach(function(row){
                row.toggleSelect();
            });
    }

}

function markAsDeleted(id){
    // look up in chromomapper
    var thisitem = chromomapper.filter(function(chromomapper){ return chromomapper.id == id; });
    if(thisitem.length && thisitem.length==1){
       thisitem[0].deleted = 1;
    }
}


function printAllSegmentData() {
    // open a modal or whatever
    // 
    //var t0 = performance.now();
    $('body').addClass('form-toggled');
    if ($("#mapName").text() != '') {
        var reportname = $("#mapName").text();
    }
    //console.log($(".rhead"));
    //$(".rhead").stickybits();;
    $("#filterdata").val('');
    $("#filtercount").text('');
    $("#report > tbody").remove();
    $("#report").append('<tbody></tbody>');
    $("#report").trigger('update');
    var reportcontent = [];
    for (var i in chromomapper) {
        var thismatch;
        if (typeof(chromomapper[i].match) === 'undefined' || chromomapper[i].match == '') {
            thismatch = 'Not specified';
        } else {
            thismatch = getMatchById(chromomapper[i].match, 'name');
            //thismatch = chromomapper[i].match.replace(/\t/g,' ');
        }
        if (chromomapper[i].SNPs == 'NaN') {
            chromomapper[i].SNPs = '';
        }
        var thisgroup = '';
        var thisgroupside = '';
        var fixsegmentlink = '';
        var nogroup = '';
        var groupcolor = '';
        var ancestorgroup = 0;
        var groupnotes = '';
        if(typeof(chromogroups[chromomapper[i].group]) !=='undefined'){
            thisgroup = chromogroups[chromomapper[i].group].name;
            thisgroupside = formatSide(chromogroups[chromomapper[i].group].side);
            groupcolor = chromogroups[chromomapper[i].group].color;
            groupnotes = chromogroups[chromomapper[i].group].notes;
            if(typeof(chromogroups[chromomapper[i].group].ancestor)!=='undefined' && chromogroups[chromomapper[i].group].ancestor==1){
                ancestorgroup = 1;
            }
        }
        else {
            thisgroup = '';
            fixsegmentlink = '<a class="fix-seg" href="#" data-seg="'+i+'">Fix segment</a>';
            nogroup ='none';
        }
        var showsnps = '';
        if(typeof(chromomapper[i].SNPs)!=='undefined'){
            showsnps = chromomapper[i].SNPs;
        }
        var showcms= '';
        if(typeof(chromomapper[i].cM)!=='undefined'){
            showcms = chromomapper[i].cM;
        }        

            // don't allow a broken group to cause an error
       reportcontent[i] += '<tr><td class="chkcol"><input type="checkbox" name="sdel" value="'+chromomapper[i].id+'" /></td><td valign="top"><small>chr</small>' + chromomapper[i].chromosome + '</td><td valign="top" align="right">' + numberWithCommas(chromomapper[i].start) + '</td><td valign="top" align="right">' + numberWithCommas(chromomapper[i].end) + '</td><td valign="top" align="right">' + showcms + '</td><td valign="top" align="right">' + showsnps + '</td><td valign="top" class="matchname'+nogroup+'" data-group="'+chromomapper[i].group+'" data-matchslug="'+thismatch+'">' + $.sanitize(thismatch) + '</td><td valign="top" class="wrap">' + certaintyToText(chromomapper[i].certainty) + '</td><td valign="top">' + $.sanitize(thisgroup) + fixsegmentlink+'</td><td valign="top">' + thisgroupside + '</td><td valign="top" class="wrap notesfield">' + nl2br(addLinks($.sanitize(chromomapper[i].notes)),true) + '</td><td class="hidden">'+groupcolor+'</td><td class="hidden">'+ancestorgroup+'</td><td class="hidden">'+groupnotes+'</td></tr>';
          
    }
    $("#datareport table tbody").append(reportcontent.join(''));
    $("#datareport h2").text(reportname);
    var sorting = [
        [1, 0],
        [2, 0]
    ];
    $("#report").trigger('update', [sorting]);
    $("#report").tablesorter({
        sortList: [
            [1, 0],
            [2, 0]
        ]
    });
    $("#datareport").show();
    $("#loadme").hide();
    //var t1 = performance.now();
    //console.log("Print report took " + (t1 - t0) + " milliseconds.")

    // for each chromomapper, output a row of data
    // chromosome / match / start / end / cm / SNPs group / confidence level / notes
}

function getIndexFromId(id){
    //var thisitem = chromomapper.filter(function(chromomapper){ return chromomapper.id == id; });
    //return chromomapper.
    return chromomapper.findIndex(function(seg){ return seg.id==id});

}
function togglechr_keyUp(e) {

    // this would test for whichever key is 40 and the ctrl key at the same time
    if (e.altKey && e.keyCode == 88) {
        // call your function to do the thing
        $("#chrtog").trigger('click');
    }
}
// register the handler 
document.addEventListener('keyup', togglechr_keyUp, false);

function formatSide(side){
    if(side=='pat'){
        return 'Paternal'
    }
    else if(side=='mat'){
        return 'Maternal'
    }
    else if(side=='both'){
        return 'Unknown or shared'
    }      
}
function getMatchSegments(match, group, context){
    // get index values for all chromomapper segments with a group that matches group and a match that matches match
    // do I have to get the whole thing?  Yes if I want index numbers.  Great!

    /* TODO
        This is actually kind of slow when you do it on a big map.
        Might I not be able to retrieve this list by getting $("strong[data-match='+match"), iterating through this array and getting the data-ids? 
    */
    var mymatchsegments = $(context +" .cp strong[data-match='"+match+"']");
    var matchsegments = [];    
    // these are the segments for this match 
    $(mymatchsegments).each(function(index){
        var thisseg = $(this).attr('data-id');
        thisseg = thisseg.replace('match','');
        matchsegments.push(thisseg);
    });

   
    return matchsegments;
}

function isTouchDevice(){
    if($('body').hasClass('user-is-touching') || $(window).width()<481){
        return true;
    }
    return false;

}
function resetPoppedItem(item) {
    $('strong.match').removeClass('cutoff');

    $('strong.match').removeClass('cutoff-right');

}

function setActiveLabel(item) {
    $(".boxgroup label").removeClass('active');
    $(item).parent().addClass('active');
}

function closeOverlays() {
    //$("#chr").removeClass('searching');
    clearSearch();
    $(".floater, .dpform").removeClass('active').hide();
    $("body").removeClass('form-toggled');
    $("#membox, #match-confirm, #import-confirm").css('display', 'none');
}

function removeCentromeres(centromere, context){
    //console.log($("em.centromere").length);
    if(typeof(centromere)==='undefined'){
        $("em.centromere").remove();
    }
    else {
          if (typeof(context) === 'undefined' || !context ) {
                var context = '';
            }
            else {
                context = context + ' ';
            }

        $(context + "#p"+centromere.chr +" em.centromere").remove();
    }
}

function getGroupsOfType(type){
    if(typeof(examplemap)!=='undefined'){
        chromogroups = examplechromogroups;
    }
    //console.log(chromogroups);
    var groupsforsort = JSON.parse(JSON.stringify(chromogroups));
    //console.log(groupsforsort);
        for (var i in groupsforsort) {
            groupsforsort[i].arrayPosition = i;
        }
    if(type=='ethnicity'){
        return groupsforsort.filter(function(groupsforsort){
            return ( typeof(groupsforsort.spec)!=='undefined' && groupsforsort.spec=='eth');
        }); 
    }

    return groupsforsort.filter(function(groupsforsort){
        return ( (typeof(groupsforsort.ancestor)==='undefined' || groupsforsort.ancestor==0) && (typeof(groupsforsort.spec)==='undefined' || groupsforsort.spec!='eth'));
    });  
}


function hideGroups(type, keyonly){
    var unkgroups = getGroupsOfType(type);
    if(type=='unknown'){
        $(".hunknown").remove();
    }
    if(type=='ethnicity'){
        $(".hethnicity").remove();
    }    
    setTimeout(function(){
        for (var i in unkgroups) {
            //console.log($("li#group"+unkgroups[i].arrayPosition));
            if(typeof(keyonly)==='undefined' || keyonly ===false){
                $("#chr div.g"+unkgroups[i].arrayPosition).css('display', 'none');
            }
            $("li#group"+unkgroups[i].arrayPosition).css('display','none');
        }
    }, 100);
    if(unkgroups.length >0){
        appendToKey(type, unkgroups.length);
    }
    // long term it might be nice to actually remove them from the page but for now, just hide them
    // so either add a 'unk' class to segments OR get the unknown groups and hide them
    // try the latter first

}
function appendToKey(type, number){
    var showtype = type;
    if(showtype=='ethnicity'){
        showtype= 'anc. composition'
    }
    $("#chrkey").append("<li class='h"+type+"'><span class='fa fa-eye'></span><button>Show "+number+" "+showtype+" group<span class='hsp'>s</span></button></li>");
    if(number==1){
        $(".h"+type+" .hsp").css('display','none');
    }
    else {
        $(".h"+type+" .hsp").css('display','inline');
    }
}


function showGroups(type){
    var unkgroups = getGroupsOfType(type);

    setTimeout(function(){
        for (var i in unkgroups) {
           // console.log($(".g"+unkgroups[i].arrayPosition));
            $("div.g"+unkgroups[i].arrayPosition).css('display', 'block');
            $("li#group"+unkgroups[i].arrayPosition).css('display','block');
        }
    }, 100);
}


function loadCentromeres(chrom, context) {
    var centromerestoprint = JSON.parse(JSON.stringify(centromeres));
    for (var i in centromerestoprint) {
            centromerestoprint[i].arrayPosition = i;
    }

    if (typeof(chrom) !== "undefined" && ($.isNumeric(chrom)|| chrom=='X')){
       
        centromerestoprint = centromerestoprint.filter(function(centromerestoprint) {
            return centromerestoprint.chr == chrom
        });
        //console.log(centromerestoprint);
    }
   
    if (centromerestoprint.length > 0) {
        for (var i in centromerestoprint) {
            //console.log(context);
            // TODO possibly remove here 
            removeCentromeres(centromerestoprint[i], context);
            printCentromere(centromerestoprint[i], context);           
        }
    }
    if(centromerestoprint.length==0){
        return false;
    }
   
    return centromerestoprint;
}

function loadFixedSegments(chrom, context) {

    // if chrom is defined, do as I do now
    // otherwise, loop through them all and output them
    if(typeof(context)==='undefined'){
        context = 'chr';
    }
    //console.log(chrom);
    var segstoprint = JSON.parse(JSON.stringify(fixedsegments));
    //var tempsegstoprint = JSON.parse(JSON.stringify(fixedsegments));
    for (var i in segstoprint) {
            segstoprint[i].arrayPosition = i;
    }
    context = context + ' #p';
    if(context =='chr-detail #p'){
        context +='d';
    }    
    if (typeof(chrom) !== "undefined" && ($.isNumeric(chrom)|| chrom=='X')){
       //console.log(chrom);
       // console.log(context);
      
        segstoprint = segstoprint.filter(function(segstoprint) {
            return segstoprint.chromosome == chrom
        });
        var chromfixedmatches = '';
        if (segstoprint.length > 0) {
            for (var i in segstoprint) {
                chromfixedmatches += printFixedMatch(segstoprint[i].arrayPosition, context, true);                
            }
            // assuming both for simplicity
            chromfixedmatches = '<div class="fixed">'+chromfixedmatches+'</div>'
            $('#'+context+ chrom + " div.both").append(chromfixedmatches);
         }
        //console.log(segstoprint);
    }
    else {
        var c = 1;
        while(c < 23){
            loadFixedSegments(c, 'chr');
            c++;
        }
    }


 
    if(segstoprint.length==0){
        return false;
    }
   
    return segstoprint;
    
}

function filterGroup(data) {
  var jo = $("#chr-groupdetail-key").find("li");
  var jsegs = $("#groupdetail .cp > div > div");

    if (data == "") {
        jo.show();
        return;
    }
    //hide all the key entries
    jo.hide();
    // and the segments
    jsegs.hide();

    jo.filter(function (i, v) {
        var $t = $(this);
        var stringsFromRowNodes = $t.children("a").text().toLowerCase();
        var searchText = data.toLowerCase();
        if (stringsFromRowNodes.indexOf(searchText)>-1) {
            return true;
        }
    return false;
    }).show();


    jsegs.filter(function (i, v) {
        var $t = $(this);        
        //var stringsFromRowNodes = $t.children("em.mn").text().toLowerCase();
        var stringsFromRowNodes = $(this).find("em.mna").text().toLowerCase();
        var searchText = data.toLowerCase();
        if (stringsFromRowNodes.indexOf(searchText)>-1) {
            return true;
        }
    return false;
    }).show();

//show the rows that match.
    
}

function filterMaps(data) {
  var jo = $(".maps-list").find("li");

    if (this.value == "") {
        jo.show();
        return;
    }
    //hide all the key entries
    jo.hide();
    // and the segments

    jo.filter(function (i, v) {
        var $t = $(this);
        var stringsFromRowNodes = $t.children("a").text().toLowerCase();
        var searchText = data.toLowerCase();
        if (stringsFromRowNodes.indexOf(searchText)>-1) {
            return true;
        }
    return false;
    }).show();


  

//show the rows that match.
    
}

function stripQuotes(string){
    if($.isArray(string)){
        return jQuery.map( string, function( n, i ) {
            return n.replace(/"/g, '');
        });
    }
    if(typeof(string)!=='undefined'){
        return string.replace(/"/g, '');
    }
    return false;

}

function filterKey(data){
    var jo = $("#chrkey").find("li");
    if (data == "") {
        jo.show();
        return;
    }

 //hide all the rows
    jo.hide();
    if(typeof(showcase)!=='undefined'){
        if(data.indexOf('seg')!=-1){
            data = ' '+data;
        }       
    }    

    var filtered = jo.filter(function (i, v) {
        var $t = $(this);
        var stringsFromRowNodes = $t.text().toLowerCase();
        var searchText = data.toLowerCase();
        if (stringsFromRowNodes.indexOf(searchText)>-1) {
        // if in showcase and the search string has the a number and a 'C', then if it isn't right at the end, return false!
            if(typeof(showcase)!=='undefined'){
                if(searchText[searchText.length-1]=='c' && (stringsFromRowNodes[stringsFromRowNodes.length-1]!='c' || (searchText.indexOf('half')==-1 && stringsFromRowNodes.indexOf('half')!==-1))){
                    return false;
                }   
                if(searchText[searchText.length-1]=='r' && (searchText.indexOf('half')==-1 && stringsFromRowNodes.indexOf('half')!==-1)){
                    return false;
                }
                if(stringsFromRowNodes.substring(stringsFromRowNodes.length-3)=='n/n' && 
                    ( 
                        (searchText.indexOf('half')==-1 && stringsFromRowNodes.indexOf('half')!==-1) 
                        || 
                        (searchText.indexOf('great')==-1 && stringsFromRowNodes.indexOf('great')!==-1)
                    )){
                    return false;
                }
                if(stringsFromRowNodes.substring(stringsFromRowNodes.length-2)=='gc' && 
                    (                        
                        (searchText.indexOf('great')==-1 && stringsFromRowNodes.indexOf('great')!==-1)
                    )){
                    return false;
                }    
                // N/N if that's the last bit of text - omit great and half
                // GC - omit great
            }   
            return true;
        }
    return false;
    });

    filtered.show();
        
}


function filterMatchList(thisname, segs, total) {
    var jo = $("#matchlistpeople tr");
    if (this.value == "") {
        jo.show();
        return;
    } 
  //hide all the rows
    jo.hide();
    //console.log(jo);
    // first filter by name
    if(thisname!==false){
        var filtered = jo.filter(function (i, v) {
            var $t = $(this).text().toLowerCase();
            //console.log($t);
            var searchText = thisname.toLowerCase();
            if ($t.indexOf(searchText)>-1) {
                return true;
            }
            return false;
        }); 
    }
    else {
        var filtered = jo;
    }

    if(segs !==false && $.isNumeric(segs)){
        filtered = filtered.filter(function (i, v) {
            var $t = $(this).find(".mlsegs").text();
           // console.log($t);
            if(parseInt($t) >= parseInt(segs)){
                return true;                
            }
            return false;          
        }); 
    }

    if(total !==false && $.isNumeric(total)){
        filtered = filtered.filter(function (i, v) {
            var $t = $(this).find(".mltotal").text();
           // console.log($t);
            if(parseFloat($t) >= parseFloat(total)){
                return true;                
            }
            return false;          
        }); 
    }
    filtered.show();
   
  
}


function filterDataTable(data, targettable) {
    var parenttable = '';
    if(typeof(targettable)!=='undefined'){
        parenttable = "#"+targettable;
    }
    var jo = $(parenttable+".tablesorter").find("tr");
    if (this.value == "") {
        jo.show();
        return;
    }
    //hide all the rows
    jo.hide();
    $(parenttable+" .tablesorter-headerRow").show();


    var filtered = jo.filter(function (i, v) {
        var $t = $(this);
        var stringsFromRowNodes = $t.children("td:nth-child(n)").text().toLowerCase();
        var searchText = data.toLowerCase();
        if (stringsFromRowNodes.indexOf(searchText)>-1) {
            return true;
        }
    return false;
    });

    filtered.show();
    if(parenttable==''){
        // show count if in all segment data
        if(data==''){
            var filtercounttext = filtered.length-1+' segment';
        }
        else {
            var filtercounttext = filtered.length+' segment';
        }
        if(filtered.length==0||filtered.length>1){
            filtercounttext +='s';
        }
        // TODO - if searchText is empty, just return total rows.

        $("#filtercount").text(filtercounttext);
    }

}

function getEOL(){
    var textarea = document.createElement("textarea");
    textarea.value = "\n";
    return textarea.value.replace(/\r\n/, "\r");
}
  function recordEventClick(category, action) {
      // console.log(category + action);
       ga('send', 'event', category, action);
       /*try{
          var pageTracker = _gat._getTracker('UA-85745481-1');
          pageTracker._trackEvent(category, action);
       } catch (err) {
        }*/
    }

function resetModals(){
    if($("#groupdetail").hasClass('active')){
        reinitialiseModal('group'); 
        $("#groupdetail").removeClass('active');
    }
    else if($("#matchdetail").hasClass('active')){
        reinitialiseModal('match');
        $("#matchdetail").removeClass('active');
        var mylists = $("#chr-detail-key").find('ul');
        if(mylists.length>0){
            mylists[0].remove();
        }
    }
    else if($("#chromodetail").hasClass('active')){
        reinitialiseModal('chr');                
        $("#chromodetail").removeClass('active');
    }
    else if($("#datareport").css('display')=='block'){
        // leave for now
         reinitialiseModal('report');                       
    }
    else if($("#matchlist").css('display')=='block'){
        // leave for now
         reinitialiseModal('matchlist');                       
    }

}

function reinitialiseModal(modal){
    if(modal=='group'){
        $("#chr-groupdetail-key .indmatch").remove();
        $('.groupdetailcontainer .chrdetailchromosome').remove();
    }
    else if(modal=='match'){
        $('.matchdetailcontainer .chrdetailchromosome').remove();       
    }
    else if(modal=='chr'){
        $("#chr-detail .cp > div").empty();

    }
    else if(modal=='report'){
        $("#datareport table tbody").empty();

    }    
    else if(modal=='matchlist'){
        $("#matchlistpeople").empty();

    }      
    else {
        $('.groupdetailcontainer .chrdetailchromosome').remove();
        $('.matchdetailcontainer .chrdetailchromosome').remove();
        $("#chr-detail .cp > div").empty();

    }
}

function sortSegments(){
    // take the chromomapper array and sort it by chromosome. then sort it by 'start' (could also sort by side in the middle but this might not be needed)
  //  var segsforsort = JSON.parse(JSON.stringify(chromomapper));
    
   
    chromomapper.sort(byChromosomeAndStart);
    //writeDataToMap('matches');
    // commenting out saving for now as this will be done when anything is changed anyway.
//    segsforsort.sort(bystart);

    //segsforsort = segsforsort.sort(function(a, b) {
    //    return parseInt(a.start, 10) < parseInt(b.start, 10);
    //});
}

function byChromosomeAndStart(a,b){
    var chrA = '';
    var chrB = '';
    var startA = parseInt(a.start);
    var startB = parseInt(b.start);
  if(a.chromosome=='X'){
    chrA = 23;
  }
  else {
    chrA = parseInt(a.chromosome);
  }
  if(b.chromosome=='X'){
    chrB = 23;
  }
  else {
    chrB = parseInt(b.chromosome);
  } 


  var comparison = 0;

  if(chrA ==chrB){
    if (startA > startB) {
        comparison = 1;
    } else if (startA <= startB) {
        comparison = -1;
    }
  }  
  else {
     if (chrA > chrB) {
        comparison = 1;
    } else if (chrA < chrB) {
        comparison = -1;
    }
    }

  return comparison;
}

function clearSearch(){
    // take class searching off 
    $("#chr").removeClass('searching');
    // take hilite and hilitefirst off
    $(".cp strong").removeClass('hilite firsthilite');
    $(".matchtrack").remove();
    // clear search field
    $("#searchentry").val('');
}

function resetFormElement(e) {
   // console.log(e);
     e.wrap('<form>').closest('form').get(0).reset();
    e.unwrap();

  // Prevent form submission
 // e.preventDefault();
}

function loadLocalSettings(keyonly){
    if(typeof(keyonly)==='undefined'){
        keyonly = false;
    }
    if((navigator.userAgent).indexOf('Firefox')!==-1 || chromomapper.length <=2000){
        $("#cfholder").css('display','none');
    }

    // check 'gshownames' and any other local vars and update
    var lsettings = ['gshownames', 'gshowmblines', 'gshowcm', 'showcentromeres', 'hideunknown','hideethnicity', 'showmatchaftersave', 'showkl', 'showcmslider', 'showtm', 'enablecf'];
     for (var i in lsettings){
        var value = false;
        if(getFieldValue(lsettings[i])=='true'){
            $("#"+lsettings[i]).prop('checked',true);            
        }
        //$("#"+lsettings[i]).prop('checked',getFieldValue(lsettings[i]));
//        console.log($("#"+lsettings[i]));
        // get value of dp id cached name
        // set $(name) to the value
    }

      if(!getFieldValue('enablecf') && chromomapper.length > 2000){
           // console.log('i am going to enable it');
            $("#enablecf").prop('checked',true);   
        }
        if($("#showcentromeres").prop('checked')){
            setTimeout(function(){
                loadCentromeres();
            },200);
        }
        if($("#hideunknown").prop('checked')){
            hideGroups('unknown', keyonly);
            calculatePaintedPercentage();
        }   
        if($("#hideethnicity").prop('checked')){
            hideGroups('ethnicity', keyonly);
        } 
        if($("#showkl").prop('checked')){
            $("#maincontent").removeClass('showkl').addClass('showkl');
            setTimeout(function(){
                showKeylines();
            },100);              
        }

        if($("#showcmslider").prop('checked')){

            var cmsliderboundL = getFieldValue('cmsliderboundL');
            var cmsliderboundH = getFieldValue('cmsliderboundH');
            if(cmsliderboundL && !isNaN(cmsliderboundL)){
                $("#cmsliderLowerBound").val(cmsliderboundL);
            }
            if(cmsliderboundH && !isNaN(cmsliderboundH)){
                $("#cmsliderUpperBound").val(cmsliderboundH);
            }            
            $("#cmDisplayThreshold").attr('min',$("#cmsliderLowerBound").val());
            $("#cmDisplayThreshold").attr('max',$("#cmsliderUpperBound").val());
           

            if(parseInt($("#cmDisplayThreshold").val()) > parseInt($("#cmsliderUpperBound").val())
                || parseInt($("#cmDisplayThreshold").val()) < parseInt($("#cmsliderLowerBound").val())
                ){
                console.log($("#cmDisplayThreshold").val()+' is greater than '+$("#cmsliderUpperBound").val() +' OR '+$("#cmDisplayThreshold").val()+' is less than '+$("#cmsliderLowerBound").val());
                $("#cmDisplayThreshold").val($("#cmsliderLowerBound").val());
            }
            $("#cmDisplayAmount").text($("#cmDisplayThreshold").val()+'cM');

            setTimeout(function(){
                  // setUpSlider();
                   showSlider();
                  //console.log('setting to '+$("#cmDisplayThreshold").val()+'cM')
            },100);             
        }

        if($("#gshowcm").prop('checked')){
            //setTimeout(function(){printMatches('all');},100);
            //printMatches('all');

            $("#maincontent").removeClass('showmatchcm').addClass('showmatchcm');
        }

        if($("#gshowmblines").prop('checked')){           
            $("#maincontent").removeClass('gshowmblines').addClass('gshowmblines');
        }

        if($("#showtm").prop('checked')){
            $("#maincontent").removeClass('showtm').addClass('showtm');
            showTraits();
        } 
         if($("#enablecf").prop('checked')){
            enableControlF();
        }
        if(chromomapper.length <=2000){
            $("#maincontent").addClass('enablecf');
        }           
               
}

//hunknown

function printAllMatchesByChromosome(){
    var c = 1;
    while(c < 23){
        clearChromosome(c);        
        loadFixedSegments(c);
        printChromosomeMatches(c);
            c++;
        }
    clearChromosome('X');         
    printChromosomeMatches('X');
    loadLocalSettings();   
}



function getOrCreateGroup(pushto, name, side, color, type, now, filename, lastmodified, spec, toporbottom, ancestor, chrlist, groupnotes){
  var groupsforkey = JSON.parse(JSON.stringify(pushto));
    for (var i in groupsforkey) {
        groupsforkey[i].arrayPosition = i;
    }
    if(name==''){
        name = 'Untitled Group';
    }
    if(color==null || color==''){
        //color = randomColor();
        color = getNewColor();
    }
    if(typeof(spec) ==='undefined'){
        spec = '';
    }
    if(typeof(groupnotes) ==='undefined'){
        groupnotes = '';
    }    
    if(typeof(toporbottom)==='undefined'){
        toporbottom = 'end';
    }
    if(typeof(ancestor) ==='undefined'){
        ancestor = 0;
    }    

    var groupexists = groupsforkey.filter(function(groupsforkey){ return groupsforkey.name == name });  
    if(!groupexists || groupexists.length == 0){
        var printsource = type;
        if(type=='custom'){
            printsource = 'a custom CSV file';
        }
        groupnotes = groupnotes + '\n\nSegments imported from '+printsource+'\n';
         
        if($("#thresholdimport").length >0){
            groupnotes +='Segments under '+$("#thresholdimport").val()+'cM excluded\n';
            groupnotes +='Matches over '+$("#upperthresholdimport").val()+'cM excluded\n';
            groupnotes +='Matches under '+$("#lowerthresholdimport").val()+'cM excluded\n';
            if($("#includelowerno").prop('checked') && $("#thresholdimport").val() >7){
                groupnotes +='Total for small matches uses segments over '+$("#thresholdimport").val()+'cM only\n';
            }
            else if($("#includeloweryes").prop('checked') && $("#thresholdimport").val() >7){
                var lt = 7;
                if($.isNumeric($("#lowerthresmatch").val())){
                    lt = $("#lowerthresmatch").val();
                }
                groupnotes +='Total for small matches uses segments under '+$("#thresholdimport").val()+'cM but over '+lt+'cM\n';
            }            
        }
        if(typeof(chrlist) !=='undefined' && chrlist!='' && chrlist!='all'){
            groupnotes += 'Import limited to chromosomes: '+chrlist;
        }        
        if(typeof(now)!=='undefined' && now !=''){
            groupnotes += '\nImport time: '+now+'.\n';
        }
        if(typeof(filename)!=='undefined' && filename !=''){
            groupnotes +='File: '+filename+'\n';   
        }
        if(typeof(lastmodified)!=='undefined' && lastmodified !=''){
            groupnotes +='File last modified: '+lastmodified+'.';   
        }
       

        
        var newgroupindex = addNewGroup(pushto, name, side, color, groupnotes,ancestor,toporbottom, spec);
        newgroupindex = parseInt(newgroupindex);
       // console.log('created new group '+newgroupindex+'('+name+')');

    }
    else {
        // use the first group with a matching name
        newgroupindex = groupexists[0].arrayPosition;
        //console.log('used existing group '+newgroupindex+'('+groupexists[0].name+')');
    }
    return newgroupindex;
}

function doSearch(){
      var term = $("#sterm").val();
      window.location = 'https://duckduckgo.com/?q=site%3Adnapainter.com+'+encodeURIComponent(term);
}

 function isIE() {
    // IE 10 and IE 11
    return /Trident\/|MSIE/.test(window.navigator.userAgent);
    }

function showHideMemButtons(){
    // if a chromosome is open, show keylower .openmem
    // otherwise show #update-info
    if($("#chr .cp-open").length >0 && !inMassEditMode() && $(window).width() > 480){
        $("#keylower .openmem").css('display','block');
        $("#update-info").css('display','none');
    }
    else {
        $("#keylower .openmem").css('display','none');
        $("#update-info").css('display','block');
    }
}

function checkLoggedIn(){
    var data = {};
    data[site.csrf.keys.name] = site.csrf.name;
    data[site.csrf.keys.value] = site.csrf.value;
    $.ajax({
            type: "GET",
            url: "/api/cl",
            data: data,
            success: function(result) {
                //console.log(result);
                //console.log('success');
                return true;
                // no problem carry on
            },
            error: function(exception) {
                //console.log('failed');
                // not logged in, print message.
                return false;
                //console.log('exception'+JSON.stringify(exception));
            }
        });
    
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}


function getIdForMatch(match, forcenew){
 var thisid = false;
 for(var m in dp.map.matches){
    if(dp.map.matches[m].name ==match){
      console.log(dp.map.matches[m].name+' is equal to '+match+' so returning this id');
      thisid = dp.map.matches[m].id;
    }
  }
 if(!thisid || forcenew){ // doesn't matter if blank still need an ID
    // otherwise, insert it into matches
    thisid = get_match_id(false);   
    var myentry = {};
    myentry.id = thisid;
    myentry.name = match;
     
    if(typeof(dp.map.matches)=='undefined'){
      dp.map.matches = [];
    }
    dp.map.matches.push(myentry);   
  }
  return thisid;

}

function get_id(chars){
  if(typeof(chars)==='undefined'){
    chars = 9;
  }
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, chars);
}


function get_match_id(company){
    if(!company){
        var company = 'nk';
    }
    return company+get_id();
}

function setupMatchIds(){
    for(var i in chromomapper){
        thisid = getIdForMatch(chromomapper[i].match);
        chromomapper[i].match = thisid;
    }
}


function getMatchById(id, field){
 for(var m in dp.map.matches){
    if(dp.map.matches[m].id ==id){
      if(typeof(field)!=='undefined'){
        if(typeof(dp.map.matches[m][field])!=='undefined'){
            return dp.map.matches[m][field];
        }
      }
      return dp.map.matches[m];
    }
 }
 return false;
}

/*
usage:

  var childid = getChildId(entry.id);
          var child = findById(data,childid);      
          var index = findIndexOfItemWithAttr(child, 'id', entry.id);         

*/
        

function findIndexOfItemWithAttr(matches, attr, value) {
    // filter object
      var filterlist = JSON.parse(JSON.stringify(matches));
      for(var i in filterlist){
        filterlist[i].index = i;
      }
      //console.log(kids);
      filterlist = filterlist.filter(function(filterlist){ return filterlist[attr] == value });
      if(filterlist.length > 0){
        return filterlist[0].index;
      }
      return -1;
}